var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _g2, _g3, _g4, _g5, _path9, _path10, _g6, _g7, _g8, _path11, _path12, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _path13, _g17, _path14, _g18, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g19, _g20, _g21, _g22, _g23, _path23, _path24, _g24, _g25, _g26, _path25, _path26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _path27, _g35, _path28, _g36, _path29, _g37, _g38, _g39, _g40, _g41, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g42, _g43, _g44, _path44, _path45, _path46, _path47, _g45, _g46, _path48, _g47, _g48, _path49, _path50, _path51, _g49, _g50, _g51, _path52, _path53, _path54, _path55, _g52, _g53, _path56, _g54, _g55, _g56, _path57, _path58, _path59, _path60, _g57, _g58, _g59, _g60, _path61, _g61, _g62, _g63, _path62, _g64, _g65, _g66, _path63, _path64, _path65, _path66, _g67, _path67, _g68, _g69, _g70, _path68, _g71, _g72, _g73, _g74, _path69, _path70, _path71, _path72, _path73, _g75, _path74, _g76, _g77, _g78, _g79, _path75, _g80, _path76, _g81, _path77, _g82, _path78, _g83, _path79, _g84, _path80, _g85, _g86, _path81, _g87, _path82, _g88, _path83, _g89, _path84, _g90, _path85, _g91, _path86, _g92, _path87, _g93, _path88, _g94, _g95, _g96, _g97, _g98, _g99, _path89, _g100, _g101, _path90, _g102, _g103, _g104, _path91, _g105, _g106, _path92, _g107, _g108, _g109, _path93, _g110, _path94, _g111, _path95, _g112, _g113, _g114, _g115, _g116, _path96, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJuggler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_18516",
    "data-name": "Group 18516",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 336.729,
    height: 635.305,
    viewBox: "0 0 336.729 635.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_723",
    "data-name": "Rectangle 723",
    width: 336.729,
    height: 635.305,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_676",
    "data-name": "Rectangle 676",
    width: 336.729,
    height: 635.304,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_554",
    "data-name": "Rectangle 554",
    width: 7.926,
    height: 6.708,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_555",
    "data-name": "Rectangle 555",
    width: 1.762,
    height: 2.362,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_556",
    "data-name": "Rectangle 556",
    width: 1.976,
    height: 3.207,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_557",
    "data-name": "Rectangle 557",
    width: 3.52,
    height: 4.092,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_558",
    "data-name": "Rectangle 558",
    width: 2.508,
    height: 5.548,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559",
    "data-name": "Rectangle 559",
    width: 19.898,
    height: 26.755,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 17.687,
    height: 26.159,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_561",
    "data-name": "Rectangle 561",
    width: 6.726,
    height: 11.333,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    width: 6.542,
    height: 6.32,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 3.935,
    height: 2.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 2.15,
    height: 2.366,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 2.127,
    height: 2.202,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 1.976,
    height: 1.997,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 10.349,
    height: 9.579,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 17.191,
    height: 17.05,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_569",
    "data-name": "Rectangle 569",
    width: 2.752,
    height: 2.753,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_570",
    "data-name": "Rectangle 570",
    width: 2.094,
    height: 2.661,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 9.444,
    height: 5.8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    "data-name": "Rectangle 572",
    width: 8.457,
    height: 6.36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 2.081,
    height: 1.935,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 3.169,
    height: 2.046,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 3.026,
    height: 4.2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 4.902,
    height: 3.668,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 20.494,
    height: 26.421,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 19.223,
    height: 25.215,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_579",
    "data-name": "Rectangle 579",
    width: 8.217,
    height: 10.332,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_580",
    "data-name": "Rectangle 580",
    width: 4.944,
    height: 7.481,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_581",
    "data-name": "Rectangle 581",
    width: 2.971,
    height: 3.656,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_582",
    "data-name": "Rectangle 582",
    width: 2.051,
    height: 2.216,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_583",
    "data-name": "Rectangle 583",
    width: 1.624,
    height: 2.328,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_584",
    "data-name": "Rectangle 584",
    width: 1.366,
    height: 2.074,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585",
    "data-name": "Rectangle 585",
    width: 10.709,
    height: 8.695,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586",
    "data-name": "Rectangle 586",
    width: 13.685,
    height: 20.675,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_587",
    "data-name": "Rectangle 587",
    width: 2.752,
    height: 2.752,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_588",
    "data-name": "Rectangle 588",
    width: 2.385,
    height: 2.484,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_589",
    "data-name": "Rectangle 589",
    width: 8.045,
    height: 8.974,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_590",
    "data-name": "Rectangle 590",
    width: 13.105,
    height: 3.624,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_591",
    "data-name": "Rectangle 591",
    width: 12.966,
    height: 3.622,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_592",
    "data-name": "Rectangle 592",
    width: 14.91,
    height: 6.143,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_593",
    "data-name": "Rectangle 593",
    width: 13.397,
    height: 5.886,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_594",
    "data-name": "Rectangle 594",
    width: 29.79,
    height: 49.872,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595",
    "data-name": "Rectangle 595",
    width: 2.245,
    height: 2.925,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    width: 20.472,
    height: 28.707,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    width: 5.32,
    height: 6.936,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_598",
    "data-name": "Rectangle 598",
    width: 7.086,
    height: 4.022,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_599",
    "data-name": "Rectangle 599",
    width: 11.727,
    height: 7.148,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_600",
    "data-name": "Rectangle 600",
    width: 16.426,
    height: 10.2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    width: 270.549,
    height: 16.644,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_602",
    "data-name": "Rectangle 602",
    width: 35.777,
    height: 83.35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 39.163,
    height: 108.384,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_604",
    "data-name": "Rectangle 604",
    width: 25.146,
    height: 91.546,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_605",
    "data-name": "Rectangle 605",
    width: 62.069,
    height: 45.653,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_606",
    "data-name": "Rectangle 606",
    width: 60.121,
    height: 60.372,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607",
    "data-name": "Rectangle 607",
    width: 69.547,
    height: 137.626,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_608",
    "data-name": "Rectangle 608",
    width: 60.019,
    height: 118.149,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    width: 30.764,
    height: 45.953,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610",
    "data-name": "Rectangle 610",
    width: 52.626,
    height: 22.618,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_611",
    "data-name": "Rectangle 611",
    width: 100.928,
    height: 178.257,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_612",
    "data-name": "Rectangle 612",
    width: 76.638,
    height: 141.057,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613",
    "data-name": "Rectangle 613",
    width: 28.144,
    height: 26.543,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_614",
    "data-name": "Rectangle 614",
    width: 37.637,
    height: 30.465,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    width: 60.036,
    height: 9.652,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    width: 103.023,
    height: 178.257,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3152",
    "data-name": "Path 3152",
    d: "M614.319,1845.1c-.456,4.778-.917,7.651-.456,10.7s-.848,3.994-.2,6.714-1.769,4.041-2.383,12.2c-.622,4.8-2.153,2.881-2.928,4.8s-.495,5.857-.495,5.857a12.83,12.83,0,0,0-2.7,1.939c-.686.836,0,4.075,0,4.075s-5.141,9.514-13.453,32.546-17.234,55.824-20.926,67.18-4.77,16.216-6.458,20.5-1.385,7.17,1.539,9.886,16.309,2.238,20.461,0c3.073-2.085.353-3.68,3.406-7.358s24.135-35.666,33.513-50.858,22.2-49.1,26.335-61.1,10.367-8.411,14.89-23.816-.682-33.262-.682-33.262Z",
    transform: "translate(-563.292 -1845.104)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -0.914,
    cy: 1.756,
    r: 0.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d5bb78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#9d8a59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#6d603d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#463d27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#272216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#110f09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886,
    stopColor: "#040302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 26.64,
    height: 141.077,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_619",
    "data-name": "Rectangle 619",
    width: 10.21,
    height: 112.318,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_620",
    "data-name": "Rectangle 620",
    width: 28.184,
    height: 49.892,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_621",
    "data-name": "Rectangle 621",
    width: 14.829,
    height: 35.994,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_622",
    "data-name": "Rectangle 622",
    width: 36.651,
    height: 11.482,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_623",
    "data-name": "Rectangle 623",
    width: 32.183,
    height: 3.215,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_624",
    "data-name": "Rectangle 624",
    width: 27.723,
    height: 9.867,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_625",
    "data-name": "Rectangle 625",
    width: 64.916,
    height: 182.357,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_626",
    "data-name": "Rectangle 626",
    width: 24.174,
    height: 5.206,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_627",
    "data-name": "Rectangle 627",
    width: 8.231,
    height: 147.895,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_628",
    "data-name": "Rectangle 628",
    width: 29.53,
    height: 16.444,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_629",
    "data-name": "Rectangle 629",
    width: 110.784,
    height: 164.746,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    width: 38.712,
    height: 153.095,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3178",
    "data-name": "Path 3178",
    d: "M738.527,990.038a22.663,22.663,0,0,1-5.179-.646,16.8,16.8,0,0,1-1.969-.631c-5.605-2.044-8.18-5.648-8.726-9.455a7.951,7.951,0,0,1,4.672-8.826c-7.677,1.8-19.118,7.543-21.667,9.981-2.877,2.771.546,2.538-2.3,13.383-1.974,7.506-3.7,21.582-3.231,27.929s3.692,20.3,7.388,31.613,8.879,24.579,9.109,35.419-3.116,28.616-2.421,29.771,2.306,4.847,2.881,4.966,2.886.11,6.006-2.894,2.651-4.263,2.651-7.383c0-22.934-2.306-65.07,2.422-89.649,4.054-21.066,9.13-30.687,10.491-33.008.238-.386.034-.567-.124-.569",
    transform: "translate(-700.047 -970.481)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -3.092,
    cy: 3.046,
    r: 0.001,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_632",
    "data-name": "Rectangle 632",
    width: 18.867,
    height: 22.086,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    width: 21.679,
    height: 133.538,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    width: 1.905,
    height: 3.913,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 1.909,
    height: 3.918,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 2.379,
    height: 4.874,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    width: 2.375,
    height: 4.867,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_639",
    "data-name": "Rectangle 639",
    width: 2.382,
    height: 4.869,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_640",
    "data-name": "Rectangle 640",
    width: 71.767,
    height: 11.345,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-90"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_641",
    "data-name": "Rectangle 641",
    width: 20.299,
    height: 8.938,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-91"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    width: 57.046,
    height: 28.212,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-92"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_643",
    "data-name": "Rectangle 643",
    width: 3.918,
    height: 3.913,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-93"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    width: 3.913,
    height: 3.913,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_645",
    "data-name": "Rectangle 645",
    width: 3.917,
    height: 3.918,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-95"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_646",
    "data-name": "Rectangle 646",
    width: 4.86,
    height: 4.874,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-96"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_647",
    "data-name": "Rectangle 647",
    width: 4.863,
    height: 4.867,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-97"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_648",
    "data-name": "Rectangle 648",
    width: 4.876,
    height: 4.869,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-98"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_649",
    "data-name": "Rectangle 649",
    width: 35.106,
    height: 28.745,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-99"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_650",
    "data-name": "Rectangle 650",
    width: 16.061,
    height: 7.101,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-100"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_651",
    "data-name": "Rectangle 651",
    width: 65.301,
    height: 157.712,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-101"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_652",
    "data-name": "Rectangle 652",
    width: 33.438,
    height: 78.613,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-102"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_653",
    "data-name": "Rectangle 653",
    width: 24.499,
    height: 114.155,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-103"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    width: 24.006,
    height: 64.561,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-104"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_655",
    "data-name": "Rectangle 655",
    width: 15.882,
    height: 5.237,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-105"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_656",
    "data-name": "Rectangle 656",
    width: 16.102,
    height: 14.203,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_657",
    "data-name": "Rectangle 657",
    width: 5.99,
    height: 31.709,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-107"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_658",
    "data-name": "Rectangle 658",
    width: 37.675,
    height: 22.406,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_659",
    "data-name": "Rectangle 659",
    width: 40.364,
    height: 48.823,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-109"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_660",
    "data-name": "Rectangle 660",
    width: 6.593,
    height: 9.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_661",
    "data-name": "Rectangle 661",
    width: 24.371,
    height: 19.155,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-111"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_662",
    "data-name": "Rectangle 662",
    width: 6.067,
    height: 2.296,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_663",
    "data-name": "Rectangle 663",
    width: 9.395,
    height: 12.063,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-113"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_664",
    "data-name": "Rectangle 664",
    width: 5.842,
    height: 2.573,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-114"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_665",
    "data-name": "Rectangle 665",
    width: 11.822,
    height: 22.098,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-115"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_666",
    "data-name": "Rectangle 666",
    width: 12.328,
    height: 53.379,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-116"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_667",
    "data-name": "Rectangle 667",
    width: 35.241,
    height: 26.762,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-117"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_668",
    "data-name": "Rectangle 668",
    width: 15.534,
    height: 7.452,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-118"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_669",
    "data-name": "Rectangle 669",
    width: 9.511,
    height: 3.073,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_670",
    "data-name": "Rectangle 670",
    width: 52.006,
    height: 26.385,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-120"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_671",
    "data-name": "Rectangle 671",
    width: 50.683,
    height: 25.795,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-121"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_672",
    "data-name": "Rectangle 672",
    width: 10.819,
    height: 4.026,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_673",
    "data-name": "Rectangle 673",
    width: 22.89,
    height: 9.378,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-123"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_674",
    "data-name": "Rectangle 674",
    width: 16.886,
    height: 11.717,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-124"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_675",
    "data-name": "Rectangle 675",
    width: 6.98,
    height: 4.292,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3246",
    "data-name": "Path 3246",
    d: "M807.288,770.741c.912.239-.733.8.716,4.192s2.729,3.465,5.972,4.235,5.268,1.27,7.413.313,6.8-4.309,8.789-4.456c-1.705-.9-5.878-1.933-10.84-1.9a18.629,18.629,0,0,1-9.037-2.106,4.975,4.975,0,0,0-1.963-.395,4.421,4.421,0,0,0-1.051.114",
    transform: "translate(-807.288 -770.627)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-126"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_677",
    "data-name": "Rectangle 677",
    width: 20.012,
    height: 6.689,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-128"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    width: 17.763,
    height: 11.518,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-129"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_679",
    "data-name": "Rectangle 679",
    width: 15.815,
    height: 16.477,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-130"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    "data-name": "Rectangle 680",
    width: 6.316,
    height: 3.148,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3250",
    "data-name": "Path 3250",
    d: "M822.31,607.1c-.046,2.5-1.944,4.079-2.621,5.667a20.712,20.712,0,0,1-2.524,4.827c-.827.861-3.96,2.066-3.389,4.1s1.351,2.119,3.116,2.935,1.654,1.788,3.184,2.055a3.361,3.361,0,0,0,1.9-.375,6.118,6.118,0,0,1,3.335-.318c3.132.458,4.6.356,4.833-.957s.631-3.255-.64-4.38-1.939-6.262.584-11.739,2.357-9.619-9.463-9.7c-.388,2.164,1.731,5.392,1.688,7.891",
    transform: "translate(-813.707 -599.212)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -5.953,
    y1: 17.63,
    x2: -5.946,
    y2: 17.63,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9a7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#fda984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fcb58b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcba8e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-133"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_683",
    "data-name": "Rectangle 683",
    width: 7.634,
    height: 3.186,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-134"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_684",
    "data-name": "Rectangle 684",
    width: 9.586,
    height: 25.416,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-135"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_685",
    "data-name": "Rectangle 685",
    width: 15.784,
    height: 6.6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-136"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686",
    "data-name": "Rectangle 686",
    width: 4.561,
    height: 1.77,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-137"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_687",
    "data-name": "Rectangle 687",
    width: 1.581,
    height: 1.876,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-138"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_688",
    "data-name": "Rectangle 688",
    width: 10.771,
    height: 5.017,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-139"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_689",
    "data-name": "Rectangle 689",
    width: 12.533,
    height: 10.588,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-140"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_690",
    "data-name": "Rectangle 690",
    width: 9.842,
    height: 4.476,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3262",
    "data-name": "Path 3262",
    d: "M902.952,645.694c-.149.966-.119,1.376.422,1.854a6.5,6.5,0,0,0,3.908,2.517c4.195.733,7.1-.565,8.125-3.02-.217-2.413-1.927-6.629-5.657-7.281a5.383,5.383,0,0,0-.93-.082c-3.217,0-5.412,3.03-5.869,6.012",
    transform: "translate(-902.875 -639.682)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-142"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_692",
    "data-name": "Rectangle 692",
    width: 1.647,
    height: 1.65,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-144"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_693",
    "data-name": "Rectangle 693",
    width: 12.566,
    height: 3.861,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-145"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_694",
    "data-name": "Rectangle 694",
    width: 8.273,
    height: 6.788,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-146"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_695",
    "data-name": "Rectangle 695",
    width: 9.702,
    height: 8.569,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-147"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_696",
    "data-name": "Rectangle 696",
    width: 7.423,
    height: 4.137,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3272",
    "data-name": "Path 3272",
    d: "M795.468,637.447c.06.951.878,2.848,3.67,3.234a9.523,9.523,0,0,0,5.9-1.288c.358-.326-.187-.324-.106-.812.379-2.176-1.718-5.793-4.783-6.328a4.689,4.689,0,0,0-.8-.073c-3.456,0-3.943,4.379-3.88,5.267",
    transform: "translate(-795.463 -632.18)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-149"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_698",
    "data-name": "Rectangle 698",
    width: 1.473,
    height: 1.472,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-151"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_699",
    "data-name": "Rectangle 699",
    width: 12.035,
    height: 2.901,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-152"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_700",
    "data-name": "Rectangle 700",
    width: 9.553,
    height: 1.989,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-153"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    width: 64.865,
    height: 60.609,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-154"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_702",
    "data-name": "Rectangle 702",
    width: 9.852,
    height: 12.013,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-155"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703",
    "data-name": "Rectangle 703",
    width: 14.951,
    height: 9.885,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-156"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_704",
    "data-name": "Rectangle 704",
    width: 71.414,
    height: 98.334,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-157"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_705",
    "data-name": "Rectangle 705",
    width: 22.844,
    height: 32.712,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-158"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 46.689,
    height: 58.02,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-159"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_707",
    "data-name": "Rectangle 707",
    width: 30.351,
    height: 75.09,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-160"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_708",
    "data-name": "Rectangle 708",
    width: 28.742,
    height: 38.006,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-161"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_709",
    "data-name": "Rectangle 709",
    width: 19.047,
    height: 27.676,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-162"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    width: 5.706,
    height: 24.73,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-163"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    width: 10.228,
    height: 29.694,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-164"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    width: 17.498,
    height: 20.36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-165"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 16.162,
    height: 12.202,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-166"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    width: 10.023,
    height: 34.57,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-167"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    width: 18.385,
    height: 27.61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-168"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    width: 33.131,
    height: 39.194,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-169"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_717",
    "data-name": "Rectangle 717",
    width: 16.819,
    height: 20.203,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-170"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_718",
    "data-name": "Rectangle 718",
    width: 10.986,
    height: 28.995,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-171"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_719",
    "data-name": "Rectangle 719",
    width: 9.145,
    height: 25.858,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-172"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_720",
    "data-name": "Rectangle 720",
    width: 11.026,
    height: 17.706,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-173"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_721",
    "data-name": "Rectangle 721",
    width: 27.37,
    height: 23.132,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2758",
    "data-name": "Group 2758",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2618",
    "data-name": "Group 2618",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2617",
    "data-name": "Group 2617",
    clipPath: "url(#clip-path-2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3000",
    "data-name": "Path 3000",
    d: "M579.031,50.29c-1.128-.88-1.961-1.685-1.961-1.685l.406-.928,1.132-2.575-.329-.871a3.935,3.935,0,0,0,.111-3.026c2.094-4.537,8.431-18.2,11.273-23.7C593.092,10.865,599.881,2.467,606.2,0a225.538,225.538,0,0,1-7.24,24.57l-1.147.458.522,1.163-1.168.376.547,1.159-1.255.3.605,1.2-1.4.435.784.908c-.207.436-.413.861-.622,1.268l-2.685,1.409s-6.1,13.779-8.143,17.862c-.167.328-.3.6-.412.786a1.286,1.286,0,0,1-.257.325c-1.083,1.005-3.543-.56-5.3-1.937",
    transform: "translate(-476.762 -0.003)",
    fill: "#867e73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3001",
    "data-name": "Path 3001",
    d: "M603.268,134.7l15.117-33.528-.108.2L602.4,134.217Z",
    transform: "translate(-497.686 -83.583)",
    fill: "#544a3a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3002",
    "data-name": "Path 3002",
    d: "M598.27,135.168l15.88-32.849L597.4,134.69Z",
    transform: "translate(-493.559 -84.534)",
    fill: "#beb9b3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3003",
    "data-name": "Path 3003",
    d: "M584.88,42.17a3.9,3.9,0,0,0-.228-.965c2.094-4.537,8.432-18.2,11.273-23.7.488-.944,1.042-1.923,1.654-2.914q.487-.784,1.015-1.579c.546-.816,1.126-1.636,1.737-2.445.856-1.135,1.769-2.25,2.721-3.312C605.98,3.989,609.28,1.244,612.46,0L611.284,2.43S608,3.717,603.85,8.091a39.672,39.672,0,0,0-2.769,3.256q-.864,1.131-1.74,2.443-.506.762-1.013,1.584c-.889,1.457-1.774,3.063-2.633,4.836-3.263,6.736-5.439,10.975-10.815,21.96",
    transform: "translate(-483.026 -0.003)",
    fill: "#544a3a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3004",
    "data-name": "Path 3004",
    d: "M669.51,33.255s2.326-4.877,5.05-11.477c.25-.606.5-1.219.757-1.851l0,0c.394-.977.794-1.984,1.192-3.011.56-1.442,1.118-2.923,1.659-4.418,1.219-3.379,2.353-6.827,3.222-10.066L682.568,0s-1.389,6.066-3.548,13.38c-.443,1.514-.924,3.081-1.43,4.66-.339,1.052-.692,2.109-1.053,3.158-.222.647-.448,1.293-.678,1.933-.175.484-.353.966-.531,1.44l-1.147.458.521,1.163-1.167.376.547,1.159-1.255.3.605,1.2-1.4.435.783.908c-.207.436-.413.861-.622,1.268Z",
    transform: "translate(-553.134 -0.004)",
    fill: "#beb9b3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3005",
    "data-name": "Path 3005",
    d: "M651.828,44.525c1.176-2.493,2.3-5.01,3.394-7.54.544-1.266,1.087-2.533,1.61-3.808s1.04-2.552,1.554-3.831l.749-1.927c.253-.641.488-1.289.731-1.934.491-1.288.941-2.591,1.406-3.888l.659-1.96c.225-.651.427-1.31.632-1.968s.42-1.313.6-1.979l.464-1.634.055-.192.046-.163.019-.066-.062.026c-.051.022-.1.048-.149.071s-.129.062-.194.093c-.339.163-.671.34-1,.526-.43.258-.86.519-1.27.809s-.817.582-1.217.886-.776.636-1.166.952-.743.674-1.116,1.01-.71.708-1.068,1.06-.691.728-1.023,1.1-.677.741-.983,1.139l-.942,1.173c-.306.4-.591.81-.887,1.215s-.594.808-.858,1.235l-.818,1.263c-.283.415-.516.86-.772,1.291l-.754,1.3c-.239.441-.461.89-.693,1.335l-.688,1.338.032.015.716-1.322c.241-.439.472-.884.72-1.318l.78-1.284c.265-.424.506-.863.8-1.27l.841-1.241c.268-.422.573-.818.87-1.22s.589-.807.9-1.2l.951-1.155c.308-.392.658-.749.99-1.12s.668-.739,1.029-1.083.7-.712,1.07-1.04.727-.679,1.11-1,.756-.645,1.157-.936.791-.6,1.205-.87.83-.539,1.253-.791c.232-.131.471-.262.709-.384l-.387,1.341c-.182.662-.4,1.314-.607,1.97s-.4,1.314-.625,1.965l-.649,1.958c-.458,1.3-.9,2.6-1.386,3.887-.24.645-.47,1.293-.721,1.934l-.739,1.928c-.5,1.282-.99,2.569-1.507,3.845s-1.033,2.553-1.562,3.825l-1.592,3.813q-.8,1.9-1.646,3.792Z",
    transform: "translate(-535.434 -11.266)",
    fill: "#dfdcd9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3006",
    "data-name": "Path 3006",
    d: "M645.417,32.873s-8.216,6.4-16.247,22.984C635.4,42.989,643.393,38.78,643.393,38.78Z",
    transform: "translate(-519.806 -27.159)",
    fill: "#7a7265"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3007",
    "data-name": "Path 3007",
    d: "M612.19,110.254l-.083.191c-.055.124-.133.308-.237.539-.206.463-.5,1.124-.869,1.913-.182.395-.38.822-.593,1.272s-.435.926-.671,1.415-.475,1-.727,1.509l-.759,1.553-.77,1.548c-.252.511-.51,1.01-.754,1.5s-.486.951-.714,1.394-.446.86-.648,1.245c-.4.77-.747,1.408-.989,1.854-.12.223-.218.4-.283.516l-.1.182.083-.191c.055-.124.133-.308.237-.539.206-.464.5-1.124.869-1.913.182-.395.38-.822.593-1.272s.435-.926.671-1.415.475-1,.727-1.509l.759-1.553.77-1.548c.253-.511.51-1.01.754-1.5s.486-.951.714-1.394.446-.86.648-1.245c.4-.77.747-1.408.989-1.854.12-.223.218-.4.283-.516l.1-.183",
    transform: "translate(-499.004 -91.09)",
    fill: "#beb9b3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2255",
    "data-name": "Group 2255",
    transform: "translate(100.308 45.517)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2254",
    "data-name": "Group 2254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2253",
    "data-name": "Group 2253",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3008",
    "data-name": "Path 3008",
    d: "M579.031,266.631c-1.128-.88-1.961-1.685-1.961-1.685l1.354-3.085,2.726,3.734.6.762,1.047.038L585,267.457c-.167.328-.3.6-.412.786a1.285,1.285,0,0,1-.257.325Z",
    transform: "translate(-577.07 -261.861)",
    fill: "#a2a2a4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2258",
    "data-name": "Group 2258",
    transform: "translate(114.553 13.008)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2257",
    "data-name": "Group 2257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2256",
    "data-name": "Group 2256",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3009",
    "data-name": "Path 3009",
    d: "M659.769,77.2l-.749-.784q.487-.783,1.015-1.578l.747.779q-.506.762-1.013,1.583",
    transform: "translate(-659.02 -74.84)",
    fill: "#bdbdbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2261",
    "data-name": "Group 2261",
    transform: "translate(121.427 19.923)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2260",
    "data-name": "Group 2260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2259",
    "data-name": "Group 2259",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3010",
    "data-name": "Path 3010",
    d: "M699.862,117.831l-1.3-1.356c.25-.606.5-1.219.757-1.85l1.219,1.274c-.222.647-.447,1.293-.678,1.933",
    transform: "translate(-698.564 -114.624)",
    fill: "#aaa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2264",
    "data-name": "Group 2264",
    transform: "translate(117.304 7.251)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2263",
    "data-name": "Group 2263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2262",
    "data-name": "Group 2262",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3011",
    "data-name": "Path 3011",
    d: "M675.6,45.815l-.75-.781c.856-1.135,1.769-2.25,2.721-3.312l.8.836a39.674,39.674,0,0,0-2.769,3.256",
    transform: "translate(-674.849 -41.722)",
    fill: "#bdbdbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2267",
    "data-name": "Group 2267",
    transform: "translate(123.377 12.492)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2266",
    "data-name": "Group 2266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2265",
    "data-name": "Group 2265",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3012",
    "data-name": "Path 3012",
    d: "M710.864,77.42l-1.078-1.13c.559-1.442,1.118-2.923,1.659-4.418l.849.888c-.443,1.514-.924,3.081-1.43,4.66",
    transform: "translate(-709.786 -71.872)",
    fill: "#dbdbdb"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3013",
    "data-name": "Path 3013",
    d: "M476.869,303.022a2.884,2.884,0,0,1-.187-1.672s.418-.306,1.067-.842c.537-.443,1.228-1.042,1.974-1.762.52-.5,1.066-1.053,1.6-1.653.4-.446.794-.918,1.166-1.406a17.026,17.026,0,0,0,1.106-1.618,10.778,10.778,0,0,0,1.2-2.721,1.551,1.551,0,0,1,.854-1.017,5.163,5.163,0,0,0,3.424-4.747,1.513,1.513,0,0,1,.628-1.051,8.049,8.049,0,0,0,2.084-2.062,3.037,3.037,0,0,0,.576-2.256,2.521,2.521,0,0,0-.72-1.262,5.751,5.751,0,0,0-2.013-1.2l.048-.386.12-1.027,4.294.57,7.517,3.3s-.182.457-.522,1.265c-.23.548-.535,1.251-.9,2.081a7.361,7.361,0,0,0-.717.857,14.174,14.174,0,0,0-2.31,5.056l-.5,1.337a95.541,95.541,0,0,1-5.272,8.882q-.546.808-1.114,1.594c-.49.684-.994,1.354-1.51,2q-.72.921-1.468,1.784c-.668.765-1.349,1.5-2.041,2.178-.517.509-1.037.992-1.564,1.44-4.683-2.129-6.288-4.254-6.81-5.662",
    transform: "translate(-393.784 -228.304)",
    fill: "#40160c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3014",
    "data-name": "Path 3014",
    d: "M480.769,305.554c.192-.147.486-.378.852-.68.7-.576,1.375-1.181,2.015-1.8.61-.586,1.147-1.14,1.637-1.693.437-.489.841-.977,1.2-1.448a17.753,17.753,0,0,0,1.15-1.684c.218-.364.415-.728.587-1.082a10.326,10.326,0,0,0,.689-1.822.864.864,0,0,1,.058-.156.817.817,0,0,1,.4-.393,5.954,5.954,0,0,0,3.175-2.818,7.768,7.768,0,0,0,.663-2.493.8.8,0,0,1,.074-.249.806.806,0,0,1,.258-.3,7.991,7.991,0,0,0,2.612-2.852,3.4,3.4,0,0,0,.336-2.2,4.136,4.136,0,0,0-2.659-2.771l.019-.156,3.474.461L504.1,284.4c-.229.552-.6,1.439-1.1,2.564a12.36,12.36,0,0,0-2,3.02,15.74,15.74,0,0,0-1.11,3.089l-.473,1.258a94.15,94.15,0,0,1-5.21,8.772c-.341.5-.7,1.021-1.1,1.577-.5.7-1,1.361-1.489,1.974-.457.584-.944,1.176-1.45,1.763-.695.795-1.35,1.495-2,2.136-.412.406-.8.771-1.181,1.106-5.833-2.763-6.225-5.37-6.208-6.1",
    transform: "translate(-397.199 -232.12)",
    fill: "#542e25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2270",
    "data-name": "Group 2270",
    transform: "translate(85.132 51.062)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2269",
    "data-name": "Group 2269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2268",
    "data-name": "Group 2268",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3015",
    "data-name": "Path 3015",
    d: "M489.96,316.555c.724-.6,1.43-1.228,2.1-1.872.638-.613,1.2-1.193,1.714-1.773.459-.513.887-1.029,1.269-1.531a19.2,19.2,0,0,0,1.239-1.816c.239-.4.457-.8.647-1.193a11.991,11.991,0,0,0,.71-1.813,7.228,7.228,0,0,0,3.612-3.375,8.8,8.8,0,0,0,.759-2.666,9.247,9.247,0,0,0,2.848-3.234,4.791,4.791,0,0,0,.449-3.11q-.044-.21-.106-.412l4.459,1.957c-.134.312-.285.656-.45,1.03a14.223,14.223,0,0,0-2.074,3.188,17.183,17.183,0,0,0-1.19,3.286l-.412,1.1a92.555,92.555,0,0,1-5.088,8.559c-.331.49-.684.995-1.079,1.544-.488.681-.974,1.325-1.446,1.917-.451.576-.924,1.151-1.415,1.72-.667.763-1.3,1.437-1.922,2.052-.143.141-.283.276-.42.407-3.135-1.633-4.1-3.051-4.4-3.8l.2-.165",
    transform: "translate(-489.759 -293.76)",
    fill: "#230d0b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2273",
    "data-name": "Group 2273",
    transform: "translate(82.85 48.569)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2272",
    "data-name": "Group 2272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2271",
    "data-name": "Group 2271",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3016",
    "data-name": "Path 3016",
    d: "M476.869,305.565a2.884,2.884,0,0,1-.187-1.672s.418-.306,1.067-.842c.537-.443,1.228-1.042,1.974-1.762.52-.5,1.066-1.053,1.6-1.653.4-.446.794-.918,1.166-1.406a17.017,17.017,0,0,0,1.106-1.618,10.777,10.777,0,0,0,1.2-2.721,1.552,1.552,0,0,1,.854-1.017,5.162,5.162,0,0,0,3.424-4.747,1.514,1.514,0,0,1,.628-1.051c1.671-1.177,2.968-2.83,2.66-4.318-.194-.928-1.006-1.8-2.732-2.464l.048-.386a3.549,3.549,0,0,1,2.011-.476,3.32,3.32,0,0,1,2.554,2.218c.353,1.224-.5,2.989-1.211,3.935a5.09,5.09,0,0,0-.669.987,1.118,1.118,0,0,0,.083,1.133,2.835,2.835,0,0,1,.332.364.732.732,0,0,1-.191.845,3.6,3.6,0,0,1-.777.505,6.748,6.748,0,0,0-2.044,2.332,4.844,4.844,0,0,0-.9,2.1c-.052.591.075,1.3-.372,1.687-.408.359-1.051.21-1.557.418-.636.264-.9,1.011-1.369,1.522a13.171,13.171,0,0,1-1.553,1.139,7.518,7.518,0,0,0-1.777,2.652,10.2,10.2,0,0,1-2.116,3.04,4.441,4.441,0,0,1-3.244,1.25",
    transform: "translate(-476.634 -279.417)",
    fill: "#c0b1ae"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2276",
    "data-name": "Group 2276",
    transform: "translate(95.27 60.069)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2275",
    "data-name": "Group 2275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2274",
    "data-name": "Group 2274",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3017",
    "data-name": "Path 3017",
    d: "M549.288,356.366a1.567,1.567,0,0,1-.442.461.533.533,0,0,1-.6-.012.686.686,0,0,1-.1-.721,8.933,8.933,0,0,1,.773-1.491,1.975,1.975,0,0,0,.228-1.614c-.151-.377-.5-.759-.327-1.127.156-.339.615-.361.984-.414a2.7,2.7,0,0,0,2.239-2.646c-.01-.412-.118-.818-.118-1.23a1.233,1.233,0,0,1,.49-1.076c.411-.249.977-.1,1.382-.363.2-.126.331-.333.531-.453,1.038-.619.122,1.818.024,2.091a21.035,21.035,0,0,1-1.372,3.011,52.943,52.943,0,0,1-3.688,5.582",
    transform: "translate(-548.088 -345.581)",
    fill: "#c3bdbd"
  }))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3018",
    "data-name": "Path 3018",
    d: "M482.407,422.944a19.915,19.915,0,0,1-2.351-1.4A8.628,8.628,0,0,1,477,418.214a3.968,3.968,0,0,1-.308-.948,2.385,2.385,0,0,1-.01-1.038s.418-.306,1.067-.842c.159.288.327.564.5.83.137.209.276.415.419.612a15.828,15.828,0,0,0,3.08,3.173,17.583,17.583,0,0,0,2.245,1.485c.466.261.887.473,1.249.637-.515.505-1.035.989-1.562,1.436q-.678-.31-1.271-.616",
    transform: "translate(-393.781 -343.183)",
    fill: "#cbbfb3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3019",
    "data-name": "Path 3019",
    d: "M498.634,381.436c-.267-.26-.531-.527-.8-.8-.222-.223-.442-.449-.666-.676l1.105-1.618c.232.244.468.485.708.729.327.325.659.649,1,.966a16.415,16.415,0,0,0,6.073,3.919c-.366.542-.738,1.073-1.116,1.6a15.29,15.29,0,0,1-6.31-4.117m3.332,7.9,1.468-1.784a16.936,16.936,0,0,1-6.252-4.729c-.2-.233-.394-.465-.581-.695q-.307-.387-.6-.765c-.533.6-1.079,1.154-1.6,1.653.219.245.435.5.649.751l.471.562a14.565,14.565,0,0,0,6.44,5.007",
    transform: "translate(-408.467 -312.578)",
    fill: "#90897f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2279",
    "data-name": "Group 2279",
    transform: "translate(89.878 69.823)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2278",
    "data-name": "Group 2278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2277",
    "data-name": "Group 2277",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3020",
    "data-name": "Path 3020",
    d: "M518.747,419.843c-.671.7-1.269,1.3-1.683,1.712a12.39,12.39,0,0,0,2.225,1.453c.546-.535,1.1-1.143,1.625-1.758a15.514,15.514,0,0,1-2.167-1.407",
    transform: "translate(-517.064 -416.688)",
    fill: "#5f4f4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3021",
    "data-name": "Path 3021",
    d: "M536.955,401.69c-.424.5-.88,1.012-1.342,1.515a12.77,12.77,0,0,0,2.137,1.181c.5-.652.917-1.217,1.181-1.585a13.548,13.548,0,0,1-1.977-1.111",
    transform: "translate(-532.389 -401.69)",
    fill: "#5f4f4d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2282",
    "data-name": "Group 2282",
    transform: "translate(86.274 76.819)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2281",
    "data-name": "Group 2281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2280",
    "data-name": "Group 2280",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3022",
    "data-name": "Path 3022",
    d: "M498.682,444.88a19.915,19.915,0,0,1-2.351-1.4l1.69-1.537a17.581,17.581,0,0,0,2.245,1.485s-.87.795-1.584,1.458",
    transform: "translate(-496.331 -441.938)",
    fill: "#6e605e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2285",
    "data-name": "Group 2285",
    transform: "translate(89.37 66.492)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2284",
    "data-name": "Group 2284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2283",
    "data-name": "Group 2283",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3023",
    "data-name": "Path 3023",
    d: "M514.941,384.9c-.267-.261-.531-.528-.8-.8.469-.607.857-1.146,1.148-1.566.327.325.659.649,1,.966-.412.448-.866.919-1.353,1.4",
    transform: "translate(-514.144 -382.533)",
    fill: "#c4bdbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2288",
    "data-name": "Group 2288",
    transform: "translate(86.588 69.553)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2287",
    "data-name": "Group 2287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2286",
    "data-name": "Group 2286",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3024",
    "data-name": "Path 3024",
    d: "M498.611,402.343l-.471-.562c.555-.546,1.074-1.1,1.545-1.64.187.23.38.462.581.695-.541.509-1.1,1.017-1.656,1.507",
    transform: "translate(-498.14 -400.142)",
    fill: "#c4bdbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2291",
    "data-name": "Group 2291",
    transform: "translate(82.908 73.033)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2290",
    "data-name": "Group 2290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2289",
    "data-name": "Group 2289",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3025",
    "data-name": "Path 3025",
    d: "M477.274,422.16a3.974,3.974,0,0,1-.308-.948,15.2,15.2,0,0,0,1.557-1.05c.137.21.276.416.419.612-.6.51-1.17.979-1.668,1.385",
    transform: "translate(-476.966 -420.162)",
    fill: "#c4bdbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2294",
    "data-name": "Group 2294",
    transform: "translate(87.244 65.764)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2293",
    "data-name": "Group 2293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2292",
    "data-name": "Group 2292",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3026",
    "data-name": "Path 3026",
    d: "M516.244,379.276c.336.334.678.667,1.031.993a17.166,17.166,0,0,0,6.092,3.98c.067-.1.138-.194.2-.293a16.418,16.418,0,0,1-6.073-3.919c-.343-.317-.675-.641-1-.966-.24-.243-.476-.485-.708-.729l-.186.273q.317.331.642.661",
    transform: "translate(-513.223 -378.342)",
    fill: "#655b4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3027",
    "data-name": "Path 3027",
    d: "M502.483,396.8c.192.236.391.475.6.714a17.509,17.509,0,0,0,6.253,4.785l.3-.367a16.943,16.943,0,0,1-6.252-4.729c-.2-.233-.394-.465-.581-.7q-.307-.387-.595-.765c-.1.11-.2.217-.295.323.185.242.374.486.57.733",
    transform: "translate(-501.913 -392.715)",
    fill: "#655b4d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2297",
    "data-name": "Group 2297",
    transform: "translate(90.531 51.211)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2296",
    "data-name": "Group 2296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2295",
    "data-name": "Group 2295",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3028",
    "data-name": "Path 3028",
    d: "M529.885,367.8q.3-.488.588-.975c-.045-.068-.083-.14-.13-.207a4.424,4.424,0,0,0-2.541-1.84,6.436,6.436,0,0,0-2.414.051,4.474,4.474,0,0,1-2.3-.033,3.607,3.607,0,0,1-1.775-2.236c0,.008-.006.014-.008.021a9.047,9.047,0,0,1-.478,1.337,3.845,3.845,0,0,0,1.882,1.818,5.28,5.28,0,0,0,2.834.1,5.6,5.6,0,0,1,2.037-.066,3.422,3.422,0,0,1,1.941,1.437,6.233,6.233,0,0,1,.369.6",
    transform: "translate(-520.823 -350.754)",
    fill: "#230d0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3029",
    "data-name": "Path 3029",
    d: "M547.764,334.559a3.315,3.315,0,0,0,2.685,1.286c.15.013.3.024.453.035a4.388,4.388,0,0,1,1.892.406,3.553,3.553,0,0,1,.865.784q.262-.474.515-.943a3.9,3.9,0,0,0-.869-.717,5.19,5.19,0,0,0-2.329-.541c-.146-.01-.291-.021-.434-.034a2.446,2.446,0,0,1-1.925-.827,2.96,2.96,0,0,1-.311-1.363,4,4,0,0,0-.422-1.763,2.463,2.463,0,0,0-.8-.818,9.281,9.281,0,0,1-.215,1.152,1.311,1.311,0,0,1,.14.178,3.158,3.158,0,0,1,.286,1.33,3.8,3.8,0,0,0,.47,1.835",
    transform: "translate(-542.341 -323.903)",
    fill: "#230d0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    "data-name": "Path 3030",
    d: "M563.365,320.365c.354.027.709.038,1.055.047.09-.352.189-.685.294-1l-.192-.006c-.357-.01-.726-.021-1.081-.047a4.076,4.076,0,0,1-2.794-1.075,5.223,5.223,0,0,1-.945-2.049,6.933,6.933,0,0,0-.96-2.2c-.011-.015-.024-.028-.036-.042a7.294,7.294,0,0,1-.7.766,6.608,6.608,0,0,1,.73,1.769,6.051,6.051,0,0,0,1.164,2.436,5.022,5.022,0,0,0,3.469,1.4",
    transform: "translate(-551.539 -310.623)",
    fill: "#230d0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M581.343,300.964c.07.357.258,1.3,1.072,1.539a1.776,1.776,0,0,0,1.138-.134l.416-.157a14.224,14.224,0,0,1,.648-1.328l-1.422.537a1.054,1.054,0,0,1-.5.109c-.1-.029-.246-.185-.36-.762q-.234-1.183-.459-2.366a2,2,0,0,1,.012-1.252,2.028,2.028,0,0,1,1.28-.692l4.37-1.191-1.477-.648-3.16.861a2.881,2.881,0,0,0-1.9,1.184c-.014.025-.027.051-.039.076a2.954,2.954,0,0,0-.079,1.853q.226,1.187.461,2.373",
    transform: "translate(-570.35 -294.617)",
    fill: "#230d0b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2300",
    "data-name": "Group 2300",
    transform: "translate(98.6 56.986)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2299",
    "data-name": "Group 2299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2298",
    "data-name": "Group 2298",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    "data-name": "Path 3032",
    d: "M568.018,330.457a1.376,1.376,0,1,1,1.838-.638,1.376,1.376,0,0,1-1.838.638",
    transform: "translate(-567.242 -327.842)",
    fill: "#c0b1ae"
  }))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3033",
    "data-name": "Path 3033",
    d: "M570.076,331.454a1.376,1.376,0,1,1,1.838-.638,1.376,1.376,0,0,1-1.838.638",
    transform: "translate(-470.342 -271.681)",
    fill: "#beb9b3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2303",
    "data-name": "Group 2303",
    transform: "translate(99.616 57.25)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2302",
    "data-name": "Group 2302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2301",
    "data-name": "Group 2301",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3034",
    "data-name": "Path 3034",
    d: "M574.794,331.124a1.371,1.371,0,0,1-1.707.686,1.372,1.372,0,1,0,1.318-2.4c-.043-.021-.087-.032-.13-.048a1.371,1.371,0,0,1,.52,1.765",
    transform: "translate(-573.087 -329.359)",
    fill: "#655b4d"
  }))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3035",
    "data-name": "Path 3035",
    d: "M551.386,277.736l.167-1.414,4.295.571,7.515,3.3s-.505,1.286-1.425,3.349a20.074,20.074,0,0,0-7.821-3.34c-.194-.929-1.007-1.8-2.731-2.463",
    transform: "translate(-455.542 -228.291)",
    fill: "#cbbfb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2306",
    "data-name": "Group 2306",
    transform: "translate(97.855 50.306)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2305",
    "data-name": "Group 2305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2304",
    "data-name": "Group 2304",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3036",
    "data-name": "Path 3036",
    d: "M563.1,293.268a3.037,3.037,0,0,0,.576-2.256,2.521,2.521,0,0,0-.719-1.263,3.411,3.411,0,0,1,1.771-.334,7.915,7.915,0,0,1,2.362.627c.918.353,1.82.738,2.723,1.121q1.179.506,2.362,1.005c.076.033.151.065.225.1-.23.548-.534,1.251-.9,2.081a7.362,7.362,0,0,0-.717.857,3.243,3.243,0,0,1-.58-.189c-.526-.219-1.008-.528-1.532-.75a17.56,17.56,0,0,0-4.505-.74,4.865,4.865,0,0,1-1.062-.26",
    transform: "translate(-562.956 -289.408)",
    fill: "#c0b1ae"
  }))))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3037",
    "data-name": "Path 3037",
    d: "M1274.273,446.026c-1.244.7-2.307,1.167-2.307,1.167l-.7-.73-1.945-2.031-.931-.029a3.938,3.938,0,0,0-2.753-1.26c-3.389-3.671-13.59-14.756-17.582-19.486-4.821-5.71-9.98-15.2-9.84-21.974a225.483,225.483,0,0,1,19.928,16.092l-.016,1.235,1.274-.037-.1,1.223,1.28-.062-.2,1.275,1.343-.1-.133,1.459,1.139-.377c.323.358.637.711.934,1.06l.274,3.02s10.4,10.907,13.385,14.359c.239.28.433.509.568.682a1.292,1.292,0,0,1,.2.361c.514,1.385-1.874,3.059-3.817,4.151",
    transform: "translate(-1022.98 -331.862)",
    fill: "#867e73"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3038",
    "data-name": "Path 3038",
    d: "M1337.642,513.633l-25.189-26.8.144.176,24.27,27.243Z",
    transform: "translate(-1084.317 -402.212)",
    fill: "#544a3a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3039",
    "data-name": "Path 3039",
    d: "M1337.549,515.092l-24.27-27.244,23.5,27.863Z",
    transform: "translate(-1085 -403.05)",
    fill: "#beb9b3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3040",
    "data-name": "Path 3040",
    d: "M1266.612,443.307a3.9,3.9,0,0,0-.979-.158c-3.39-3.671-13.59-14.757-17.582-19.486-.684-.813-1.377-1.7-2.059-2.643q-.538-.749-1.07-1.542c-.545-.817-1.08-1.666-1.594-2.54-.721-1.225-1.4-2.5-2.018-3.781-1.9-3.956-3.169-8.055-3.1-11.468L1240,403.7s-.066,3.525,2.385,9.035a39.727,39.727,0,0,0,1.948,3.8q.715,1.231,1.591,2.542.511.759,1.075,1.542c1.006,1.378,2.151,2.811,3.46,4.283,4.975,5.592,8.058,9.225,16.149,18.4",
    transform: "translate(-1022.979 -331.867)",
    fill: "#544a3a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3041",
    "data-name": "Path 3041",
    d: "M1263.947,426.478s-3.615-4.016-8.67-9.058c-.465-.463-.933-.931-1.42-1.408l0,0c-.752-.738-1.529-1.492-2.325-2.253-1.118-1.068-2.273-2.152-3.446-3.224-2.655-2.42-5.407-4.787-8.066-6.829l-1.792-2.015s5.073,3.6,11,8.4c1.229.989,2.492,2.033,3.757,3.1.842.715,1.683,1.446,2.514,2.181.513.453,1.024.909,1.526,1.366.38.347.757.7,1.127,1.041l-.017,1.235,1.274-.037-.1,1.223,1.28-.062-.2,1.275,1.343-.1-.133,1.459,1.139-.377c.324.358.637.711.933,1.06Z",
    transform: "translate(-1022.992 -331.866)",
    fill: "#beb9b3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3042",
    "data-name": "Path 3042",
    d: "M1272.32,435.711c-1.853-2.041-3.749-4.042-5.667-6.021-.961-.988-1.924-1.974-2.9-2.945s-1.96-1.938-2.944-2.9l-1.494-1.429c-.495-.48-1-.944-1.507-1.415-1-.946-2.033-1.861-3.054-2.787l-1.558-1.359c-.516-.457-1.047-.9-1.577-1.337s-1.053-.89-1.6-1.311l-1.332-1.054-.157-.124-.132-.1-.053-.042v.068c0,.055.007.109.009.164,0,.072.007.143.011.215.021.376.057.75.1,1.124.074.5.15.993.261,1.483.095.493.225.978.353,1.463s.29.961.433,1.442.339.944.506,1.417.383.927.571,1.392.408.916.628,1.367.425.909.677,1.344l.723,1.32c.25.435.522.856.783,1.285s.519.859.813,1.266l.853,1.239c.275.42.6.806.9,1.208l.915,1.194c.316.39.646.767.968,1.151l.973,1.147.027-.024-.948-1.167c-.314-.39-.636-.774-.942-1.17l-.887-1.212c-.291-.407-.6-.8-.869-1.223l-.825-1.252c-.287-.409-.537-.842-.793-1.27s-.52-.852-.763-1.288l-.7-1.321c-.245-.435-.44-.894-.656-1.343s-.427-.9-.607-1.365-.391-.916-.551-1.387-.349-.931-.495-1.406-.307-.945-.422-1.428-.251-.96-.342-1.446c-.108-.484-.18-.973-.251-1.461-.032-.265-.062-.536-.084-.8l1.091.87c.542.422,1.06.875,1.588,1.314s1.061.874,1.576,1.33l1.561,1.349c1.023.92,2.056,1.828,3.061,2.768.5.468,1.015.93,1.511,1.406l1.5,1.42c.992.954,1.994,1.9,2.976,2.864s1.963,1.932,2.936,2.907l2.913,2.931q1.451,1.472,2.873,2.972Z",
    transform: "translate(-1031.353 -341.112)",
    fill: "#dfdcd9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3043",
    "data-name": "Path 3043",
    d: "M1260.175,434.585s2.772,10.042,15.016,23.807c-9.5-10.683-10.333-19.676-10.333-19.676Z",
    transform: "translate(-1041.127 -359.044)",
    fill: "#7a7265"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3044",
    "data-name": "Path 3044",
    d: "M1304.306,530.241l.145.15c.094.1.233.241.407.425.349.368.846.9,1.435,1.535.295.319.614.665.948,1.035s.689.756,1.051,1.161.739.82,1.116,1.249l1.144,1.3,1.135,1.3c.376.429.738.858,1.093,1.269s.693.813,1.015,1.193.624.741.9,1.075c.557.667,1.015,1.229,1.334,1.623.16.2.283.353.369.459l.13.163-.145-.15c-.094-.1-.234-.24-.407-.425-.35-.368-.847-.9-1.435-1.534-.295-.319-.614-.666-.948-1.035s-.689-.756-1.05-1.162-.74-.82-1.116-1.249l-1.144-1.3-1.135-1.3c-.375-.429-.738-.858-1.093-1.269s-.693-.813-1.014-1.193-.624-.741-.9-1.075c-.557-.667-1.015-1.229-1.334-1.623-.161-.2-.283-.354-.369-.459l-.13-.163",
    transform: "translate(-1077.587 -438.073)",
    fill: "#beb9b3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2309",
    "data-name": "Group 2309",
    transform: "translate(246.653 108.971)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2308",
    "data-name": "Group 2308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2307",
    "data-name": "Group 2307",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3045",
    "data-name": "Path 3045",
    d: "M1423.634,632.1c-1.244.7-2.307,1.167-2.307,1.167L1419,630.836l4.493-1.09.935-.267.436-.952,1.823-1.621c.239.28.434.51.568.682a1.286,1.286,0,0,1,.2.361Z",
    transform: "translate(-1418.994 -626.906)",
    fill: "#a2a2a4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2312",
    "data-name": "Group 2312",
    transform: "translate(221.943 87.219)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2311",
    "data-name": "Group 2311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2310",
    "data-name": "Group 2310",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3046",
    "data-name": "Path 3046",
    d: "M1278.912,503.314l-1.011.392q-.538-.75-1.07-1.542l1.006-.392q.51.76,1.075,1.542",
    transform: "translate(-1276.832 -501.772)",
    fill: "#bdbdbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2315",
    "data-name": "Group 2315",
    transform: "translate(230.865 83.508)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2314",
    "data-name": "Group 2314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2313",
    "data-name": "Group 2313",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3047",
    "data-name": "Path 3047",
    d: "M1331.324,481.785l-1.75.68c-.464-.463-.933-.931-1.42-1.408l1.643-.638c.513.453,1.023.908,1.526,1.366",
    transform: "translate(-1328.156 -480.419)",
    fill: "#aaa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2318",
    "data-name": "Group 2318",
    transform: "translate(218.331 80.872)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2317",
    "data-name": "Group 2317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2316",
    "data-name": "Group 2316",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3048",
    "data-name": "Path 3048",
    d: "M1259.077,469.063l-1.008.394c-.721-1.225-1.4-2.5-2.018-3.781l1.078-.418a39.688,39.688,0,0,0,1.948,3.8",
    transform: "translate(-1256.051 -465.259)",
    fill: "#bdbdbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2321",
    "data-name": "Group 2321",
    transform: "translate(225.091 78.222)",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2320",
    "data-name": "Group 2320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2319",
    "data-name": "Group 2319",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3049",
    "data-name": "Path 3049",
    d: "M1299.84,453.115l-1.457.563c-1.118-1.068-2.273-2.152-3.447-3.223l1.146-.445c1.229.989,2.493,2.033,3.757,3.1",
    transform: "translate(-1294.937 -450.01)",
    fill: "#dbdbdb"
  }))))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3050",
    "data-name": "Path 3050",
    d: "M1439.631,662.428a2.884,2.884,0,0,1-1.617-.467s-.123-.5-.369-1.308c-.2-.665-.493-1.533-.872-2.5-.262-.671-.565-1.388-.915-2.11-.26-.539-.544-1.086-.853-1.615a17.064,17.064,0,0,0-1.072-1.641,10.778,10.778,0,0,0-2.056-2.149,1.551,1.551,0,0,1-.612-1.178,5.162,5.162,0,0,0-3.075-4.98,1.512,1.512,0,0,1-.73-.982,8.055,8.055,0,0,0-1.108-2.714,3.037,3.037,0,0,0-1.864-1.4,2.521,2.521,0,0,0-1.442.182,5.75,5.75,0,0,0-1.88,1.4l-.338-.192-.9-.5,2.17-3.749,5.925-5.682s.352.342.969.966c.419.422.951.972,1.576,1.632a7.349,7.349,0,0,0,.517.99,14.174,14.174,0,0,0,3.787,4.069l1.042.978a95.565,95.565,0,0,1,6.188,8.27q.538.814,1.047,1.639c.445.715.871,1.437,1.272,2.162q.575,1.018,1.087,2.039c.451.91.866,1.819,1.231,2.719.272.672.52,1.338.732,2-3.759,3.511-6.336,4.181-7.837,4.124",
    transform: "translate(-1173.109 -521.189)",
    fill: "#40160c"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3051",
    "data-name": "Path 3051",
    d: "M1443.293,666.226c-.062-.234-.163-.594-.3-1.048-.266-.865-.565-1.722-.891-2.55-.308-.788-.615-1.5-.937-2.161-.284-.591-.58-1.151-.878-1.663a17.693,17.693,0,0,0-1.115-1.707c-.253-.341-.514-.663-.775-.956a10.308,10.308,0,0,0-1.419-1.334.868.868,0,0,1-.122-.113.819.819,0,0,1-.21-.52,5.955,5.955,0,0,0-1.388-4.011,7.767,7.767,0,0,0-2.05-1.567.8.8,0,0,1-.385-.519,8,8,0,0,0-1.635-3.5,3.4,3.4,0,0,0-1.9-1.151,4.136,4.136,0,0,0-3.578,1.4l-.137-.077,1.755-3.033,5.349-5.13c.423.423,1.1,1.108,1.947,2a12.372,12.372,0,0,0,2.024,3,15.765,15.765,0,0,0,2.429,2.207l.981.919a94.025,94.025,0,0,1,6.11,8.171c.336.509.674,1.039,1.035,1.622.453.729.875,1.446,1.254,2.131.365.646.725,1.322,1.074,2.015.468.946.864,1.82,1.208,2.666.217.536.405,1.035.57,1.514-4.786,4.332-7.344,3.7-8.012,3.4",
    transform: "translate(-1177.772 -525.926)",
    fill: "#542e25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2324",
    "data-name": "Group 2324",
    transform: "translate(251.359 112.661)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2323",
    "data-name": "Group 2323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2322",
    "data-name": "Group 2322",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3052",
    "data-name": "Path 3052",
    d: "M1461.289,674.308c-.276-.9-.588-1.791-.927-2.654-.322-.824-.643-1.564-.982-2.262-.3-.621-.612-1.214-.928-1.758a19.227,19.227,0,0,0-1.2-1.84c-.277-.373-.565-.728-.855-1.054a11.972,11.972,0,0,0-1.4-1.35,7.231,7.231,0,0,0-1.736-4.629,8.822,8.822,0,0,0-2.172-1.722,9.244,9.244,0,0,0-1.9-3.868,4.788,4.788,0,0,0-2.7-1.605q-.211-.04-.421-.06l3.515-3.371c.236.244.5.514.779.81a14.209,14.209,0,0,0,2.151,3.136,17.182,17.182,0,0,0,2.58,2.357l.855.8a92.637,92.637,0,0,1,5.96,7.976c.326.494.657,1.013,1.013,1.588.443.711.852,1.407,1.218,2.069.36.637.71,1.294,1.048,1.965.45.909.831,1.749,1.16,2.561.076.186.147.367.215.544-2.709,2.271-4.389,2.623-5.192,2.613q-.035-.119-.075-.249",
    transform: "translate(-1446.062 -648.136)",
    fill: "#230d0b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2327",
    "data-name": "Group 2327",
    transform: "translate(247.696 116.025)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2326",
    "data-name": "Group 2326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2325",
    "data-name": "Group 2325",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3053",
    "data-name": "Path 3053",
    d: "M1443.818,692.7a2.883,2.883,0,0,1-1.616-.467s-.123-.5-.369-1.308c-.2-.665-.493-1.533-.872-2.5-.262-.671-.564-1.388-.915-2.11-.26-.54-.545-1.086-.853-1.615a16.964,16.964,0,0,0-1.072-1.641,10.757,10.757,0,0,0-2.055-2.149,1.551,1.551,0,0,1-.612-1.178,5.163,5.163,0,0,0-3.075-4.98,1.516,1.516,0,0,1-.73-.982c-.448-1.994-1.479-3.825-2.971-4.11-.932-.176-2.051.24-3.322,1.581l-.338-.192a3.552,3.552,0,0,1,.329-2.04,3.321,3.321,0,0,1,3.027-1.51c1.266.143,2.571,1.6,3.173,2.625a5.07,5.07,0,0,0,.656,1,1.117,1.117,0,0,0,1.078.357,2.832,2.832,0,0,1,.463-.168.732.732,0,0,1,.708.5,3.59,3.59,0,0,1,.169.911,6.751,6.751,0,0,0,1.373,2.78,4.847,4.847,0,0,0,1.6,1.641c.526.274,1.226.426,1.416.99.175.514-.208,1.052-.21,1.6,0,.689.59,1.217.882,1.848a13.136,13.136,0,0,1,.458,1.871,7.513,7.513,0,0,0,1.77,2.657,10.2,10.2,0,0,1,2,3.118,4.44,4.44,0,0,1-.087,3.475",
    transform: "translate(-1424.993 -667.486)",
    fill: "#c0b1ae"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2330",
    "data-name": "Group 2330",
    transform: "translate(260.121 118.243)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2329",
    "data-name": "Group 2329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2328",
    "data-name": "Group 2328",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3054",
    "data-name": "Path 3054",
    d: "M1504.42,689.4a1.573,1.573,0,0,1,.257.585.534.534,0,0,1-.241.552.687.687,0,0,1-.706-.181,8.955,8.955,0,0,1-1.081-1.285,1.974,1.974,0,0,0-1.4-.828c-.406,0-.891.169-1.167-.129-.254-.274-.1-.707-.006-1.068a2.7,2.7,0,0,0-1.588-3.081c-.385-.148-.8-.2-1.181-.362a1.233,1.233,0,0,1-.806-.865c-.073-.475.278-.943.193-1.417-.041-.229-.181-.433-.215-.664-.175-1.2,1.727.584,1.941.778a21.015,21.015,0,0,1,2.257,2.42,53,53,0,0,1,3.746,5.544",
    transform: "translate(-1496.465 -680.248)",
    fill: "#c3bdbd"
  }))))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3055",
    "data-name": "Path 3055",
    d: "M1530.632,780.271a19.966,19.966,0,0,1-2.2,1.634,8.628,8.628,0,0,1-4.243,1.553,3.947,3.947,0,0,1-.993-.078,2.386,2.386,0,0,1-.963-.388s-.122-.5-.369-1.308c.327-.036.646-.086.958-.144.246-.047.489-.1.726-.153a15.809,15.809,0,0,0,4.11-1.632,17.553,17.553,0,0,0,2.231-1.506c.42-.33.777-.638,1.067-.91.27.669.517,1.335.729,1.993-.364.338-.717.652-1.055.939",
    transform: "translate(-1257.33 -642.22)",
    fill: "#cbbfb3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3056",
    "data-name": "Path 3056",
    d: "M1503.505,733.979c-.343.147-.691.289-1.044.431-.291.12-.583.237-.879.356l-1.072-1.641c.313-.121.627-.247.944-.376.426-.178.852-.36,1.276-.556a16.411,16.411,0,0,0,5.945-4.11c.361.545.709,1.093,1.049,1.642a15.293,15.293,0,0,1-6.219,4.254m8.577-.053L1511,731.887a16.936,16.936,0,0,1-6.762,3.966c-.292.1-.58.186-.864.271q-.475.136-.935.257c.351.722.653,1.439.916,2.11.31-.108.625-.211.943-.312l.7-.22a14.567,14.567,0,0,0,7.09-4.033",
    transform: "translate(-1239.687 -601.526)",
    fill: "#90897f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2333",
    "data-name": "Group 2333",
    transform: "translate(266.346 127.471)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2332",
    "data-name": "Group 2332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2331",
    "data-name": "Group 2331",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3057",
    "data-name": "Path 3057",
    d: "M1542.707,756.712c.387.886.715,1.67.937,2.21a12.405,12.405,0,0,0,2.194-1.5c-.286-.71-.635-1.453-1-2.174a15.516,15.516,0,0,1-2.13,1.464",
    transform: "translate(-1540.895 -751.44)",
    fill: "#5f4f4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3058",
    "data-name": "Path 3058",
    d: "M1532.284,734.742c.3.582.6,1.2.887,1.819a12.782,12.782,0,0,0,1.909-1.523c-.41-.715-.774-1.312-1.012-1.7a13.534,13.534,0,0,1-1.783,1.4",
    transform: "translate(-1532.283 -733.341)",
    fill: "#5f4f4d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2336",
    "data-name": "Group 2336",
    transform: "translate(270.33 136.03)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2335",
    "data-name": "Group 2335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2334",
    "data-name": "Group 2334",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3059",
    "data-name": "Path 3059",
    d: "M1558.172,784.6a19.941,19.941,0,0,1-2.2,1.634l-.773-2.15a17.56,17.56,0,0,0,2.231-1.506s.4,1.108.741,2.022",
    transform: "translate(-1555.2 -782.576)",
    fill: "#6e605e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2339",
    "data-name": "Group 2339",
    transform: "translate(261.767 130.668)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2338",
    "data-name": "Group 2338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2337",
    "data-name": "Group 2337",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3060",
    "data-name": "Path 3060",
    d: "M1507.993,753.517c-.344.147-.691.289-1.044.43-.382-.666-.731-1.231-1.007-1.66.426-.178.852-.36,1.276-.556.257.552.518,1.153.775,1.786",
    transform: "translate(-1505.941 -751.731)",
    fill: "#c4bdbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2342",
    "data-name": "Group 2342",
    transform: "translate(263.683 134.327)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2341",
    "data-name": "Group 2341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2340",
    "data-name": "Group 2340",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3061",
    "data-name": "Path 3061",
    d: "M1518.583,774.889l-.7.22c-.292-.721-.606-1.413-.923-2.055.283-.085.572-.174.864-.271.264.694.518,1.406.759,2.106",
    transform: "translate(-1516.96 -772.782)",
    fill: "#c4bdbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2345",
    "data-name": "Group 2345",
    transform: "translate(265.494 139.168)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2344",
    "data-name": "Group 2344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2343",
    "data-name": "Group 2343",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3062",
    "data-name": "Path 3062",
    d: "M1528.746,802.7a3.971,3.971,0,0,1-.993-.078,15.259,15.259,0,0,0-.374-1.84c.246-.046.489-.1.726-.153.24.754.457,1.455.641,2.071",
    transform: "translate(-1527.379 -800.626)",
    fill: "#c4bdbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2348",
    "data-name": "Group 2348",
    transform: "translate(260.824 126.557)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2347",
    "data-name": "Group 2347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2346",
    "data-name": "Group 2346",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3063",
    "data-name": "Path 3063",
    d: "M1501.548,733.061c.438-.183.876-.371,1.312-.572a17.166,17.166,0,0,0,6.009-4.1c-.066-.1-.127-.2-.193-.3a16.42,16.42,0,0,1-5.944,4.111c-.425.2-.851.378-1.276.556-.317.129-.631.255-.944.376l.181.277q.426-.166.856-.341",
    transform: "translate(-1500.511 -728.082)",
    fill: "#655b4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3064",
    "data-name": "Path 3064",
    d: "M1512.665,754.608c.292-.087.588-.179.889-.279a17.51,17.51,0,0,0,6.814-3.946l-.224-.419a16.938,16.938,0,0,1-6.762,3.966c-.292.1-.581.187-.865.271q-.475.136-.935.257c.064.132.125.264.186.4.294-.078.592-.16.9-.246",
    transform: "translate(-1509.658 -746.16)",
    fill: "#655b4d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2351",
    "data-name": "Group 2351",
    transform: "translate(253.191 109.729)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2350",
    "data-name": "Group 2350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2349",
    "data-name": "Group 2349",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3065",
    "data-name": "Path 3065",
    d: "M1496.716,706.234q-.337-.463-.676-.917c-.08.015-.16.023-.24.041a4.424,4.424,0,0,0-2.672,1.644,6.426,6.426,0,0,0-.877,2.249,4.477,4.477,0,0,1-.913,2.117,3.609,3.609,0,0,1-2.745.784c.006,0,.01.011.016.016a9.02,9.02,0,0,1,1.052.953,3.845,3.845,0,0,0,2.4-1.043,5.284,5.284,0,0,0,1.173-2.581,5.594,5.594,0,0,1,.719-1.907,3.418,3.418,0,0,1,2.07-1.242,6.156,6.156,0,0,1,.692-.113",
    transform: "translate(-1483.031 -692.446)",
    fill: "#230d0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3066",
    "data-name": "Path 3066",
    d: "M1472.352,690.561a3.313,3.313,0,0,0,2.216-1.989c.07-.133.138-.269.206-.4a4.387,4.387,0,0,1,1.1-1.593,3.544,3.544,0,0,1,1.055-.5q-.338-.424-.674-.837a3.9,3.9,0,0,0-1,.529,5.2,5.2,0,0,0-1.391,1.945c-.065.131-.13.261-.2.388-.457.871-.961,1.364-1.5,1.462a2.965,2.965,0,0,1-1.379-.235,4,4,0,0,0-1.79-.285,2.457,2.457,0,0,0-1.061.425,9.373,9.373,0,0,1,.982.64,1.319,1.319,0,0,1,.218-.061,3.158,3.158,0,0,1,1.338.245,3.8,3.8,0,0,0,1.876.268",
    transform: "translate(-1465.968 -675.859)",
    fill: "#230d0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    "data-name": "Path 3067",
    d: "M1466.1,672.145c.16-.317.306-.64.448-.957-.291-.217-.56-.437-.816-.656l-.08.175c-.146.326-.3.663-.457.981a4.075,4.075,0,0,1-2.062,2.17,5.223,5.223,0,0,1-2.255.089,6.929,6.929,0,0,0-2.4.045c-.018,0-.035.012-.052.017a7.326,7.326,0,0,1,.438.944,6.6,6.6,0,0,1,1.914,0,6.05,6.05,0,0,0,2.7-.143,5.021,5.021,0,0,0,2.625-2.667",
    transform: "translate(-1458.109 -663.707)",
    fill: "#230d0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    "data-name": "Path 3068",
    d: "M1461.139,639.179a1.828,1.828,0,0,0,1.832-.4,1.774,1.774,0,0,0,.312-1.1l.014-.444a14.239,14.239,0,0,1-.979-1.107l-.048,1.519a1.054,1.054,0,0,1-.09.5c-.066.083-.265.156-.842.041q-1.183-.236-2.362-.481a2,2,0,0,1-1.152-.49,2.027,2.027,0,0,1-.15-1.448l.572-4.493-1.164,1.116-.413,3.249a2.88,2.88,0,0,0,.366,2.211c.018.022.036.044.055.065a2.952,2.952,0,0,0,1.681.782q1.184.245,2.369.482",
    transform: "translate(-1456.604 -631.272)",
    fill: "#230d0b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2354",
    "data-name": "Group 2354",
    transform: "translate(256.501 117.999)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2353",
    "data-name": "Group 2353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2352",
    "data-name": "Group 2352",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3069",
    "data-name": "Path 3069",
    d: "M1477.93,681.251a1.376,1.376,0,1,1,.113-1.942,1.376,1.376,0,0,1-.113,1.942",
    transform: "translate(-1475.64 -678.848)",
    fill: "#c0b1ae"
  }))))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3070",
    "data-name": "Path 3070",
    d: "M1479.639,679.731a1.376,1.376,0,1,1,.113-1.942,1.376,1.376,0,0,1-.113,1.942",
    transform: "translate(-1220.551 -559.592)",
    fill: "#beb9b3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2357",
    "data-name": "Group 2357",
    transform: "translate(257.165 117.735)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2356",
    "data-name": "Group 2356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2355",
    "data-name": "Group 2355",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3071",
    "data-name": "Path 3071",
    d: "M1481.293,677.971a1.371,1.371,0,0,1-.02,1.84,1.332,1.332,0,0,0,.112-.081,1.376,1.376,0,0,0-1.828-2.056,1.328,1.328,0,0,0-.094.1,1.371,1.371,0,0,1,1.83.195",
    transform: "translate(-1479.463 -677.327)",
    fill: "#655b4d"
  }))))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3072",
    "data-name": "Path 3072",
    d: "M1421.154,640.96l-1.242-.7,2.171-3.75,5.923-5.681s.995.959,2.548,2.6a20.072,20.072,0,0,0-6.08,5.947c-.933-.176-2.049.241-3.321,1.58",
    transform: "translate(-1173.099 -521.181)",
    fill: "#cbbfb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2360",
    "data-name": "Group 2360",
    transform: "translate(249.928 110.621)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2359",
    "data-name": "Group 2359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2358",
    "data-name": "Group 2358",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3073",
    "data-name": "Path 3073",
    d: "M1441.141,645.376a3.039,3.039,0,0,0-1.864-1.4,2.521,2.521,0,0,0-1.442.182,3.412,3.412,0,0,1,.369-1.764,7.911,7.911,0,0,1,1.484-1.942c.677-.713,1.378-1.4,2.077-2.087q.919-.9,1.833-1.8c.059-.057.118-.114.18-.169.419.422.951.973,1.576,1.632a7.376,7.376,0,0,0,.517.99,3.256,3.256,0,0,1-.4.463c-.4.4-.873.729-1.279,1.128a17.553,17.553,0,0,0-2.408,3.879,4.856,4.856,0,0,1-.647.882",
    transform: "translate(-1437.826 -636.401)",
    fill: "#c0b1ae"
  }))))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3074",
    "data-name": "Path 3074",
    d: "M114.459,469.058,106,473.729s-2.227-3.684-5.375-8.916l-.6-1.008-.621-1.038L98.1,460.6c-1.75-2.915-3.642-6.079-5.523-9.231L91.5,449.564c-1.192-2-2.362-3.976-3.477-5.852l-.244-.418q-1.126-1.907-2.04-3.827c-.614-1.269-1.159-2.532-1.647-3.778q-.369-.94-.7-1.863a60.977,60.977,0,0,1-3.474-17.29,61.565,61.565,0,0,1,15.272,15.53c.4.583.786,1.178,1.168,1.79.709,1.142,1.393,2.332,2.031,3.574.026.047.046.092.072.139.707,1.374,1.441,2.8,2.186,4.256,1,1.946,2.016,3.941,3.024,5.924l.932,1.829c1.681,3.3,3.308,6.516,4.742,9.349L111,462.2c.173.336.338.667.5.985,1.8,3.565,2.959,5.868,2.959,5.868",
    transform: "translate(-66.031 -344.133)",
    fill: "#a9a9a9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2363",
    "data-name": "Group 2363",
    transform: "translate(25.473 103.617)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2362",
    "data-name": "Group 2362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2361",
    "data-name": "Group 2361",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    "data-name": "Path 3075",
    d: "M159.65,597.934l-12.027,1.8-1.078-1.81,12.173-1.815.932,1.829",
    transform: "translate(-146.545 -596.106)",
    fill: "#bdbdbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2366",
    "data-name": "Group 2366",
    transform: "translate(17.367 87.933)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2365",
    "data-name": "Group 2365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2364",
    "data-name": "Group 2364",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3076",
    "data-name": "Path 3076",
    d: "M112.876,507.671,100.609,509.5q-.369-.94-.7-1.863l11.8-1.76q.594.874,1.168,1.79",
    transform: "translate(-99.911 -505.881)",
    fill: "#bdbdbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2369",
    "data-name": "Group 2369",
    transform: "translate(19.712 93.436)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2368",
    "data-name": "Group 2368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2367",
    "data-name": "Group 2367",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3077",
    "data-name": "Path 3077",
    d: "M128.312,541.8l-12.626,1.886-.244-.418q-1.126-1.907-2.04-3.827l12.724-1.9c.707,1.374,1.441,2.8,2.186,4.256",
    transform: "translate(-113.402 -537.542)",
    fill: "#bdbdbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2372",
    "data-name": "Group 2372",
    transform: "translate(32.074 114.794)",
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2371",
    "data-name": "Group 2371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2370",
    "data-name": "Group 2370",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3078",
    "data-name": "Path 3078",
    d: "M197.915,664.674,187.043,666.3l-.6-1.008-.621-1.038-1.3-2.162,11.246-1.677Z",
    transform: "translate(-184.518 -660.411)",
    fill: "#bdbdbd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2375",
    "data-name": "Group 2375",
    transform: "translate(16.948 77.931)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2374",
    "data-name": "Group 2374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2373",
    "data-name": "Group 2373",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3079",
    "data-name": "Path 3079",
    d: "M113.082,466.99A59.9,59.9,0,0,0,97.5,448.335a59.9,59.9,0,0,0,7.5,23.122c6.617,11.3,15.852,26.751,15.852,26.751l3.22-1.779,3.22-1.779s-8.168-16.045-14.207-27.66",
    transform: "translate(-97.5 -448.336)",
    fill: "#999"
  }))))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3080",
    "data-name": "Path 3080",
    d: "M117.2,486.434c6.167,10.988,14.681,26.077,14.681,26.077l.823-.454-25.581-46.3A201.213,201.213,0,0,0,117.2,486.434",
    transform: "translate(-88.502 -384.794)",
    fill: "#d9d9d9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3081",
    "data-name": "Path 3081",
    d: "M107.122,465.752l.232.547c.153.356.379.878.671,1.54s.651,1.465,1.071,2.381.9,1.946,1.431,3.068l.837,1.745.914,1.858c.321.634.644,1.289.985,1.952l.516,1.006.261.511.268.513c.362.686.721,1.387,1.1,2.087s.758,1.415,1.157,2.125c.784,1.426,1.606,2.862,2.418,4.3l4.756,8.477,2.181,3.9,1.95,3.5,2.908,5.246,1.1,1.993-1.134-1.972-2.977-5.207-1.982-3.483-2.207-3.89L118.8,489.5c-.807-1.444-1.625-2.882-2.406-4.313-.4-.712-.774-1.426-1.152-2.13s-.738-1.405-1.1-2.093l-.267-.514-.26-.512-.51-1.01c-.336-.667-.653-1.325-.968-1.963l-.9-1.867-.822-1.753c-.258-.564-.511-1.1-.741-1.619s-.452-1.005-.653-1.468c-.407-.923-.755-1.73-1.036-2.4s-.5-1.193-.644-1.552l-.221-.552",
    transform: "translate(-88.502 -384.794)",
    fill: "#f5f5f5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3082",
    "data-name": "Path 3082",
    d: "M119.266,485.293a201.212,201.212,0,0,0-12.143-19.541l25.581,46.3.822-.454s-8.241-15.24-14.26-26.309",
    transform: "translate(-88.503 -384.794)",
    fill: "#737373"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3083",
    "data-name": "Path 3083",
    d: "M87.791,443.3c6.406,10.84,14.965,25.038,17.492,29.224l.329-.182c-2.181-3.626-10.727-17.852-17.087-28.645a57.751,57.751,0,0,1-7.42-25.036l-1.171-2.12A60.9,60.9,0,0,0,87.791,443.3",
    transform: "translate(-66.04 -344.134)",
    fill: "#c2c2c2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3084",
    "data-name": "Path 3084",
    d: "M98.348,438.265c5.752,11.129,13.245,25.937,15.154,29.713l.329-.182c-2.2-4.368-9.661-19.171-15.428-30.364a60.884,60.884,0,0,0-18.462-20.89l-.008-.005,1.171,2.12.006,0a57.771,57.771,0,0,1,17.238,19.6",
    transform: "translate(-66.039 -344.134)",
    fill: "#dbdbdb"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3085",
    "data-name": "Path 3085",
    d: "M103.365,447.343l-.4-.722-.2-.361c-.066-.12-.137-.238-.206-.357l-.413-.712c-.139-.236-.286-.468-.428-.7-.282-.471-.587-.926-.885-1.387-.149-.23-.308-.454-.462-.681s-.307-.454-.47-.675l-.478-.669c-.161-.222-.327-.44-.491-.66l-.246-.329c-.083-.11-.168-.217-.252-.325l-.506-.648c-.347-.424-.688-.854-1.046-1.269s-.716-.83-1.078-1.242-.735-.813-1.115-1.209l-.282-.3-.285-.3c-.192-.2-.379-.4-.574-.588l-.582-.581-.59-.572-.6-.564c-.2-.187-.4-.371-.605-.556q-.609-.552-1.233-1.088l-.627-.531c-.212-.174-.421-.351-.636-.521-.425-.346-.858-.682-1.294-1.013s-.878-.653-1.331-.961l.169-.093c.019.546.057,1.092.1,1.638s.1,1.09.169,1.634c.032.272.068.544.1.815s.074.543.116.814q.122.813.265,1.623c.095.54.2,1.078.308,1.615l.17.8.181.8c.127.533.254,1.066.395,1.6.068.266.136.531.211.795s.144.529.22.792l.233.789c.077.263.163.523.245.785l.124.392.131.39.264.779c.187.515.366,1.034.567,1.544.1.255.194.513.3.767l.312.761c.1.255.214.5.322.757s.214.5.331.753c.231.5.455,1,.7,1.487.123.245.24.494.367.737l.383.729c.064.121.126.244.192.364l.2.36.4.719-.415-.711-.208-.356c-.069-.118-.133-.24-.2-.36l-.394-.723c-.131-.242-.252-.488-.378-.732-.256-.486-.487-.984-.726-1.479-.12-.247-.228-.5-.343-.75s-.229-.5-.334-.753l-.32-.76c-.107-.253-.2-.51-.306-.766-.207-.509-.39-1.027-.583-1.542l-.271-.778-.134-.39-.128-.392c-.084-.262-.173-.522-.252-.785l-.24-.789c-.079-.263-.152-.528-.228-.792s-.148-.53-.218-.8c-.144-.531-.272-1.065-.4-1.6l-.184-.8-.173-.806c-.111-.538-.217-1.078-.314-1.619s-.188-1.083-.27-1.627c-.043-.272-.079-.544-.119-.816s-.073-.545-.106-.818q-.1-.819-.174-1.641c-.048-.548-.089-1.1-.109-1.648L86,427.525l.177.121c.455.31.9.638,1.336.97s.871.673,1.3,1.021c.215.172.424.35.636.525l.628.535q.623.54,1.233,1.095c.2.187.406.371.606.56l.6.568.59.576.582.584c.2.194.383.395.574.592s.38.4.566.6c.376.4.74.813,1.107,1.222s.721.83,1.069,1.255.693.853,1.037,1.282l.5.654c.083.109.168.217.25.328l.244.332c.162.222.327.442.486.666l.472.676c.159.224.308.455.46.683s.306.456.452.689c.291.466.59.927.865,1.4.139.237.283.471.419.71l.4.719c.066.12.135.239.2.361l.191.365Z",
    transform: "translate(-71.055 -353.212)",
    fill: "#f5f5f5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3086",
    "data-name": "Path 3086",
    d: "M261.119,770.959c-.317-2.681-1.881-5.329-3.569-7.624a57.089,57.089,0,0,1-4.919-6.986c-2.194-4.166-2.692-9.006-4.931-13.064-.232-.42-.482-.831-.755-1.233l6.223-3.438c.195.445.41.875.642,1.295,2.244,4.056,6.076,7.054,8.435,11.129a57.077,57.077,0,0,1,3.3,7.883c1.045,2.65,2.453,5.384,4.554,7.079Z",
    transform: "translate(-204.021 -610.226)",
    fill: "#5c290f"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3087",
    "data-name": "Path 3087",
    d: "M270.877,771.209a20.1,20.1,0,0,0-3.479-7.673,67.368,67.368,0,0,1-4.791-7.057c-2.207-4.159-3.135-8.762-5.374-12.82q-.348-.63-.746-1.237l4.074-2.251q.3.662.651,1.29c2.243,4.056,5.813,7.2,8.159,11.281a67.374,67.374,0,0,1,3.423,7.812,20.129,20.129,0,0,0,4.477,7.122Z",
    transform: "translate(-211.904 -611.513)",
    fill: "#864321"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3088",
    "data-name": "Path 3088",
    d: "M279.968,773.468a61.726,61.726,0,0,0-3.875-7.454c-1.452-2.425-2.952-4.8-4.326-7.314-2.254-4.133-4.024-8.271-6.265-12.328q-.348-.63-.713-1.255l1.3-.719q.335.643.683,1.272c2.242,4.056,4.856,7.727,7.154,11.836,1.4,2.5,2.609,5.035,3.889,7.555a62.1,62.1,0,0,0,4.194,7.278Z",
    transform: "translate(-218.763 -615.005)",
    fill: "#935638"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3089",
    "data-name": "Path 3089",
    d: "M283.712,761.853a78.855,78.855,0,0,0-3.525-7.756c-2.336-4.088-5.7-7.346-7.94-11.4q-.348-.63-.658-1.286l-1.284.709q.333.644.681,1.273c2.242,4.057,4.916,7.7,7.217,11.8,1.4,2.5,2.592,5.045,3.86,7.571a54.779,54.779,0,0,0,4.212,7.268l1.851-1.023a23.529,23.529,0,0,1-4.415-7.156",
    transform: "translate(-223.32 -612.534)",
    fill: "#98592b"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3090",
    "data-name": "Path 3090",
    d: "M286.147,762.076c-1.243-2.541-2.389-5.106-3.8-7.607-2.308-4.1-5.113-7.669-7.355-11.726q-.348-.629-.677-1.276l-.686.379q.341.64.689,1.269c2.242,4.057,4.679,7.825,6.968,11.939,1.4,2.506,2.661,5.006,3.975,7.508s2.787,5.2,4.142,7.307l.99-.547a43.623,43.623,0,0,1-4.251-7.247",
    transform: "translate(-226.069 -612.584)",
    fill: "#b28361"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3091",
    "data-name": "Path 3091",
    d: "M236.223,724.521l-3.051,1.686,0,0-3.058,1.689a5.156,5.156,0,0,0-.83-.761,4.117,4.117,0,0,0-3.624-.669l11.727-6.479s-.015.013-.043.032a4.256,4.256,0,0,0-1.118,4.5",
    transform: "translate(-186.433 -594.839)",
    fill: "#422e24"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3092",
    "data-name": "Path 3092",
    d: "M240.785,722.867l-4.957,2.738-4.956,2.738s2.071-.682,4.021,1.67l2.583-1.427,2.583-1.427c-.953-2.9.726-4.293.726-4.293",
    transform: "translate(-190.741 -597.216)",
    fill: "#65463d"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3093",
    "data-name": "Path 3093",
    d: "M249.616,729.675,246.8,731.23l-2.648,1.463s1.2-.2,2.915,2.281l1.38-.762,1.547-.854c-1.186-2.775-.379-3.682-.379-3.682",
    transform: "translate(-201.714 -602.841)",
    fill: "#775c54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2378",
    "data-name": "Group 2378",
    transform: "translate(61.428 152.599)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2377",
    "data-name": "Group 2377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2376",
    "data-name": "Group 2376",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3094",
    "data-name": "Path 3094",
    d: "M355.5,880.775c-.293.2-.973-.264-1.519-1.045s-.752-1.581-.46-1.785.973.263,1.519,1.045.752,1.581.46,1.786",
    transform: "translate(-353.392 -877.897)",
    fill: "#331c0b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2381",
    "data-name": "Group 2381",
    transform: "translate(43.8 130.678)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2380",
    "data-name": "Group 2380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2379",
    "data-name": "Group 2379",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3095",
    "data-name": "Path 3095",
    d: "M265.083,761.359c-.074-.095-.145-.191-.217-.287-.989.292-2.018.478-2.838.725a8.334,8.334,0,0,0-1.1.428,7.56,7.56,0,0,0-.99.576,6.769,6.769,0,0,0-1.705,1.68q.056.146.111.293c2-2.667,4.571-2.711,6.74-3.415",
    transform: "translate(-257.145 -759.459)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3096",
    "data-name": "Path 3096",
    d: "M254.392,754.6a3.394,3.394,0,0,0,1.892-1.276,4.31,4.31,0,0,1,1.517-1.055,4.667,4.667,0,0,1,.906-.265q-.07-.107-.139-.215a4.042,4.042,0,0,0-.869.213,4.44,4.44,0,0,0-1.663,1.072,10.359,10.359,0,0,1-.776.734c-.755.606-1.236.4-2,.352a2.686,2.686,0,0,0-1.141.18c-.048.018-.094.04-.14.061q.08.151.158.3a2.373,2.373,0,0,1,1.1-.178,6.619,6.619,0,0,0,1.155.074",
    transform: "translate(-251.98 -751.791)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3097",
    "data-name": "Path 3097",
    d: "M268.746,771.237l-.167-.2c-1.745,2.1-5.19,1.719-7.545,3.024.036.106.069.213.1.319,2.454-1.277,5.98-.909,7.607-3.147",
    transform: "translate(-259.461 -767.695)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3098",
    "data-name": "Path 3098",
    d: "M269.53,781.985c1.759-.994,2.565-2.422,4.007-3.462l-.173-.2a29.551,29.551,0,0,0-2.817,2.5,5.28,5.28,0,0,1-3.076,1.381,16.282,16.282,0,0,0-1.963.347l.084.276c.989-.224,2.064-.208,3.085-.5a5.022,5.022,0,0,0,.853-.336",
    transform: "translate(-263.157 -773.711)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3099",
    "data-name": "Path 3099",
    d: "M267.472,777.4a30.2,30.2,0,0,0,3.71-3.131l-.147-.17a26.422,26.422,0,0,1-4.643,3.441c-.793.286-1.8-.1-2.935.358.029.093.059.186.087.279.066-.023.13-.047.2-.068,1.508-.425,2.011.417,3.726-.71",
    transform: "translate(-261.462 -770.224)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3100",
    "data-name": "Path 3100",
    d: "M315.1,859.316a7.2,7.2,0,0,0,2.143-.19,1.722,1.722,0,0,0,.961-.773c-.037-.088-.074-.176-.11-.264a1.494,1.494,0,0,1-.94.765,3.265,3.265,0,0,1-.947.122c-.347,0-.721-.027-1.12-.013a3.081,3.081,0,0,0-1.237.253c-1.239.571-1.667,2.2-3.519,3.4.059.084.119.168.177.253,2.457-1.458,2.3-3.462,4.591-3.554",
    transform: "translate(-300.188 -839.612)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3101",
    "data-name": "Path 3101",
    d: "M333.257,884.924c-.185.324-.355.661-.587,1.013a7.434,7.434,0,0,1-4.356,3.123c-.455.118-.915.2-1.364.288q-.261.048-.518.1.05.166.094.333.243-.047.488-.09c.448-.08.916-.162,1.39-.279,3.9-.964,4.864-4.079,5.558-5.137-.052-.068-.1-.138-.152-.208a6.18,6.18,0,0,0-.554.854",
    transform: "translate(-313.49 -861.077)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3102",
    "data-name": "Path 3102",
    d: "M290.325,824.622c1.336-.784,2.888-.448,4.4-1.076a2.994,2.994,0,0,0,1.252-.926c.026-.036.045-.065.066-.1-.033-.075-.064-.15-.1-.225a3.239,3.239,0,0,1-2.272,1.227c-.347.056-.719.088-1.109.132a10.943,10.943,0,0,0-1.211.181c-2.24.481-3.25,2.51-4.91,3.612.051.077.1.152.156.228,1.381-.834,2.359-2.312,3.727-3.057",
    transform: "translate(-280.452 -810.043)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3103",
    "data-name": "Path 3103",
    d: "M309.511,849.945a2.434,2.434,0,0,1,1.861-.9c.7-.04,1.379.052,1.969.064a3.7,3.7,0,0,0,1.3-.145l-.076-.2a3.978,3.978,0,0,1-1.207.062,6.62,6.62,0,0,0-3.156.127c-1.984.916-1.972,3.7-3.41,5.055l.151.2c1.255-1.04,1.557-3.1,2.572-4.26",
    transform: "translate(-297.261 -831.844)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3104",
    "data-name": "Path 3104",
    d: "M275.423,804.08c.035.081.073.162.108.243l.172-.02a7.606,7.606,0,0,0,4.713-2.68c1.023-1.292,1.436-2.49,3.591-2.993.2-.046.394-.082.579-.114-.058-.081-.116-.162-.175-.241-.148.02-.3.044-.465.076-2.326.457-2.785,1.756-3.829,3.036a7.61,7.61,0,0,1-4,2.548c-.25.06-.479.107-.7.145",
    transform: "translate(-271.348 -790.195)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3105",
    "data-name": "Path 3105",
    d: "M318.595,870.081a3.655,3.655,0,0,0,1.868-.6,3.259,3.259,0,0,0,.889-.935c.31-.471.734-1.361.932-1.662a6.44,6.44,0,0,1,3.069-2.534c-.037-.079-.074-.158-.11-.238a6.129,6.129,0,0,0-3.274,2.569c-.532.8-.829,1.9-1.706,2.51a3.654,3.654,0,0,1-1.824.6c.053.094.1.187.156.281",
    transform: "translate(-306.887 -844.592)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3106",
    "data-name": "Path 3106",
    d: "M261.214,769.38a6.374,6.374,0,0,0,.768-.321c.793-.406.909-.886,1.32-1.2.415-.348,1.032-.212,1.6-.249a3.8,3.8,0,0,0,2.224-.9c-.046-.056-.094-.112-.14-.168a4.174,4.174,0,0,1-.67.379,4.908,4.908,0,0,1-2.3.328c-.95.023-1.2.58-1.568,1-.6.719-1.844.85-2.552,1.53.03.085.06.17.089.255a3.6,3.6,0,0,1,1.231-.658",
    transform: "translate(-258.518 -763.98)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3107",
    "data-name": "Path 3107",
    d: "M313.492,865.841c.049.074.1.15.146.224a4.975,4.975,0,0,0,2.232-.881,4.784,4.784,0,0,0,.729-.731,9.532,9.532,0,0,1,1.322-1.52,4.08,4.08,0,0,1,.811-.5c.57-.27,1.142-.482,1.609-.738a3.744,3.744,0,0,0,.678-.451c-.034-.076-.067-.152-.1-.228-.935.729-2.226.838-3.227,1.629-1.279,1.017-1.359,2.363-3.55,3.022-.232.07-.442.123-.649.171",
    transform: "translate(-302.8 -842.031)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3108",
    "data-name": "Path 3108",
    d: "M323.964,881.513c.05.121.1.242.144.363a4.507,4.507,0,0,0,2.029-.021,3.813,3.813,0,0,0,1.29-.682c1.736-1.43,2.183-3.531,3.55-5.036q-.062-.1-.123-.21c-1.522,1.471-1.99,3.6-3.666,4.948a3.441,3.441,0,0,1-1.154.628,5.068,5.068,0,0,1-2.071.01",
    transform: "translate(-311.452 -854.349)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3109",
    "data-name": "Path 3109",
    d: "M320.753,875.053a4.361,4.361,0,0,0-.8.17c.038.072.076.145.113.218.8-.188,1.574-.081,2.444-.316,1.9-.514,2.009-2.55,2.851-3.824a2,2,0,0,1,1.74-.992c-.035-.068-.071-.135-.105-.2a1.894,1.894,0,0,0-1.3.4c-1.539,1.117-1.274,3.688-3.28,4.278a11.48,11.48,0,0,1-1.659.266",
    transform: "translate(-308.138 -849.535)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3110",
    "data-name": "Path 3110",
    d: "M281.1,808.882c1.349-1.073,1.277-2.149,4.286-3.491.567-.253.909-.393,1.365-.577-.036-.056-.075-.111-.112-.167-4.475,1.488-4.389,2.739-5.549,3.775-1.214.991-2.473,1.042-3.9,1.612.03.065.062.13.093.195,1.2-.4,2.659-.5,3.821-1.346",
    transform: "translate(-272.808 -795.458)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3111",
    "data-name": "Path 3111",
    d: "M273.941,789.26c1.085-1.035,1.31-2.77,2.787-3.741l-.169-.2c-1.572.945-1.862,2.733-2.869,3.674a3.219,3.219,0,0,1-1.212.691c-1.379.47-2.89.173-4.372.119l.1.329c2.03.129,4.2.6,5.733-.873",
    transform: "translate(-265.302 -779.492)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3112",
    "data-name": "Path 3112",
    d: "M298.108,838.781a3.708,3.708,0,0,0,.515-.231,4.813,4.813,0,0,0,1.728-1.523,17.094,17.094,0,0,0,1.061-2.36c.462-.874,1.087-.95,2.013-1a5.322,5.322,0,0,0,1.2-.167,4.505,4.505,0,0,0,1.641-.81c-.031-.082-.061-.164-.093-.245a4.5,4.5,0,0,1-1.626.743c-1.28.309-2.644-.228-3.475,1.3a9.272,9.272,0,0,0-.485,1.245,4.606,4.606,0,0,1-.532,1.1,4.7,4.7,0,0,1-1.573,1.47,5.1,5.1,0,0,1-.541.269l.164.213",
    transform: "translate(-289.954 -818.421)",
    fill: "#422e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3113",
    "data-name": "Path 3113",
    d: "M282.424,818.8c3.223-.759,3.342-3.578,5.5-4.19a3.453,3.453,0,0,1,1.354-.037A2.313,2.313,0,0,0,291.8,813.1c-.04-.075-.082-.15-.122-.225a2.632,2.632,0,0,1-1.186,1.254c-1.15.547-2.18-.716-4.036.94-1.307,1.161-1.813,2.88-4.2,3.434q.086.146.173.29",
    transform: "translate(-276.989 -802.259)",
    fill: "#422e24"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2384",
    "data-name": "Group 2384",
    transform: "translate(51.04 135.333)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2383",
    "data-name": "Group 2383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2382",
    "data-name": "Group 2382",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    "data-name": "Path 3114",
    d: "M298.636,785.389c-.693.485-2.3-.624-3.6-2.477s-1.783-3.747-1.09-4.232,2.3.625,3.6,2.477,1.783,3.747,1.09,4.232",
    transform: "translate(-293.631 -778.568)",
    fill: "#331c0b"
  }))))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3115",
    "data-name": "Path 3115",
    d: "M337.461,896.166l-4.488,2.479-4.488,2.479a7.725,7.725,0,0,0,8.976-4.959",
    transform: "translate(-271.387 -740.392)",
    fill: "#422e24"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3116",
    "data-name": "Path 3116",
    d: "M342.679,900.585l-3.1,1.711-3.1,1.711a4.19,4.19,0,0,0,6.195-3.422",
    transform: "translate(-277.995 -744.043)",
    fill: "#603a31"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3117",
    "data-name": "Path 3117",
    d: "M361.095,902.921l-1.431.79s.631,1.876.01,2.219a3.37,3.37,0,0,0,1.421-3.009",
    transform: "translate(-297.146 -745.973)",
    fill: "#7b5b54"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3118",
    "data-name": "Path 3118",
    d: "M337.461,896.166s-.135.088-.373.236-.579.36-.992.606c-.206.124-.43.257-.668.4s-.488.287-.749.435-.529.305-.805.458l-.835.467-.839.458c-.276.153-.552.3-.816.438s-.523.276-.767.4-.476.246-.69.355c-.429.219-.789.395-1.041.517s-.4.189-.4.189.135-.087.373-.237.579-.36.992-.606c.206-.124.43-.257.668-.4s.488-.287.749-.435.529-.305.805-.458l.835-.466.839-.458c.276-.152.552-.3.816-.438s.523-.275.767-.4.476-.246.691-.355c.428-.219.788-.4,1.041-.518s.4-.19.4-.19",
    transform: "translate(-271.387 -740.392)",
    fill: "#c5916c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2387",
    "data-name": "Group 2387",
    transform: "translate(39.224 129.037)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2386",
    "data-name": "Group 2386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2385",
    "data-name": "Group 2385",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3119",
    "data-name": "Path 3119",
    d: "M230.348,742.351l-4.691,2.592a4.225,4.225,0,0,1,4.454,1.43l2.632-1.454a8.58,8.58,0,0,0-2.395-2.568",
    transform: "translate(-225.657 -742.351)",
    fill: "#b8aaa6"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2390",
    "data-name": "Group 2390",
    transform: "translate(39.224 125.15)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2389",
    "data-name": "Group 2389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2388",
    "data-name": "Group 2388",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3120",
    "data-name": "Path 3120",
    d: "M229.281,727.137a4.118,4.118,0,0,0-3.624-.669l11.727-6.478s-.015.013-.043.033a55.586,55.586,0,0,0-8.06,7.114",
    transform: "translate(-225.657 -719.99)",
    fill: "#b8aaa6"
  }))))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3121",
    "data-name": "Path 3121",
    d: "M223.93,703.177l-16.223,8.963-.27-.931-.541-1.854L222,701.008l1.317,1.486Z",
    transform: "translate(-170.932 -579.157)",
    fill: "#979797"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2393",
    "data-name": "Group 2393",
    transform: "translate(35.963 121.851)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2392",
    "data-name": "Group 2392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2391",
    "data-name": "Group 2391",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3122",
    "data-name": "Path 3122",
    d: "M207.436,711.209l-.54-1.854L222,701.009l1.317,1.485a36.8,36.8,0,0,0-15.885,8.715",
    transform: "translate(-206.896 -701.009)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3123",
    "data-name": "Path 3123",
    d: "M225.89,709.554l-.749.239-.4.124-.462.157c-.329.113-.7.236-1.1.385l-.628.229-.666.26c-.459.172-.931.385-1.425.589-.245.108-.491.224-.741.337-.125.058-.252.113-.377.174l-.376.185-.379.186-.19.094-.188.1-.754.4c-.5.281-1,.556-1.471.855s-.941.595-1.391.885l-.648.448c-.106.074-.212.143-.314.218l-.3.22-.577.422-.53.407c-.342.258-.646.507-.918.724l-.381.305-.317.267-.6.5.576-.536.305-.281.368-.322.418-.366c.146-.131.309-.256.474-.394l.519-.425.569-.437c.387-.3.815-.6,1.252-.913l.681-.455c.116-.076.229-.157.349-.229l.359-.221c.477-.3.978-.582,1.476-.867l.761-.4.19-.1.192-.093.382-.186.379-.184c.127-.06.255-.114.381-.17.253-.111.5-.224.75-.329.5-.2.978-.4,1.443-.565.232-.084.455-.169.674-.245l.636-.21c.406-.14.786-.246,1.12-.345l.469-.138.4-.107.761-.2",
    transform: "translate(-209.465 -708.069)",
    fill: "#f5f5f5"
  }))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2396",
    "data-name": "Group 2396",
    transform: "translate(0 618.66)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2395",
    "data-name": "Group 2395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2394",
    "data-name": "Group 2394",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3124",
    "data-name": "Path 3124",
    d: "M269.848,3567.444c-5.691-.887-45.513-.9-42.836-2.716,2.694-1.8,36.715-6.185-15.252-5.525-44.371.571-65.893,3.218-69.67,4.284-1.044.3.648.691,3.662,1.125,3.155.563-22.456.115-48.723-.627s-109.666.171-95.4,3.909c14.246,3.747,49.06,4.225,87.386,1.253s61.166,1.112,54.737,1.662a81.861,81.861,0,0,0-10.55,1.42c-4.4,1.288,44,5.286,78.2,2.694s64.15-6.6,58.45-7.48",
    transform: "translate(0 -3559.136)"
  }))))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3125",
    "data-name": "Path 3125",
    d: "M659.155,1029.591c-6.778-1.53-16.364,4.77-20.482,12.52s-4.386,12.724-5.4,20,.644,40.726-5.175,47.7c-5.333,6.4,5.282,36.288,12.494,35.64,7.2-.665,11.582-27.435,16.194-53.122,3.12-17.426,6.321-28.6,8.952-38.424s2.063-22.364-6.578-24.323",
    transform: "translate(-517.721 -850.434)",
    fill: "#e38b00"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3126",
    "data-name": "Path 3126",
    d: "M694.327,1029.593c-6.778-1.528-16.364,4.77-20.482,12.52a40.435,40.435,0,0,0-4.625,14.361c4.216,8.884,21,13.939,27.482,13.432,1.488-6.041,2.912-11.177,4.2-15.99,2.621-9.829,2.063-22.364-6.577-24.323",
    transform: "translate(-552.894 -850.436)",
    fill: "#934200"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3127",
    "data-name": "Path 3127",
    d: "M656.173,1333.377c-.167,5.239-.443,10.7-1.027,15.448.179,4.881,13.913,13.159,22.63,8.833.848-4.638,1.693-9.408,2.546-14.148q.306-1.721.618-3.351c-6.867,2.217-20.981-3.026-24.766-6.782",
    transform: "translate(-541.266 -1101.605)",
    fill: "#934200"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2399",
    "data-name": "Group 2399",
    transform: "translate(109.177 178.926)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2398",
    "data-name": "Group 2398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2397",
    "data-name": "Group 2397",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3128",
    "data-name": "Path 3128",
    d: "M663.871,1031.309a8.558,8.558,0,0,0-3.521-1.716c-6.778-1.528-16.364,4.77-20.482,12.52s-4.386,12.715-5.4,20.005c-1.015,7.272.644,40.726-5.175,47.7a6.433,6.433,0,0,0-1.194,2.89c1.7-1.006,3.517-1.786,5.162-5.994,3.431-8.781,3.947-28.607,3.483-35.53s1.756-23.036,7.754-31.19c6.581-8.936,13.538-11.656,19.378-8.689",
    transform: "translate(-628.094 -1029.362)",
    fill: "#fff"
  }))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2402",
    "data-name": "Group 2402",
    transform: "translate(110.226 186.653)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2401",
    "data-name": "Group 2401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2400",
    "data-name": "Group 2400",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3129",
    "data-name": "Path 3129",
    d: "M644.431,1154.679c-2.545,2.848-6.3,4.744-10.3,6.693,2.515,10.115,8.218,21.211,12.639,20.815,7.2-.665,11.582-27.435,16.194-53.122,3.12-17.426,6.322-28.6,8.952-38.424,1.479-5.537,1.94-11.936.52-16.814-3.542-.495-6.889,14.027-10.363,25.8-4.587,15.563-10.414,46.971-17.639,55.049",
    transform: "translate(-634.128 -1073.813)"
  }))))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2405",
    "data-name": "Group 2405",
    transform: "translate(122.865 203.48)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2404",
    "data-name": "Group 2404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2403",
    "data-name": "Group 2403",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3130",
    "data-name": "Path 3130",
    d: "M706.839,1262.161c2.029-.486,3.039-2.425,3.926-4.1a35.145,35.145,0,0,0,2.008-5.567c1.117-3.8,1.99-7.69,2.736-11.6l2.183-11.8,2.025-11.838c1.394-7.882,2.924-15.828,4.9-23.641q1.579-5.844,3.35-11.612c1.3-3.819,2.553-7.639,4.016-11.4-2.1,7.741-4.195,15.5-5.929,23.33-1.778,7.835-3.15,15.746-4.557,23.641-1.423,7.9-2.86,15.793-4.668,23.619a115.541,115.541,0,0,1-3.248,11.582,36.113,36.113,0,0,1-2.408,5.508,13.634,13.634,0,0,1-1.756,2.434,4.356,4.356,0,0,1-2.579,1.432",
    transform: "translate(-706.839 -1170.616)",
    fill: "#fff"
  }))))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3131",
    "data-name": "Path 3131",
    d: "M420.241,1331.7c-1.07-9.608-7.357-14.523-21.816-21.731s-29.6-22.9-33.889-29.072-13.393.64-7.332,9.932,22.652,38.48,33.974,49.081,24.6,12.068,26.147,11,4.156-8.129,2.916-19.212",
    transform: "translate(-293.446 -1056.296)",
    fill: "#e38b00"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3132",
    "data-name": "Path 3132",
    d: "M586.063,1514.794c10.2,7.49,20.644,8.513,22.008,7.575,1.535-1.074,4.156-8.129,2.916-19.212-.827-7.422-4.8-12.051-13.21-17.1,10.831,11.288-3.474,29.165-11.714,28.735",
    transform: "translate(-484.192 -1227.748)",
    fill: "#934200"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3133",
    "data-name": "Path 3133",
    d: "M491.085,1423.711a81.348,81.348,0,0,1-10.6-6.833c1.1,1.6,1.684,3.628.3,9.391s-8.41,9.69-12.14,7.017c3.235,4.876,6.573,9.612,9.753,13.628,6.769,1.517,12.861-4.873,14-10.606s.784-10.618-1.317-12.6",
    transform: "translate(-387.184 -1170.592)",
    fill: "#934200"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3134",
    "data-name": "Path 3134",
    d: "M357.2,1290.834c1.995,3.057,5.141,8.287,8.854,14.285,5.077-.017,7.191-3.282,8.265-6.275s-.341-7.285-.341-7.285a86.856,86.856,0,0,1-9.446-10.657c-4.28-6.172-13.393.64-7.332,9.932",
    transform: "translate(-293.446 -1056.296)",
    fill: "#934200"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2408",
    "data-name": "Group 2408",
    transform: "translate(62.292 222.236)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2407",
    "data-name": "Group 2407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2406",
    "data-name": "Group 2406",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3135",
    "data-name": "Path 3135",
    d: "M401.052,1309.965c-14.459-7.213-29.6-22.9-33.889-29.072-2.672-3.862-7.234-2.643-8.8,1.074,6.437,6.735,17.17,17.2,25.917,22.026,13.453,7.408,26.591,12.072,36.152,20.184-3.133-5.218-9.237-9.152-19.382-14.212",
    transform: "translate(-358.365 -1278.523)",
    fill: "#fff"
  }))))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2411",
    "data-name": "Group 2411",
    transform: "translate(63.759 234.537)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2410",
    "data-name": "Group 2410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2409",
    "data-name": "Group 2409",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3136",
    "data-name": "Path 3136",
    d: "M366.8,1349.292c2.357,2.9,4.441,5.985,6.629,8.986l6.3,9.173c2.148,3.018,4.19,6.1,6.27,9.152,2.089,3.031,4.207,6.044,6.428,8.973,2.268,2.878,4.335,5.913,6.756,8.594a48.162,48.162,0,0,0,7.878,7.259,42.494,42.494,0,0,0,9.339,5.41,38.536,38.536,0,0,0,5.12,1.884,23.1,23.1,0,0,0,2.673.6,6.023,6.023,0,0,0,2.728.056,5.965,5.965,0,0,1-2.741.243,22.251,22.251,0,0,1-2.757-.371,35.67,35.67,0,0,1-5.354-1.492,43.588,43.588,0,0,1-9.873-5.06c-6.21-4.144-10.891-10.069-15.277-16.015-4.365-5.989-8.436-12.2-12.375-18.483-3.977-6.266-7.75-12.656-11.744-18.905",
    transform: "translate(-366.801 -1349.292)",
    fill: "#fff"
  }))))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3137",
    "data-name": "Path 3137",
    d: "M315.029,2775.061c3.973,32.963-5.034,45.542-15.129,60.922s-37.324,42.772-43.948,57.227-28.155,8.462-18.3-3.542,17.537-28.3,27.836-49.835,25.027-55.172,29.238-66.153c7.361-19.187,19.391-6.22,20.3,1.381",
    transform: "translate(-194.243 -2283.285)",
    fill: "#76421c"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2414",
    "data-name": "Group 2414",
    transform: "translate(52.198 480.389)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2413",
    "data-name": "Group 2413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2412",
    "data-name": "Group 2412",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3138",
    "data-name": "Path 3138",
    d: "M348.581,2773.66c5.789,18.522,2.323,41.825-5.524,56.6s-27.631,40.836-34.059,47.417-2.4,6.232-3.086,10.043-3.338,5.64-4.838,10.375a25.77,25.77,0,0,0-.78,3.2,14.017,14.017,0,0,0,9.51-8.091c6.624-14.455,33.85-41.843,43.948-57.227s19.1-27.959,15.129-60.923c-.912-7.6-12.942-20.563-20.3-1.394",
    transform: "translate(-300.293 -2763.668)"
  }))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2417",
    "data-name": "Group 2417",
    transform: "translate(61.708 491.775)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2416",
    "data-name": "Group 2416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2415",
    "data-name": "Group 2415",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3139",
    "data-name": "Path 3139",
    d: "M355.005,2947.323c2.076-5.35,5.35-10.171,8.521-14.928,3.287-4.7,6.82-9.212,10.337-13.717,6.961-9.051,14.659-17.537,21.143-26.71l4.719-7c1.594-2.357,3.1-4.719,4.544-7.118a69.819,69.819,0,0,0,6.718-15.154,67.948,67.948,0,0,0,2.882-16.476,161.052,161.052,0,0,0,.213-17.042c1.262,11.287,1.654,22.921-1.385,33.982a66.832,66.832,0,0,1-6.65,15.712c-2.894,4.91-6.006,9.7-9.28,14.37-6.752,9.2-14.357,17.729-21.655,26.489-3.67,4.369-7.3,8.772-10.772,13.3a88.066,88.066,0,0,0-9.335,14.3",
    transform: "translate(-355.005 -2829.173)",
    fill: "#fff"
  }))))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2420",
    "data-name": "Group 2420",
    transform: "translate(90.976 480.391)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2419",
    "data-name": "Group 2419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2418",
    "data-name": "Group 2418",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3140",
    "data-name": "Path 3140",
    d: "M532.887,2773.679c-1.744,4.523-5.256,12.9-9.506,22.677,8.1-1.569,6.824,7.025,11.616,6.752,5.388-.307,5.691,9.075,10.465,5.84,3.21-2.17,4.966-6.253,8.628-15.913a116.552,116.552,0,0,0-.9-17.976c-.912-7.6-12.946-20.567-20.3-1.381",
    transform: "translate(-523.381 -2763.676)"
  }))))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3141",
    "data-name": "Path 3141",
    d: "M550.165,2823.912c-1.855-2.954.162-11.044-1.633-14.16-3.687,2.881-6.918,3.026-11.36.746s-14.736-1.624-17.362,1.1-5.712,2.541-7.562,1.381c-3.64.755-2.984,6.543-5.784,7.771s45.615,11.9,43.7,3.163",
    transform: "translate(-418.331 -2320.828)",
    fill: "#934200"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3142",
    "data-name": "Path 3142",
    d: "M536.857,2828.018c-6.287-.6-13.091-6.974-13.9-9.752s-2.115-5.384-11.561-5.2-10.759,1.825-11.658,4.753-13.432,6.364-13.67,7.967,3.8,6.39,5.341,7.157,6.871-1.15,11.326-.106,6.045,5.524,11.786,6.07,8.751-5.038,13.18-4.459c8.935,1.159,9.161-6.428,9.161-6.428",
    transform: "translate(-401.566 -2324.082)",
    fill: "#e38b00"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3143",
    "data-name": "Path 3143",
    d: "M597.505,2827.466c.772-5.844-12.085-4.382-12.925-3.462s-.1,10.244-2.587,17.162c4.459,1.045,6.045,5.525,11.786,6.071,5.086.486,8.039-3.845,11.727-4.428,0-.009-8.772-9.5-8-15.342",
    transform: "translate(-480.829 -2332.413)",
    fill: "#934200"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3144",
    "data-name": "Path 3144",
    d: "M614.319,1845.1c-.456,4.778-.917,7.651-.456,10.7s-.848,3.994-.2,6.714-1.769,4.041-2.383,12.2c-.622,4.8-2.153,2.881-2.928,4.8s-.494,5.857-.494,5.857a12.845,12.845,0,0,0-2.7,1.939c-.686.836,0,4.075,0,4.075s-5.141,9.514-13.453,32.546-17.234,55.824-20.926,67.18-4.77,16.216-6.458,20.5-1.385,7.17,1.539,9.885,16.309,2.238,20.461,0c3.073-2.085.353-3.679,3.406-7.358s24.135-35.666,33.513-50.858,22.2-49.1,26.335-61.1,10.367-8.411,14.89-23.816-.682-33.262-.682-33.262Z",
    transform: "translate(-465.378 -1524.382)",
    fill: "#ccac7b"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2423",
    "data-name": "Group 2423",
    transform: "translate(148.294 320.721)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2422",
    "data-name": "Group 2422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2421",
    "data-name": "Group 2421",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3145",
    "data-name": "Path 3145",
    d: "M903.242,1845.1H853.778a76.032,76.032,0,0,0-.639,8.572c4.94,6,12.686,10.393,28.73,14.033,1.513.191,14.425-1.9,23.888-4.527a76.535,76.535,0,0,0-2.515-18.078",
    transform: "translate(-853.132 -1845.102)",
    fill: "#210000"
  }))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2426",
    "data-name": "Group 2426",
    transform: "translate(100.008 320.721)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2425",
    "data-name": "Group 2425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2424",
    "data-name": "Group 2424",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3146",
    "data-name": "Path 3146",
    d: "M575.345,2021c.154.166.29.332.473.5,2.916,2.724,16.309,2.238,20.461,0,3.073-2.085.354-3.679,3.406-7.358s24.135-35.666,33.513-50.858,22.2-49.1,26.335-61.1,10.367-8.411,14.89-23.816-.682-33.262-.682-33.262H647.509c9.446,26.011,3.845,44.732-3.2,40.372a47.12,47.12,0,0,0-19.544-7.152c-2.14-.252,3.427.191,8.734,5.511,2.536,2.835-3.917,1.56-9.169,3.542s3.811.981,10.729,4.561c4.207,2.174,2.758,12.123-1.27,24.11s-9.608,32.4-26.77,68.31c-11.8,24.693-16.007,33.33-18.432,35.248-2.046,1.637-8.888,3.26-13.24,1.39",
    transform: "translate(-575.345 -1845.103)",
    fill: "#210000"
  }))))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2429",
    "data-name": "Group 2429",
    transform: "translate(122.448 353.984)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2428",
    "data-name": "Group 2428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2427",
    "data-name": "Group 2427",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3147",
    "data-name": "Path 3147",
    d: "M706.342,2172.229c3.052-3.674,24.135-35.666,33.513-50.858s22.2-49.1,26.335-61.1,10.367-8.41,14.89-23.815c-3.146,7.69-10.819,13.257-13.423,17.341s-6.066,17.029-14.723,36.7-10.038,22.375-18.688,37.784-24.007,37.491-26.143,40.547-3.615,4.527-3.658,6.215c-.026,1.18.111,1.807.072,2.468.3-1.351-.183-2.873,1.825-5.286",
    transform: "translate(-704.442 -2036.458)",
    fill: "#fff"
  }))))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2432",
    "data-name": "Group 2432",
    transform: "translate(152.331 355.339)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2431",
    "data-name": "Group 2431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2430",
    "data-name": "Group 2430",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3148",
    "data-name": "Path 3148",
    d: "M904.5,2070.8s-.742-12.89-1.773-14.937-19.25-10.239-24.422-11.607c3.419,1.24,9.468,4.868,14.426,8.158a56.2,56.2,0,0,0-6.45-.443c-7.208-.184-11.471.417-9.4.413s14.762-.17,20.158,2.988a29.257,29.257,0,0,1,3.555,2.826c1.675,1.862,3.909,12.6,3.909,12.6",
    transform: "translate(-876.356 -2044.258)"
  }))))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3149",
    "data-name": "Path 3149",
    d: "M78.45,3431.776c-2.9,2.157-4.561,3.35-8.427,6.116s-6.684,3.121-11.765,5.764c-4.736,2.476-4.258,1.922-7.361,2.17s-4.8.716-5.993.746c-1.006.025-4.118,2.489-5.332,5.153a21.471,21.471,0,0,0,.776,5.29c.188.158,19.3,3.167,25.141,2.345s9.442-2.763,13.628-2.916c4.2-.158,5,3.027,6.582,3.027s11.428-1.117,11.97-2.157a37.456,37.456,0,0,0,1.931-7.464c.273-2.042-1.424-8.3-1.658-12.55-.059-1.224,2.067-.759,2.127-2.49a6.292,6.292,0,0,1,1.573-4.834c1.705-2.272-8.086.1-12.3.627s-4.677-4.8-5.964-2.81-1.85,1.7-4.924,3.982",
    transform: "translate(-32.685 -2831.595)",
    fill: "#76421c"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2435",
    "data-name": "Group 2435",
    transform: "translate(31.515 597.414)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2434",
    "data-name": "Group 2434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2433",
    "data-name": "Group 2433",
    clipPath: "url(#clip-path-63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3150",
    "data-name": "Path 3150",
    d: "M207.257,3438.382c-.925,2.276.827,2.937.349,5.549-.695,3.806-3.338,5.64-4.838,10.375s-.469,6.953-3.935,6.659c-3.35-.294-7.489,3.965-17.528,6.407.477-.022.917-.069,1.287-.115,5.848-.823,9.442-2.762,13.628-2.916,4.2-.157,5,3.027,6.581,3.027s11.428-1.117,11.97-2.157a37.444,37.444,0,0,0,1.931-7.463c.273-2.042-1.424-8.3-1.658-12.55-.059-1.224,2.067-.76,2.127-2.489a6.291,6.291,0,0,1,1.573-4.834c1.6-2.136-6.961-.167-11.488.507",
    transform: "translate(-181.305 -3436.907)"
  }))))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2438",
    "data-name": "Group 2438",
    transform: "translate(6.877 618.254)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2437",
    "data-name": "Group 2437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2436",
    "data-name": "Group 2436",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3151",
    "data-name": "Path 3151",
    d: "M65.486,3566.312c5.848-.823,9.442-2.762,13.628-2.915,4.2-.158,5,3.026,6.581,3.026s11.428-1.116,11.97-2.156A37.471,37.471,0,0,0,99.6,3556.8c-13.722,4.083-18.572-1.381-26.723,2.156-6.8,2.95-22.12,2.238-33.3-.281a21.488,21.488,0,0,0,.776,5.291c.188.157,19.3,3.167,25.141,2.344",
    transform: "translate(-39.56 -3556.802)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2443",
    "data-name": "Group 2443",
    transform: "translate(97.913 320.721)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2442",
    "data-name": "Group 2442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2441",
    "data-name": "Group 2441",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2440",
    "data-name": "Group 2440",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2439",
    "data-name": "Group 2439",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616",
    "data-name": "Rectangle 616",
    width: 106.359,
    height: 179.115,
    transform: "translate(-0.658 0)",
    fill: "url(#radial-gradient)"
  }))))))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3153",
    "data-name": "Path 3153",
    d: "M1175.617,2760.975c5.572,20.9,10.03,30.41,10.218,53.838s-3.41,43.992-4.723,58.48-.047,18.189-6.854,17.495-8.261-1.492-8.977-18.117-9.83-52.611-11.791-64.035,2.571-25.239,2.034-38.638,2.007-20.209,8.465-20.209c5.324,0,9.425,2.915,11.629,11.185",
    transform: "translate(-952.578 -2271.813)",
    fill: "#76421c"
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2446",
    "data-name": "Group 2446",
    transform: "translate(206.624 477.977)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2445",
    "data-name": "Group 2445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2444",
    "data-name": "Group 2444",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3154",
    "data-name": "Path 3154",
    d: "M1193.485,2749.79a6.584,6.584,0,0,0-4.787,1.854l3.26,17.563c9.084,19.633,13.385,68.5,11.77,87.428-.976,11.454-.7,23.564-2.98,33.709a25.4,25.4,0,0,0,3.005.444c6.807.694,5.546-3,6.854-17.495s4.911-35.043,4.724-58.48-4.647-32.942-10.218-53.838c-2.2-8.27-6.3-11.185-11.629-11.185",
    transform: "translate(-1188.698 -2749.79)"
  }))))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2449",
    "data-name": "Group 2449",
    transform: "translate(223.04 489.162)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2448",
    "data-name": "Group 2448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2447",
    "data-name": "Group 2447",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3155",
    "data-name": "Path 3155",
    d: "M1288.63,2926.457c-.038-4.765.337-9.51.559-14.245.311-4.741.72-9.455.984-14.17l.78-14.131q.313-7.04.226-14.093a154.122,154.122,0,0,0-2.332-27.861c-.785-4.612-1.854-9.208-2.95-13.819-.955-4.651-2.046-9.284-2.763-14,2.392,9.169,5.4,18.181,7.447,27.439a125.414,125.414,0,0,1,2.762,28.24,283.217,283.217,0,0,1-1.551,28.386c-.921,9.434-2.255,18.82-3.163,28.253",
    transform: "translate(-1283.136 -2814.14)",
    fill: "#fff"
  }))))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2452",
    "data-name": "Group 2452",
    transform: "translate(201.816 477.977)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2451",
    "data-name": "Group 2451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2450",
    "data-name": "Group 2450",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3156",
    "data-name": "Path 3156",
    d: "M1189.221,2786.265c-1.82-7.681-4.254-15.145-6.961-25.29-2.2-8.27-6.3-11.185-11.629-11.185-6.458,0-9,6.808-8.465,20.209a102.282,102.282,0,0,1-1.13,16.731c6.526,7.417,15.461,13.56,17.848,12.9,2.685-.729,6.249-5.942,10.337-13.368",
    transform: "translate(-1161.037 -2749.79)"
  }))))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3157",
    "data-name": "Path 3157",
    d: "M1146.824,2844.271c2.826-1.587,1.326-8.765-.46-11.876-3.692,2.877-6.927,3.022-11.369.75s-14.723-1.64-17.358,1.092-5.708,2.54-7.561,1.389c-3.632.755-2.976,6.535-5.784,7.771s23.086,11.838,42.533.875",
    transform: "translate(-912.165 -2339.532)",
    fill: "#934200"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3158",
    "data-name": "Path 3158",
    d: "M1143.767,2839.344c-6.309,0-13.692-5.691-14.766-8.385s-2.609-5.154-12-4.075-10.542,2.843-11.16,5.844-7,7.077-12.843,5.082c0,0,.072,2.536,0,4.152s4.382,6,6,6.616,4-1.54,8.538-.921,6.544,4.915,12.311,4.915,8.922-5.456,13.385-5.307a10.019,10.019,0,0,0,10.533-7.92",
    transform: "translate(-903.012 -2335.293)",
    fill: "#e38b00"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3159",
    "data-name": "Path 3159",
    d: "M1188.94,2857.946c4.254,0,7.089-2.962,10.069-4.458-3.308-4.54-6.031-12.025-6.13-17.7s-12.017-.985-11.94,2.4.541,7.3-4.31,14.847c4.54.614,6.544,4.915,12.311,4.915",
    transform: "translate(-972.104 -2340.668)",
    fill: "#934200"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3160",
    "data-name": "Path 3160",
    d: "M1186.748,3450.411c1.453-.853,1.8-5.768-1.88-11.774s-3.968-5.766-3.205-7.609-1.568-4.394-.968-8.005-4.8-7.843-9.263-7.843a6.578,6.578,0,0,0-6.569,7.221c.333,3.311.346,7.78-1.194,8.7s-10.84,7.924-11.151,13.155,2.144,6.922,2.545,7.076,27.874,1.309,31.685-.921",
    transform: "translate(-952.161 -2821.543)",
    fill: "#76421c"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2455",
    "data-name": "Group 2455",
    transform: "translate(220.789 593.85)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2454",
    "data-name": "Group 2454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2453",
    "data-name": "Group 2453",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3161",
    "data-name": "Path 3161",
    d: "M1278.9,3432.042c.771-1.85-1.568-4.395-.968-8.006.521-3.132-3.474-6.726-7.455-7.629-.456,9.433-.695,12.085,1.846,15.9,1.884,2.818,7.451,12.255,6.744,20.094a14.449,14.449,0,0,0,4.919-.976c1.453-.853,1.8-5.768-1.88-11.774s-3.969-5.767-3.206-7.609",
    transform: "translate(-1270.192 -3416.407)"
  }))))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3162",
    "data-name": "Path 3162",
    d: "M1183.139,3535.86a149.569,149.569,0,0,1-22.925,1.965,59,59,0,0,1-12.319-1.965s-1.4-5.542-1.288-8.078,3.436-7.268,4.941-8.312,7.229-3.538,10.231-3.09,19.6,9.438,20.733,11.748.627,7.732.627,7.732",
    transform: "translate(-947.295 -2905.108)",
    fill: "#76421c"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2458",
    "data-name": "Group 2458",
    transform: "translate(199.306 621.244)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2457",
    "data-name": "Group 2457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2456",
    "data-name": "Group 2456",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3163",
    "data-name": "Path 3163",
    d: "M1147.9,3583.51a59.047,59.047,0,0,0,12.319,1.965,149.6,149.6,0,0,0,22.925-1.965,26.118,26.118,0,0,0-.213-6.48c-1.27,2.558-19.383-1.219-24.443-2.446s-10.388-.307-11.876.848c-.115,2.537,1.288,8.078,1.288,8.078",
    transform: "translate(-1146.601 -3574.001)"
  }))))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2461",
    "data-name": "Group 2461",
    transform: "translate(200.601 629.512)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2460",
    "data-name": "Group 2460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2459",
    "data-name": "Group 2459",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3164",
    "data-name": "Path 3164",
    d: "M1164.375,3622.289c-6.6-1.292-9.579-.678-10.328.521a59.037,59.037,0,0,0,12.319,1.964,146.552,146.552,0,0,0,19.865-1.5,74.9,74.9,0,0,1-21.855-.989",
    transform: "translate(-1154.047 -3621.569)"
  }))))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2464",
    "data-name": "Group 2464",
    transform: "translate(201.244 612.271)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2463",
    "data-name": "Group 2463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2462",
    "data-name": "Group 2462",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3165",
    "data-name": "Path 3165",
    d: "M1182.936,3529.973c11.484,6.855-19.37-4.382-25.035-.229-.878-.405,2.336-4.578,4.548-5.329s7.507-2.617,9.161-1.858a54.575,54.575,0,0,1,5.346,2.493c.618.52-3.56-.865-6.356-.741-2.8.106,4.928,1.245,12.336,5.665",
    transform: "translate(-1157.753 -3522.379)",
    fill: "#fff"
  }))))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3166",
    "data-name": "Path 3166",
    d: "M937.6,1845.1s.09,22.951.435,27.567,4.8,14.272,4.8,14.272a86.982,86.982,0,0,1,9.31,3.908c.6.345.55,2.933,1.24,5.124s7.046,47.465,11.675,68.843,10.171,54.383,13.249,59.35,17.554,5.427,20.683-6.424c3-11.381,4.007-13.4,3.321-15.942s-1.735-.921-1.509-12.11-.06-69.469-1.117-81.793c-1.036-12.319-2.144-11.846-1.991-18.457s1.309-7.528-.546-10.571-5.768-24.413-7.69-33.765Z",
    transform: "translate(-774.626 -1524.382)",
    fill: "#ccac7b"
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2467",
    "data-name": "Group 2467",
    transform: "translate(162.977 320.721)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2466",
    "data-name": "Group 2466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2465",
    "data-name": "Group 2465",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3167",
    "data-name": "Path 3167",
    d: "M1002.311,2001.8c-.7-2.536-1.735-.92-1.509-12.11s-.06-69.469-1.117-81.793c-1.036-12.319-2.144-11.846-1.991-18.457s1.309-7.528-.546-10.571c-1.4-2.306-4-15.163-6.006-25.312-.162-.831-.32-1.633-.473-2.421-.128-.6-.235-1.189-.354-1.756-.021-.115-.046-.239-.068-.35-.285-1.454-.55-2.779-.789-3.926H937.6s.042,10.325.17,18.517a98.935,98.935,0,0,0,13.884,4.088c1.565.192,15.325-2.042,24.843-4.8,4.229-1.2,6.019-1.828,6.019-1.828l-5.87,3.691c.5,6,.921,8.674,1.155,10.23,4.838-.076,6.872,1.036,6.872,1.036s-2.443.2-6.5.933-22.337,5.064-21.33,5.448c3.308.234,22.128-1.7,22.264-1.1,1.56,7.115,3.964,20.734,3.964,20.734s6.322,87.935,8.384,101.657,7.618,12.5,1.462,19.263c-3.078,3.38-7.869,3.824-11.892,3.424,5.311,2.481,15.405,1.015,17.959-8.653,3-11.381,4.007-13.4,3.321-15.943",
    transform: "translate(-937.603 -1845.102)",
    fill: "#210000"
  }))))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2470",
    "data-name": "Group 2470",
    transform: "translate(185.16 352.136)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2469",
    "data-name": "Group 2469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2468",
    "data-name": "Group 2468",
    clipPath: "url(#clip-path-75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3168",
    "data-name": "Path 3168",
    d: "M1089.084,2025.854c-7.533,1.15-22.213,4.68-23.863,5.183,2.477-.371,16.28-3.137,18.117-3.329,1.82-.187,7.426-2.106,5.746-1.854",
    transform: "translate(-1065.221 -2025.831)"
  }))))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2473",
    "data-name": "Group 2473",
    transform: "translate(219.662 344.371)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2472",
    "data-name": "Group 2472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2471",
    "data-name": "Group 2471",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3169",
    "data-name": "Path 3169",
    d: "M1270.228,2102.095c.239-11.2-.06-69.47-1.117-81.793-1.036-12.319-2.144-11.846-1.991-18.458s1.309-7.528-.546-10.571c-.72-1.189-1.748-5.162-2.86-10.116a91.28,91.28,0,0,0,3.252,12.95c.192.849-.772,7.123-1.006,8.658s1.083,9.54,1.62,18,1.53,33.227,1.385,53.075-.921,36.3-.333,38.231,1.56,1.224,2.1,3.231-1,6.765-2.033,13.748c2.78-10.4,3.7-12.393,3.035-14.848-.7-2.536-1.735-.92-1.509-12.11",
    transform: "translate(-1263.713 -1981.157)",
    fill: "#fff"
  }))))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2476",
    "data-name": "Group 2476",
    transform: "translate(164.806 354.022)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2475",
    "data-name": "Group 2475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2474",
    "data-name": "Group 2474",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3170",
    "data-name": "Path 3170",
    d: "M976.688,2052.793c-5.38-1.543-23.151-7.541-24.131-8.116-.964-.571-4.331-7.775-4.434-8,1.424,4.233,3.4,8.538,3.4,8.538a86.952,86.952,0,0,1,9.31,3.909c2.4.958,21.245,5.2,15.853,3.666",
    transform: "translate(-948.123 -2036.68)"
  }))))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3171",
    "data-name": "Path 3171",
    d: "M910.754,1843.26s-5.3,3.871-29.34,4.7-31.5-2.408-36.63-5.089c-.917.32-2.183.337-1.948,1.454s-.64,5.141-.478,6.177c.144,1.044,8.7,7.937,22.477,9.4s40.555-4.267,47.623-8.09c.912-.678,1.3-.985.836-2.754a38.6,38.6,0,0,1-1.079-5.081c0-.686-1.462-.716-1.462-.716",
    transform: "translate(-695.92 -1522.538)",
    fill: "#372620"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3172",
    "data-name": "Path 3172",
    d: "M1179.739,1855.554s1.356,6.424.934,9.876c.345.388,3.112-.635,3.112-.635s-.58-8.726-1.151-10.337a2.309,2.309,0,0,0-1.586-.375,8.03,8.03,0,0,0-1.888.546c-.2.213.366.443.579.925",
    transform: "translate(-974.161 -1531.784)",
    fill: "#ccac7b"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3173",
    "data-name": "Path 3173",
    d: "M1063.391,1869.672s.588,7.775.375,11.791c.315.448,3.128-.255,3.128-.255s.022-10.086-.452-11.927c-.716-.627-3.227-.162-3.052.392",
    transform: "translate(-878.542 -1544.108)",
    fill: "#ccac7b"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3174",
    "data-name": "Path 3174",
    d: "M888.889,1855.142s-.4,7.767-.192,11.786c-.252.439-2.558-.6-2.558-.6s-.119-10.073.248-11.914c.579-.614,2.643.179,2.5.724",
    transform: "translate(-732.093 -1531.893)",
    fill: "#ccac7b"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3175",
    "data-name": "Path 3175",
    d: "M806.593,1092.99c.269-3.934,1.744-4.045,1.3-6.2-1.624-8.082-6.888-17.371-6.513-30.231.516-17.605,6.484-24.268,9.9-33.662,4.617-12.694,12.154-22.712,14.92-39.26s-1.688-38.433-7.92-42.846-21.91-5.842-43-6.036c-21.612-.194-49.613,11.7-52.615,15.44-3,3.758.231,4.638-1.611,9.932s-3.491,20.634-4.386,31.256c-1.385,16.407.836,13.977,4.915,24.873,4.715,12.549,6.006,12.711,8.005,17.23,1.27,2.856,4.19,20.235,6.151,37.222.652,5.669-.111,12.285-.154,16.7-.017,1.927,2.289,4.173,3.739,5.588,11.816,11.471,66.882,5.456,67.261,0",
    transform: "translate(-591.76 -772.269)",
    fill: "#934200"
  })), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2479",
    "data-name": "Group 2479",
    transform: "translate(124.503 162.481)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2478",
    "data-name": "Group 2478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2477",
    "data-name": "Group 2477",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3176",
    "data-name": "Path 3176",
    d: "M818.286,940.788c-6.236-4.412-21.91-5.842-43-6.036-21.612-.194-49.614,11.7-52.615,15.44s.231,4.638-1.611,9.932-3.491,20.634-4.386,31.256c-1.385,16.407.836,13.978,4.915,24.873,4.715,12.55,6.006,12.711,8.005,17.23,1.27,2.856,4.19,20.235,6.151,37.222.652,5.67-.111,12.285-.154,16.7a2.647,2.647,0,0,0,.119.78,4.686,4.686,0,0,0,.23.656c.069.136.145.264.218.4.059.1.111.209.171.307.085.136.17.264.264.392a3.611,3.611,0,0,0,.221.307c.09.128.188.252.286.375.085.1.174.209.264.311.1.119.192.23.3.349s.2.209.285.32.2.2.286.3c.115.115.235.226.35.341a2.332,2.332,0,0,0,.226.234c.183.183.358.349.52.511a11.744,11.744,0,0,0,1.147.951c.222.167.477.311.712.465.2.124.38.248.576.363.345.2.716.388,1.087.571.107.056.222.111.328.166.439.2.886.392,1.356.584a46.9,46.9,0,0,0,10.643,2.558c-1.888-1.539-3.551-2.553-5.128-3.794-2.089-1.654-3.662-2.664-4.442-3.73.439-4.169.294-9.877-.379-18.053-1.953-23.59.017-46.549.712-49.094.678-2.536,10.367,44.656,14.873,55.04a131.281,131.281,0,0,0,11.624,20.478c17.072-.32,33.949-3.491,34.153-6.5.269-3.934,1.743-4.045,1.3-6.2-1.624-8.082-6.888-17.371-6.513-30.231.516-17.605,6.483-24.267,9.9-33.663,4.617-12.694,12.154-22.711,14.92-39.26s-1.688-38.433-7.92-42.847",
    transform: "translate(-716.263 -934.75)"
  }))))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3177",
    "data-name": "Path 3177",
    d: "M730.206,967.625c-1.454.462-6.2,4.478-6.083,9.207.119,4.661,3.7,10.672,14.4,10.846.158,0,.362.183.124.569-1.36,2.321-6.437,11.942-10.491,33.008-4.727,24.579-2.421,66.716-2.421,89.649,0,3.12.46,4.39-2.651,7.383s-5.426,3.005-6.006,2.895-2.191-3.815-2.882-4.966,2.656-18.918,2.422-29.771-5.418-24.114-9.109-35.418-6.927-25.274-7.388-31.613,1.258-20.423,3.231-27.929c2.848-10.844-.576-10.612,2.3-13.383s17.252-9.807,24.55-10.478",
    transform: "translate(-578.362 -799.43)",
    fill: "#ccac7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2484",
    "data-name": "Group 2484",
    transform: "translate(121.684 168.691)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2483",
    "data-name": "Group 2483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2482",
    "data-name": "Group 2482",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2481",
    "data-name": "Group 2481",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2480",
    "data-name": "Group 2480",
    clipPath: "url(#clip-path-80)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_630",
    "data-name": "Rectangle 630",
    width: 39.23,
    height: 153.172,
    transform: "translate(-0.388 0)",
    fill: "url(#radial-gradient-2)"
  }))))))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2487",
    "data-name": "Group 2487",
    transform: "translate(141.53 168.707)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2486",
    "data-name": "Group 2486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2485",
    "data-name": "Group 2485",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3179",
    "data-name": "Path 3179",
    d: "M832.85,990.109a22.657,22.657,0,0,1-5.179-.646,16.672,16.672,0,0,1-1.969-.631c-5.605-2.044-8.18-5.648-8.726-9.455a7.947,7.947,0,0,1,4.646-8.811c-1.3.311-2.711.718-4.16,1.215-2.127,1.5-2.562,2.884-3.069,5.235a11.925,11.925,0,0,0,3.7,10.5c3.287,3.11,9.562,5.245,13.832,5.134.452-.9.815-1.56,1.054-1.972.238-.386.034-.567-.124-.569",
    transform: "translate(-814.216 -970.567)",
    fill: "#ffd890"
  }))))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2490",
    "data-name": "Group 2490",
    transform: "translate(138.718 188.248)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2489",
    "data-name": "Group 2489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2488",
    "data-name": "Group 2488",
    clipPath: "url(#clip-path-82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3180",
    "data-name": "Path 3180",
    d: "M805.889,1136.128c-.874,11.369-1.049,36.4-1.45,42.465s-.733,28.547-1.24,31.766-3.935,6.138-5.158,6.138c.58.111,2.886.111,6.006-2.894s2.651-4.262,2.651-7.383c0-22.933-2.306-65.07,2.421-89.649,4.054-21.067,9.13-30.687,10.491-33.008.239-.386.034-.567-.124-.57a93.462,93.462,0,0,0-8.129,19.157c-3.568,11.65-4.586,22.614-5.469,33.978",
    transform: "translate(-798.041 -1082.993)",
    fill: "#210000"
  }))))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2493",
    "data-name": "Group 2493",
    transform: "translate(140.726 290.568)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2492",
    "data-name": "Group 2492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2491",
    "data-name": "Group 2491",
    clipPath: "url(#clip-path-83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3181",
    "data-name": "Path 3181",
    d: "M811.5,1673.578c0,1.087-.422,1.961-.951,1.961s-.954-.874-.954-1.961.43-1.953.954-1.953.951.878.951,1.953",
    transform: "translate(-809.592 -1671.626)"
  }))))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3182",
    "data-name": "Path 3182",
    d: "M809.283,1669.538c0,1.031-.4,1.875-.912,1.875s-.912-.844-.912-1.875.4-1.884.912-1.884.912.839.912,1.884",
    transform: "translate(-667.104 -1377.777)",
    fill: "#934200"
  })), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2496",
    "data-name": "Group 2496",
    transform: "translate(141.007 275.64)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2495",
    "data-name": "Group 2495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2494",
    "data-name": "Group 2494",
    clipPath: "url(#clip-path-83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3183",
    "data-name": "Path 3183",
    d: "M813.115,1587.7c0,1.083-.422,1.961-.946,1.961s-.959-.878-.959-1.961.427-1.952.959-1.952.946.874.946,1.952",
    transform: "translate(-811.21 -1585.746)"
  }))))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3184",
    "data-name": "Path 3184",
    d: "M810.905,1583.649c0,1.04-.405,1.88-.913,1.88s-.917-.84-.917-1.88.405-1.875.917-1.875.913.84.913,1.875",
    transform: "translate(-668.44 -1306.825)",
    fill: "#934200"
  })), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2499",
    "data-name": "Group 2499",
    transform: "translate(147.427 201.101)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2498",
    "data-name": "Group 2498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2497",
    "data-name": "Group 2497",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3185",
    "data-name": "Path 3185",
    d: "M850.052,1158.893c0,1.087-.422,1.957-.954,1.957s-.955-.87-.955-1.957.426-1.961.955-1.961.954.878.954,1.961",
    transform: "translate(-848.142 -1156.932)"
  }))))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3186",
    "data-name": "Path 3186",
    d: "M847.818,1154.868c0,1.031-.409,1.871-.921,1.871s-.912-.84-.912-1.871.414-1.884.912-1.884.921.84.921,1.884",
    transform: "translate(-698.933 -952.569)",
    fill: "#934200"
  })), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2502",
    "data-name": "Group 2502",
    transform: "translate(140.491 258.834)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2501",
    "data-name": "Group 2501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2500",
    "data-name": "Group 2500",
    clipPath: "url(#clip-path-86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3187",
    "data-name": "Path 3187",
    d: "M810.622,1491.509c0,1.347-.533,2.438-1.19,2.438s-1.189-1.092-1.189-2.438.533-2.434,1.189-2.434,1.19,1.091,1.19,2.434",
    transform: "translate(-808.243 -1489.074)"
  }))))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3188",
    "data-name": "Path 3188",
    d: "M808.365,1486.461c0,1.292-.511,2.336-1.143,2.336s-1.138-1.044-1.138-2.336.512-2.34,1.138-2.34,1.143,1.049,1.143,2.34",
    transform: "translate(-665.969 -1226.147)",
    fill: "#934200"
  })), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2505",
    "data-name": "Group 2505",
    transform: "translate(141.45 238.933)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2504",
    "data-name": "Group 2504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2503",
    "data-name": "Group 2503",
    clipPath: "url(#clip-path-87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3189",
    "data-name": "Path 3189",
    d: "M816.135,1377c0,1.347-.537,2.438-1.194,2.438s-1.181-1.091-1.181-2.438.525-2.43,1.181-2.43,1.194,1.091,1.194,2.43",
    transform: "translate(-813.76 -1374.576)"
  }))))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3190",
    "data-name": "Path 3190",
    d: "M813.837,1371.938c0,1.287-.507,2.345-1.138,2.345s-1.147-1.057-1.147-2.345.512-2.34,1.147-2.34,1.138,1.048,1.138,2.34",
    transform: "translate(-670.485 -1131.53)",
    fill: "#934200"
  })), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2508",
    "data-name": "Group 2508",
    transform: "translate(143.135 218.148)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2507",
    "data-name": "Group 2507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2506",
    "data-name": "Group 2506",
    clipPath: "url(#clip-path-88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3191",
    "data-name": "Path 3191",
    d: "M825.831,1257.439c0,1.338-.533,2.43-1.189,2.43s-1.193-1.091-1.193-2.43.537-2.438,1.193-2.438,1.189,1.087,1.189,2.438",
    transform: "translate(-823.449 -1255.001)"
  }))))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3192",
    "data-name": "Path 3192",
    d: "M823.58,1252.4c0,1.3-.516,2.345-1.147,2.345s-1.142-1.049-1.142-2.345.511-2.332,1.142-2.332,1.147,1.04,1.147,2.332",
    transform: "translate(-678.531 -1032.781)",
    fill: "#934200"
  })), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2511",
    "data-name": "Group 2511",
    transform: "translate(143.953 315.913)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2510",
    "data-name": "Group 2510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2509",
    "data-name": "Group 2509",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3193",
    "data-name": "Path 3193",
    d: "M831.775,1822.249c11.816,11.471,66.882,5.456,67.261,0a10.021,10.021,0,0,1,.887-3.692,44.48,44.48,0,0,1-6.117,3.253c-8.112,3.542-21.757,3.934-25.594,3.137-4.732-.98-5.371-.017-12.707-1.833s-16.394-2.856-18.675-4.506c-.294,1.091.022,1.876,2.131,3.253,2.587,1.684-.516.848-3.286,0-2.025-.614-5.622-3.977-7.52-4.42.469,1.731,2.361,3.581,3.619,4.808",
    transform: "translate(-828.156 -1817.441)"
  }))))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2514",
    "data-name": "Group 2514",
    transform: "translate(153.163 317.903)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2513",
    "data-name": "Group 2513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2512",
    "data-name": "Group 2512",
    clipPath: "url(#clip-path-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3194",
    "data-name": "Path 3194",
    d: "M900.756,1837.573c-3.67-.418-9.612-5.427-13.773-6.441s-5.367-1.756-5.831-2.238c-.132.111,1,1.3,4.011,2.293a21.96,21.96,0,0,1,6.377,3.163,26.457,26.457,0,0,0,6.16,3.1c1.854.61,5.179.362,3.056.124",
    transform: "translate(-881.141 -1828.893)"
  }))))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3195",
    "data-name": "Path 3195",
    d: "M845.483,937.987c7.536-1.309,19.319-1.385,23.815-.23s7.6,10.1-8.777,19.012-23.364,8.466-29.106,8.342-12.916-5.735-14.753-9.5-.614-8.2,3.922-10.638,11.9-4.725,24.9-6.982",
    transform: "translate(-674.031 -774.082)",
    fill: "#fcba8e"
  })), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2517",
    "data-name": "Group 2517",
    transform: "translate(141.813 162.861)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2516",
    "data-name": "Group 2516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2515",
    "data-name": "Group 2515",
    clipPath: "url(#clip-path-91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3196",
    "data-name": "Path 3196",
    d: "M845.483,937.987c7.536-1.309,19.319-1.385,23.815-.23s7.6,10.1-8.777,19.012-23.364,8.466-29.106,8.342-12.916-5.735-14.753-9.5-.614-8.2,3.922-10.638,11.9-4.725,24.9-6.982",
    transform: "translate(-815.844 -936.944)"
  }))))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3197",
    "data-name": "Path 3197",
    d: "M963.46,1081.06a12.9,12.9,0,0,1-2.74,4.156,88.2,88.2,0,0,1-30.56,5.844c-5.78-1.228-16.3-16.923-22.805-38.923s-13.252-64.755-4.16-95.265c12.1-1.618,21.22-6.983,26.527-12.577,6.991-7.372,6.288-11.266,2.033-13.1,0,0-.188-.59,7.375-.763s23.18-.443,27.1,2.556,13.692,10.38,13.692,35.773c0,20.614-16.232,48.126-19.8,61.613-3.6,13.607-3.666,23.151-3.052,28.615s7.327,20.048,6.394,22.072",
    transform: "translate(-742.549 -768.622)",
    fill: "#ccac7b"
  })), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2520",
    "data-name": "Group 2520",
    transform: "translate(174.047 290.568)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2519",
    "data-name": "Group 2519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2518",
    "data-name": "Group 2518",
    clipPath: "url(#clip-path-92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3198",
    "data-name": "Path 3198",
    d: "M1005.206,1673.578a1.959,1.959,0,1,1-1.956-1.953,1.96,1.96,0,0,1,1.956,1.953",
    transform: "translate(-1001.289 -1671.626)"
  }))))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3199",
    "data-name": "Path 3199",
    d: "M1005.045,1669.538a1.878,1.878,0,1,1-1.871-1.884,1.872,1.872,0,0,1,1.871,1.884",
    transform: "translate(-827.242 -1377.777)",
    fill: "#934200"
  })), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2523",
    "data-name": "Group 2523",
    transform: "translate(168.766 275.64)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2522",
    "data-name": "Group 2522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2521",
    "data-name": "Group 2521",
    clipPath: "url(#clip-path-93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3200",
    "data-name": "Path 3200",
    d: "M974.819,1587.7a1.957,1.957,0,1,1-1.961-1.952,1.961,1.961,0,0,1,1.961,1.952",
    transform: "translate(-970.906 -1585.746)"
  }))))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3201",
    "data-name": "Path 3201",
    d: "M974.658,1583.649a1.876,1.876,0,1,1-1.88-1.875,1.875,1.875,0,0,1,1.88,1.875",
    transform: "translate(-802.14 -1306.825)",
    fill: "#934200"
  })), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2526",
    "data-name": "Group 2526",
    transform: "translate(159.58 201.101)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2525",
    "data-name": "Group 2525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2524",
    "data-name": "Group 2524",
    clipPath: "url(#clip-path-94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3202",
    "data-name": "Path 3202",
    d: "M921.974,1158.893a1.959,1.959,0,1,1-1.956-1.961,1.954,1.954,0,0,1,1.956,1.961",
    transform: "translate(-918.057 -1156.932)"
  }))))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3203",
    "data-name": "Path 3203",
    d: "M921.826,1154.868a1.884,1.884,0,1,1-1.884-1.884,1.879,1.879,0,0,1,1.884,1.884",
    transform: "translate(-758.478 -952.569)",
    fill: "#934200"
  })), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2529",
    "data-name": "Group 2529",
    transform: "translate(164.853 258.834)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2528",
    "data-name": "Group 2528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2527",
    "data-name": "Group 2527",
    clipPath: "url(#clip-path-95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3204",
    "data-name": "Path 3204",
    d: "M953.254,1491.509a2.43,2.43,0,1,1-2.43-2.434,2.431,2.431,0,0,1,2.43,2.434",
    transform: "translate(-948.394 -1489.074)"
  }))))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3205",
    "data-name": "Path 3205",
    d: "M953.056,1486.461a2.332,2.332,0,1,1-2.332-2.34,2.33,2.33,0,0,1,2.332,2.34",
    transform: "translate(-783.54 -1226.147)",
    fill: "#934200"
  })), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2532",
    "data-name": "Group 2532",
    transform: "translate(161.541 238.933)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2531",
    "data-name": "Group 2531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2530",
    "data-name": "Group 2530",
    clipPath: "url(#clip-path-96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3206",
    "data-name": "Path 3206",
    d: "M934.2,1377a2.432,2.432,0,1,1-2.425-2.43A2.429,2.429,0,0,1,934.2,1377",
    transform: "translate(-929.34 -1374.576)"
  }))))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3207",
    "data-name": "Path 3207",
    d: "M934.007,1371.938a2.334,2.334,0,1,1-2.323-2.34,2.336,2.336,0,0,1,2.323,2.34",
    transform: "translate(-767.799 -1131.53)",
    fill: "#934200"
  })), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2535",
    "data-name": "Group 2535",
    transform: "translate(159.102 218.148)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2534",
    "data-name": "Group 2534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2533",
    "data-name": "Group 2533",
    clipPath: "url(#clip-path-97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3208",
    "data-name": "Path 3208",
    d: "M920.187,1257.439A2.438,2.438,0,1,1,917.75,1255a2.436,2.436,0,0,1,2.438,2.438",
    transform: "translate(-915.311 -1255.001)"
  }))))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3209",
    "data-name": "Path 3209",
    d: "M919.991,1252.4a2.34,2.34,0,1,1-2.341-2.332,2.342,2.342,0,0,1,2.341,2.332",
    transform: "translate(-756.208 -1032.781)",
    fill: "#934200"
  })), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2538",
    "data-name": "Group 2538",
    transform: "translate(159.947 162.01)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2537",
    "data-name": "Group 2537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2536",
    "data-name": "Group 2536",
    clipPath: "url(#clip-path-98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3210",
    "data-name": "Path 3210",
    d: "M953.047,942.837c2.076-3.212,4.037-9.011-.695-10.8-3.018.237-2.924.563-2.924.563,4.254,1.835,4.957,5.729-2.033,13.1-5.307,5.595-14.425,10.959-26.527,12.577-.247.82-.469,1.66-.7,2.5a44,44,0,0,0,16.722-4.24c8.466-4.307,14.08-10.494,16.156-13.711",
    transform: "translate(-920.169 -932.042)",
    fill: "#ffd890"
  }))))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2541",
    "data-name": "Group 2541",
    transform: "translate(179.38 313.556)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2540",
    "data-name": "Group 2540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2539",
    "data-name": "Group 2539",
    clipPath: "url(#clip-path-99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3211",
    "data-name": "Path 3211",
    d: "M1038.978,1810.882c-1.986-.537-7.008-7-7.008-7s6.121,5.248,7.216,5.652,8.845.58,8.845.58-7.413,1.215-9.054.771",
    transform: "translate(-1031.97 -1803.879)",
    fill: "#fff"
  }))))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2544",
    "data-name": "Group 2544",
    transform: "translate(172.074 164.728)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2543",
    "data-name": "Group 2543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2542",
    "data-name": "Group 2542",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3212",
    "data-name": "Path 3212",
    d: "M1035.431,1044.7c3.568-13.487,19.8-41,19.8-61.613,0-24.214-8.879-32.045-13.1-35.319-6.9-.97-16.991,5.763-20.827,19.722-5.75,20.878-7.75,22.959-9.758,34.144l-6.662,11.245-12.848,12.46s12.3-4.949,13.108-5.409c.494-.281,6.672,33.727,7.059,46.536.388,13.031,8.926,35.675,6.594,36.024-4.425.657-12.895,2.033-14.8,1.394-2.28-.75-8.372-7.439-14.063-18.364,5.542,11.565,11.625,19.033,15.538,19.869a92.6,92.6,0,0,0,18.168-2.136c.525-.12,1.032-.234,1.526-.349.3-.068.584-.141.869-.209q.749-.185,1.453-.37a67.905,67.905,0,0,0,8.543-2.779,12.9,12.9,0,0,0,2.74-4.156c.934-2.025-5.784-16.616-6.394-22.072s-.545-15.009,3.052-28.616",
    transform: "translate(-989.935 -947.676)",
    fill: "#210000"
  }))))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2547",
    "data-name": "Group 2547",
    transform: "translate(200.609 168.547)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2546",
    "data-name": "Group 2546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2545",
    "data-name": "Group 2545",
    clipPath: "url(#clip-path-101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3213",
    "data-name": "Path 3213",
    d: "M1158.143,1033.181c-6.155-22.984-3.726-30.717-2.707-37.119,1.543-9.664,5.529-18.5,14.5-25.158s19.254,14.721,17.379,29.429c-2.856,22.35-13.994,35.713-22.639,38.944-1.611,1.091-.345,5.2-.656,8.986a58.4,58.4,0,0,1-5.874-15.082",
    transform: "translate(-1154.098 -969.65)",
    fill: "#210000"
  }))))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2550",
    "data-name": "Group 2550",
    transform: "translate(212.774 202.439)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2549",
    "data-name": "Group 2549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2548",
    "data-name": "Group 2548",
    clipPath: "url(#clip-path-102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3214",
    "data-name": "Path 3214",
    d: "M1232.218,1274.631c.934-2.025-5.784-16.615-6.394-22.072s-.545-15.009,3.052-28.615c3.432-13,18.59-38.991,19.7-59.311-.686,6.594-3,14.531-6.138,22.5-3.235,8.193-15.35,34.161-16.5,41.2s-2.349,21-1.654,24.383,6.616,21.458,6.539,22.072-1.347,4-1.347,4a12.893,12.893,0,0,0,2.74-4.156",
    transform: "translate(-1224.08 -1164.632)",
    fill: "#fff"
  }))))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2553",
    "data-name": "Group 2553",
    transform: "translate(146.302 179.75)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2552",
    "data-name": "Group 2552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2551",
    "data-name": "Group 2551",
    clipPath: "url(#clip-path-103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3215",
    "data-name": "Path 3215",
    d: "M864.934,1071.378c-2.392-10.568-7.976-23.624-8.061-25.223a3.766,3.766,0,0,0,.776-.609c.619-.648,1.394-3.589,2.894-5.71,1.172-1.577.784-3.606-1.824-5.007s-6.978-.637-7.5,1.064c-.631,2.05-.068,7.076-.077,8.378a2.2,2.2,0,0,0,.307,1.185,22.209,22.209,0,0,0-9.058,13.313c-1.791,8.125.063,17.49,2.212,23.432-.294-3.461,1.338-9.5,5.222-16.876.733-1.394,1.415-2.826,2.02-4.262.077.759.158,1.543.264,2.378,1.859,15.026,6.918,24.135,7.37,29.165s-.6,6.053-.6,6.053c4.659-5.12,8.453-16.68,6.057-27.281",
    transform: "translate(-841.669 -1034.097)",
    fill: "#210000"
  }))))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3216",
    "data-name": "Path 3216",
    d: "M936.017,1880.977c1.321-.154,3.18.042,2.438-4.19-1.045-6.023,1.257-7.711-.294-8.921-.772-.614-3.934-.516-7.059-.724a50.4,50.4,0,0,0-6.936-.167c-1.825.3-2.1,11.863-.507,12.665s7.989,1.842,12.358,1.339",
    transform: "translate(-762.242 -1542.395)",
    fill: "#e38b00"
  })), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2556",
    "data-name": "Group 2556",
    transform: "translate(160.594 324.512)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2555",
    "data-name": "Group 2555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2554",
    "data-name": "Group 2554",
    clipPath: "url(#clip-path-104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3217",
    "data-name": "Path 3217",
    d: "M939.218,1867.865c-.772-.614-3.934-.516-7.059-.725a50.276,50.276,0,0,0-6.935-.166c-.639.106-1.083,1.6-1.33,3.525,4.033,3.236,11.523-.247,13.479.256,2.089.541,1.944,1.389,1.944,1.389.26-2.413.938-3.474-.1-4.28",
    transform: "translate(-923.893 -1866.907)"
  }))))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2559",
    "data-name": "Group 2559",
    transform: "translate(160.372 324.512)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2558",
    "data-name": "Group 2558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2557",
    "data-name": "Group 2557",
    clipPath: "url(#clip-path-105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3218",
    "data-name": "Path 3218",
    d: "M938.161,1867.865c-.772-.614-3.935-.516-7.059-.725a50.278,50.278,0,0,0-6.935-.166c-1.825.3-2.1,11.863-.507,12.664s7.988,1.842,12.358,1.339c1.321-.154,3.18.043,2.438-4.19-1.045-6.023,1.257-7.711-.294-8.922m-2.17,3.44c-.409,1.65.128,5.529.239,7.072s-.938,2.156-2.673,2.255c-3.9.221-9.028-.661-9.723-1.317s-1.091-2.519-1.036-6.092.6-4.872,1.151-5a78.171,78.171,0,0,1,10.115.239c2.464.345,2.345,1.189,1.927,2.843",
    transform: "translate(-922.614 -1866.907)"
  }))))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3219",
    "data-name": "Path 3219",
    d: "M882.327,753.869c-.908-3.229-.23-1.453-.8-10.791s-1.113-27.1-2.4-30.3-18.415-2.025-31.127,8.641-8.713,21.465-6.074,23.487,1.735,4.774,2.191,8.67,1.645,9.719,4.855,12.9,9.1,2.148,16.164-2.223,17.72-8.508,17.191-10.386",
    transform: "translate(-693.309 -587.596)",
    fill: "#fcba8e"
  })), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2562",
    "data-name": "Group 2562",
    transform: "translate(183.048 138.587)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2561",
    "data-name": "Group 2561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2560",
    "data-name": "Group 2560",
    clipPath: "url(#clip-path-106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3220",
    "data-name": "Path 3220",
    d: "M1057.338,797.286c-.835,8.327-.712,17.577-2.464,23.125-1.1,3.47-2.737,5.109-1.142,8.585,3.243-1.709,5.563-3.127,5.307-4.024-.907-3.229-.23-1.453-.8-10.791-.281-4.523-.55-11.028-.9-16.9",
    transform: "translate(-1053.069 -797.286)",
    fill: "#fff"
  }))))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2565",
    "data-name": "Group 2565",
    transform: "translate(151.361 158.325)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2564",
    "data-name": "Group 2564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2563",
    "data-name": "Group 2563",
    clipPath: "url(#clip-path-107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3221",
    "data-name": "Path 3221",
    d: "M900.858,918.016c-2.14,1.087-5.977,1.424-7.562,3.031s-12.2,8.915-15.192,7.816c-2.085-.752-5.222-3.837-7.328-6.9.7,3.368,1.944,7.112,4.3,9.435,3.21,3.176,9.1,2.149,16.164-2.223s17.72-8.508,17.192-10.386c-.8-2.847-.362-1.81-.648-7.948a19.026,19.026,0,0,1-6.927,7.174",
    transform: "translate(-870.776 -910.842)"
  }))))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2568",
    "data-name": "Group 2568",
    transform: "translate(145.869 123.636)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2567",
    "data-name": "Group 2567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2566",
    "data-name": "Group 2566",
    clipPath: "url(#clip-path-108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3222",
    "data-name": "Path 3222",
    d: "M878.946,712.6c-2.05-2.886-18.573-1.516-30.947,8.871-12.715,10.661-8.713,21.465-6.074,23.488.69.39,1.274.684,1.82,1,5.909,3.376,4.322,5.531,5.708,7.434s2.247-.051,3.086,1.4c.819,1.449.4,6.307,2.34,5.134s14.084-12.7,20.244-24.4c4.757-9.037,5-18.244,3.823-22.927",
    transform: "translate(-839.177 -711.276)"
  }))))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3223",
    "data-name": "Path 3223",
    d: "M895.865,896.8c-.022,4.408-3.551,8.086-10.844,12.452s-14.681,7.626-16.467,8.922c-2.737-1.159-7.852-5.335-8.794-9.278l-1.249-3.907s-2.336,1.744-1.841,3.126-.171,4.589,1.423,6.529,4.642,6.961,10.112,8.9c5.507-.448,9.911-4.48,14.817-7.053s15.9-7.483,15.239-11.978.021-5.446-.217-7.136a4.884,4.884,0,0,0-2.123-2.892s-.043.243-.055,2.314",
    transform: "translate(-707.704 -739.003)",
    fill: "#e38b00"
  })), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2571",
    "data-name": "Group 2571",
    transform: "translate(149.162 170.305)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2570",
    "data-name": "Group 2570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2569",
    "data-name": "Group 2569",
    clipPath: "url(#clip-path-109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3224",
    "data-name": "Path 3224",
    d: "M858.123,979.763a29.73,29.73,0,0,0,6.556,9.031c.545.768-5.055-2.634-6.458-7.2-.043-.652-.055-1.277-.1-1.831",
    transform: "translate(-858.123 -979.762)"
  }))))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2574",
    "data-name": "Group 2574",
    transform: "translate(166.139 162.114)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2573",
    "data-name": "Group 2573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2572",
    "data-name": "Group 2572",
    clipPath: "url(#clip-path-110)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3225",
    "data-name": "Path 3225",
    d: "M979.908,932.643a24.261,24.261,0,0,0,.256,3.11c-2.157,4.055-10.086,8.063-13.351,9.906-3.73,2.114-12.323,7.2-10.853,5.942s8.065-4.876,15.469-10.1c4.694-3.308,7.319-6.273,8.479-8.86",
    transform: "translate(-955.792 -932.642)"
  }))))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3226",
    "data-name": "Path 3226",
    d: "M889.028,1025.751c.682-1.639,5.115-2,7.579-.362s2.66,3.691,1.347,5.154c-1.689,1.973-2.732,4.827-3.414,5.422a4.14,4.14,0,0,1-3.756.853c-1.931-.38-2.736-1.432-2.609-2.73s.043-6.354.853-8.336",
    transform: "translate(-733.779 -846.274)",
    fill: "#e38b00"
  })), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2577",
    "data-name": "Group 2577",
    transform: "translate(154.444 186.209)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2576",
    "data-name": "Group 2576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2575",
    "data-name": "Group 2575",
    clipPath: "url(#clip-path-111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3227",
    "data-name": "Path 3227",
    d: "M893.155,1073.23c-1.718-.68-3.965-.531-4.429-.119s-.234-1.55,1.117-1.807a5.788,5.788,0,0,1,4.433,1.492c.686.9.144.94-1.121.435",
    transform: "translate(-888.509 -1071.257)",
    fill: "#fff"
  }))))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2580",
    "data-name": "Group 2580",
    transform: "translate(155.581 178.585)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2579",
    "data-name": "Group 2579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2578",
    "data-name": "Group 2578",
    clipPath: "url(#clip-path-112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3228",
    "data-name": "Path 3228",
    d: "M899.19,1038.355c-.5-.852-3.252-1.456-4.134-1.4,2.046-.708,4.727,1.193,5.149.761s.567-2.231.6-3.508,1.731-1.549,2.472-2.421-.039-3.118-1.987-4.391a5.751,5.751,0,0,1,1.015.529c2.46,1.639,2.66,3.691,1.347,5.154-1.688,1.974-2.732,4.827-3.414,5.422a3.966,3.966,0,0,1-2.741.959c1.07-.094,2.059-.482,1.7-1.109",
    transform: "translate(-895.056 -1027.4)"
  }))))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2583",
    "data-name": "Group 2583",
    transform: "translate(154.49 188.083)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2582",
    "data-name": "Group 2582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2581",
    "data-name": "Group 2581",
    clipPath: "url(#clip-path-113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3229",
    "data-name": "Path 3229",
    d: "M891.293,1084.5a2.973,2.973,0,0,1-2.515-1.773c.115-.269.448-.49,1.091-.625a5.976,5.976,0,0,1,4.633,1.451.507.507,0,0,1,.107.422,4.252,4.252,0,0,1-3.316.524",
    transform: "translate(-888.778 -1082.037)"
  }))))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3230",
    "data-name": "Path 3230",
    d: "M833.764,1085.318c-1.581.593-8.193,4.714-10.725,12.635s-1.551,17.417.039,23.535c.03-3.47,2.208-9.331,6.756-16.313s7.562-15.307,7.118-17.627-1.863-2.722-3.188-2.229",
    transform: "translate(-678.694 -896.51)",
    fill: "#e38b00"
  })), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2586",
    "data-name": "Group 2586",
    transform: "translate(145.737 188.669)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2585",
    "data-name": "Group 2585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2584",
    "data-name": "Group 2584",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3231",
    "data-name": "Path 3231",
    d: "M838.466,1104.867c.691-7.089,5.627-15.388,10.649-19.457a1.908,1.908,0,0,1,1.129.71,46.528,46.528,0,0,1-1.781,9.169c-1.9,6.454-10.738,17.23-10,9.578",
    transform: "translate(-838.422 -1085.41)"
  }))))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3232",
    "data-name": "Path 3232",
    d: "M887.24,1085.075a2.567,2.567,0,0,1,2.481,1.586c-.09,1.526,4.288,15.1,5.691,25.883s-3.436,21.94-8.547,26.6c0,0,1.151-.925,1.155-5.972s-4.177-14.587-4.647-29.715,2.907-18.447,3.866-18.385",
    transform: "translate(-729.788 -896.464)",
    fill: "#e38b00"
  })), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2589",
    "data-name": "Group 2589",
    transform: "translate(153.544 189.279)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2588",
    "data-name": "Group 2588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2587",
    "data-name": "Group 2587",
    clipPath: "url(#clip-path-115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3233",
    "data-name": "Path 3233",
    d: "M883.377,1106.635c-.345-11.475,1.5-16.152,2.835-17.718-1.846,4.256-2.8,18.08.086,29.461s3.231,16.408,4.232,15.572,6.309-9.075,4.553-20.508c.128.767.243,1.526.333,2.276,1.407,10.768-3.414,21.906-8.53,26.578.144-.141,1.134-1.283,1.138-5.947.017-5.047-4.177-14.587-4.647-29.715",
    transform: "translate(-883.335 -1088.917)",
    fill: "#fff"
  }))))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3234",
    "data-name": "Path 3234",
    d: "M782.524,531.325c3.159-.552,10-1.025,13.709-3.15a44.919,44.919,0,0,0,9.578-7.537c1.663-1.909,3.692-9.177,4.578-13.259a20.763,20.763,0,0,0,11.961-12.515c3.342-9.651,8.4-31.5-16.765-40.858s-38.765,3.92-40.244,8.555a89.877,89.877,0,0,1-5.661,12.56c-1.236,2.379-.955,8.681-.7,12.437,0,.933-.128,1.351-1.347,2.769a16.764,16.764,0,0,0-3.913,9.9,33.785,33.785,0,0,0,1.854,12.98c1.181,3.86,2.925,6.292,3.133,8.851.376,4.353,1.381,8.873,8.014,11.135a17.378,17.378,0,0,0,4.68.788c4.569.022,7.984-2.114,11.121-2.66",
    transform: "translate(-622.667 -372.393)",
    fill: "#fcba8e"
  })), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2592",
    "data-name": "Group 2592",
    transform: "translate(135.193 125.277)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2591",
    "data-name": "Group 2591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2590",
    "data-name": "Group 2590",
    clipPath: "url(#clip-path-116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3235",
    "data-name": "Path 3235",
    d: "M812.9,725.865c-.431,1.172-2.157,2.534-5.908,1.332s-4.31-3.585-6.778-4.883c-3.4-1.784-10.883-1.311-12.784-1.582s-3.372,2.886-6.083,2.592a4.457,4.457,0,0,1-3.58-2.051c.183,2.117,2.779,2.462,2.711,3.05a47.409,47.409,0,0,0-1.5,8.621c-.456,5.386,2.306,12.443,1.658,8.161s1.121-10.19,1.172-7.268.529,4.408,2.17,6.3a2.908,2.908,0,0,1,.652,2.89,5.6,5.6,0,0,1,4.4.333,6,6,0,0,1,2.762,2.692c-.277-1.857.273-2.1,3.167-3.391,2.988-1.337,7.724-5.476,8.466-5.092.742,1.292-2.328,5.058-1.322,4.478s2.72-3.966,1.855-.5-3.018,6.475-2.267,5.853c3.167-3.024,7.69-11.494,7.847-13.679s-1.39-4.561-1.261-4.832c4.506-.085,5.021-3.357,4.625-3.02m-6.138,8.717c-.051-1.714-1.466-1.9-3.7-2.6s-7.029-1.925-9.808-1.786c-2.8.132-4.271-.782-6.074-1.127s-4.207-1.03-4.966.277-1.769,5.844-1.889,3.892a15.193,15.193,0,0,1,.861-6c.712-2.031,3.73-4.156,3.981-3.725s13.282,3.007,14.378,2.4,2.434,1.057,4.876,3.182,3.125,4.3,2.344,5.488",
    transform: "translate(-777.763 -720.717)"
  }))))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2595",
    "data-name": "Group 2595",
    transform: "translate(142.169 126.522)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2594",
    "data-name": "Group 2594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2593",
    "data-name": "Group 2593",
    clipPath: "url(#clip-path-117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3236",
    "data-name": "Path 3236",
    d: "M833.426,730.792c-.1,1.643-1.8,3.193-4.753,3.819s-3.547,1.019-4.416.441-3.086-.5-3.606-1.675-2.835-3.25-2.753-4.535,6.735-1.091,9.97-.488,5.67.691,5.558,2.438",
    transform: "translate(-817.895 -727.884)"
  }))))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2598",
    "data-name": "Group 2598",
    transform: "translate(138.338 115.768)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2597",
    "data-name": "Group 2597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2596",
    "data-name": "Group 2596",
    clipPath: "url(#clip-path-118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3237",
    "data-name": "Path 3237",
    d: "M805.365,667.344s-7.017,3.148-9.455-1.332c-.345,1.025.878,2.805,4.015,3.031s4.131-.526,5.44-1.7",
    transform: "translate(-795.854 -666.012)"
  }))))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2601",
    "data-name": "Group 2601",
    transform: "translate(135.666 135.208)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2600",
    "data-name": "Group 2600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2599",
    "data-name": "Group 2599",
    clipPath: "url(#clip-path-119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3238",
    "data-name": "Path 3238",
    d: "M804.674,801.576c3.159-.552,10-1.025,13.709-3.15a44.911,44.911,0,0,0,9.578-7.537c1.637-1.88,3.615-8.919,4.527-13.037-1.437,1.9-6.19,10.718-12.9,15.608-6.731,4.887-14.629,5.235-15.6,5.02-.507-.115-.9-1.1-.9-1.1a15.431,15.431,0,0,1-10.848,4.339c-3.913-.162-6.863-1.5-8.457-4s-2.421-5.518-3.3-7.215a8.327,8.327,0,0,1,.375,1.807c.376,4.353,1.381,8.873,8.014,11.134a17.377,17.377,0,0,0,4.68.789c4.57.022,7.984-2.114,11.121-2.66",
    transform: "translate(-780.483 -777.852)"
  }))))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2604",
    "data-name": "Group 2604",
    transform: "translate(136.86 135.797)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2603",
    "data-name": "Group 2603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2602",
    "data-name": "Group 2602",
    clipPath: "url(#clip-path-120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3239",
    "data-name": "Path 3239",
    d: "M794.545,806.243a17.369,17.369,0,0,0,4.68.788c4.57.022,7.984-2.114,11.122-2.66,3.159-.552,10-1.025,13.709-3.15a44.92,44.92,0,0,0,9.578-7.537c1.556-1.79,3.432-8.28,4.4-12.449-2.353,4.352-2.477,9.033-7.447,13.53-5,4.523-7.4,5.812-10.972,6.746s-8.214,2.148-9.548,2.253-.874-1.475-2.391-.3a18.537,18.537,0,0,1-9.348,2.8,13.1,13.1,0,0,1-7.656-2.553,9.22,9.22,0,0,1-3.321-4.163c.917,2.75,2.835,5.209,7.2,6.7",
    transform: "translate(-787.35 -781.237)",
    fill: "#fff"
  }))))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3240",
    "data-name": "Path 3240",
    d: "M804.754,779.08a8.378,8.378,0,0,0,1.7,4.022c1.3,1.656,1.01,1.042,3.389,1.891s2.315.42,5.7.972,7.856-2.9,9.885-3.634-2.971,3.15-4.591,4.448-3.76,3.308-7.2,2.506-5.972-1-7.5-1.918-2.038-3.233-2.059-5.548.524-4.143.682-2.739",
    transform: "translate(-664.305 -643.254)",
    fill: "#ffd1b4"
  })), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2607",
    "data-name": "Group 2607",
    transform: "translate(141.573 139.901)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2606",
    "data-name": "Group 2606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2605",
    "data-name": "Group 2605",
    clipPath: "url(#clip-path-121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3241",
    "data-name": "Path 3241",
    d: "M816.7,806.376a2.315,2.315,0,0,1-1.611-1.012c-.55-.823-.665-.571-.605.085a2.8,2.8,0,0,0,1.812,2.112c1.159.422,2.685.418,4.109.938s4,.5,4.783-.115-3.21-.712-4.267-.87a39.9,39.9,0,0,1-4.22-1.138",
    transform: "translate(-814.465 -804.845)",
    fill: "#fff"
  }))))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2610",
    "data-name": "Group 2610",
    transform: "translate(140.325 133.953)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2609",
    "data-name": "Group 2609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2608",
    "data-name": "Group 2608",
    clipPath: "url(#clip-path-122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3242",
    "data-name": "Path 3242",
    d: "M807.287,770.74c.912.239-.733.8.716,4.192s2.729,3.466,5.973,4.235,5.268,1.27,7.413.313,6.8-4.31,8.789-4.457c-1.7-.9-5.878-1.933-10.84-1.9a18.631,18.631,0,0,1-9.037-2.106,5.014,5.014,0,0,0-3.014-.281",
    transform: "translate(-807.287 -770.627)"
  }))))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2613",
    "data-name": "Group 2613",
    transform: "translate(138.387 146.649)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2612",
    "data-name": "Group 2612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2611",
    "data-name": "Group 2611",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3243",
    "data-name": "Path 3243",
    d: "M798.084,846.25c1.146-2.046,3.261-2.492,6.121-1.306s4.1,5.448,4,6.886,3.747-1.354,4.736-3.54c.7.526-3.133,6.181-7.132,6.935s-7.988-1.144-9.148-4.806a11.277,11.277,0,0,1-.021-6.746s.264.183.349.857.648,2.534,1.1,1.72",
    transform: "translate(-796.137 -843.672)",
    fill: "#fff"
  }))))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2616",
    "data-name": "Group 2616",
    transform: "translate(140.981 147.808)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2615",
    "data-name": "Group 2615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2614",
    "data-name": "Group 2614",
    clipPath: "url(#clip-path-124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3244",
    "data-name": "Path 3244",
    d: "M814.818,850.4a3.386,3.386,0,0,0-3.576,2.161c-.771,1.858.981-1.185,3.329-.55s2.907,2.558,3.346,2.624-.29-3.481-3.1-4.235",
    transform: "translate(-811.057 -850.343)",
    fill: "#fff"
  }))))))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2623",
    "data-name": "Group 2623",
    transform: "translate(140.325 133.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2622",
    "data-name": "Group 2622",
    clipPath: "url(#clip-path-125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2621",
    "data-name": "Group 2621",
    transform: "translate(1.078 -0.479)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2620",
    "data-name": "Group 2620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2619",
    "data-name": "Group 2619",
    clipPath: "url(#clip-path-126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3245",
    "data-name": "Path 3245",
    d: "M813.62,768.128l-.128,3.061s.742,1.634,6.3,2.717a29.427,29.427,0,0,0,10.67.32c.524-.169.622-.719.963-.962,0,0-.1.437.158.556s1.462-.365,1.9-1.662-6.466-2.2-10.149-2.837-9.566-2.022-9.715-1.193",
    transform: "translate(-813.492 -767.87)",
    fill: "#fff"
  }))))))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2634",
    "data-name": "Group 2634",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2633",
    "data-name": "Group 2633",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2626",
    "data-name": "Group 2626",
    transform: "translate(155.822 120.068)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2625",
    "data-name": "Group 2625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2624",
    "data-name": "Group 2624",
    clipPath: "url(#clip-path-128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3247",
    "data-name": "Path 3247",
    d: "M896.674,690.843c-.277.428-.738,1.6,1.59,3.237S905.57,696.312,909,697s4.292,2.965,4.3,4.777,1.931-1.7.132-5.2-6.2-3.659-9.557-3.634-4.412-.032-5.473-.718-1.462-1.812-1.731-1.381",
    transform: "translate(-896.441 -690.748)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2629",
    "data-name": "Group 2629",
    transform: "translate(131.005 116.484)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2628",
    "data-name": "Group 2628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2627",
    "data-name": "Group 2627",
    clipPath: "url(#clip-path-129)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3248",
    "data-name": "Path 3248",
    d: "M758.629,670.269a2.108,2.108,0,0,1,2.331.731c-.307.318-.567.262-1.756.908s-3.163,2.462-4.131,6.266c1.4-5.43,6.667-6.684,7.021-6.543a22.894,22.894,0,0,0,3.913,1.025c2.771.5,3.589-.829,3.465-.134-.209,1.074-1.2,1.673-5.5,1.9-3.99.209-9.161.8-10.137,12.183a33.346,33.346,0,0,1-.12-5.122,16.765,16.765,0,0,1,3.913-9.9,9.841,9.841,0,0,0,1-1.313",
    transform: "translate(-753.67 -670.132)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2632",
    "data-name": "Group 2632",
    transform: "translate(168.538 117.704)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2631",
    "data-name": "Group 2631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2630",
    "data-name": "Group 2630",
    clipPath: "url(#clip-path-130)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3249",
    "data-name": "Path 3249",
    d: "M970.179,677.218c.575,1.074,3.585,1.818,5.729,1.115-.26.369-2.016.7-3.257.458s1.5.526,2.788,1.419c.49.4-1.492-.673-2.873-1.117s-2.2-.693-2.749-.237.076-2.166.362-1.639",
    transform: "translate(-969.592 -677.148)"
  }))))))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2636",
    "data-name": "Group 2636",
    transform: "translate(141.441 104.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2635",
    "data-name": "Group 2635",
    clipPath: "url(#clip-path-131)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_682",
    "data-name": "Rectangle 682",
    width: 23.345,
    height: 30.202,
    transform: "translate(-4.605 0.624) rotate(-8.649)",
    fill: "url(#linear-gradient)"
  })))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2662",
    "data-name": "Group 2662",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2661",
    "data-name": "Group 2661",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2639",
    "data-name": "Group 2639",
    transform: "translate(144.455 124.377)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2638",
    "data-name": "Group 2638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2637",
    "data-name": "Group 2637",
    clipPath: "url(#clip-path-133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3251",
    "data-name": "Path 3251",
    d: "M831.881,717.391c.64.232.772.9,2.272,1.168a5.977,5.977,0,0,0,4-.392c1.59-.689-.673-2.321-3.38-2.588s-5.026,1.023-2.89,1.812",
    transform: "translate(-831.044 -715.543)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2642",
    "data-name": "Group 2642",
    transform: "translate(141.441 104.156)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2641",
    "data-name": "Group 2641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2640",
    "data-name": "Group 2640",
    clipPath: "url(#clip-path-134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3252",
    "data-name": "Path 3252",
    d: "M816.893,624.628c-1.765-.816-2.545-.9-3.116-2.935s2.562-3.235,3.389-4.1a20.719,20.719,0,0,0,2.524-4.828c.677-1.588,2.575-3.163,2.621-5.667s-2.076-5.727-1.688-7.89c.417,2.924,2.54,5.7,2.664,8.24s-1.5,3.951-2.686,6.605a12.293,12.293,0,0,1-2.954,4.493c-.545.395-2.975,1.435-3.124,2.462a4.034,4.034,0,0,0,2.37,3.617",
    transform: "translate(-813.707 -599.212)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2645",
    "data-name": "Group 2645",
    transform: "translate(142.252 124.447)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2644",
    "data-name": "Group 2644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2643",
    "data-name": "Group 2643",
    clipPath: "url(#clip-path-135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3253",
    "data-name": "Path 3253",
    d: "M819.852,715.942c-.537.993-.563,1.179.9,1.737s.964,1.07,2.719,1.528a5.823,5.823,0,0,0,3.542-.1c1.126-.251,1.8-.891,3.044-.409s2.724,4.755,4.1,1.769c-.051.352-.107.7-.162,1a1.242,1.242,0,0,1-.883,1.027c-1.275.426-2.033-2.6-3.815-2.464s-2.989,1.509-5.525,1.066-1.479-1.385-3.013-2.293c-1.194-.706-2-.865-2.387-1.121a2.675,2.675,0,0,1,1.479-1.746",
    transform: "translate(-818.373 -715.942)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2648",
    "data-name": "Group 2648",
    transform: "translate(149.931 128.811)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2647",
    "data-name": "Group 2647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2646",
    "data-name": "Group 2646",
    clipPath: "url(#clip-path-136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3254",
    "data-name": "Path 3254",
    d: "M863.052,742.817c-.6-.107-1.062-.53,1.1-1.358s2.591-.271,2.911.509-.891.454-.891.454-.018-.744-1.253-.471-.128.269-1.863.865",
    transform: "translate(-862.551 -741.048)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2651",
    "data-name": "Group 2651",
    transform: "translate(143.966 127.365)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2650",
    "data-name": "Group 2650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2649",
    "data-name": "Group 2649",
    clipPath: "url(#clip-path-137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3255",
    "data-name": "Path 3255",
    d: "M828.23,732.729c1.066.209,1.415,1.262,1.582,1.876a1.734,1.734,0,0,1-.938-.369s.72-.686-.643-1.507",
    transform: "translate(-828.23 -732.729)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2654",
    "data-name": "Group 2654",
    transform: "translate(157.871 110.509)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2653",
    "data-name": "Group 2653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2652",
    "data-name": "Group 2652",
    clipPath: "url(#clip-path-138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3256",
    "data-name": "Path 3256",
    d: "M908.225,639.872c1.748-3.4,4.22-4.206,5.674-4.1s3.892,1.379,5.1,5.006a11.684,11.684,0,0,0-5.384-2.95c-2.962-.516-5.388,2.044-5.388,2.044",
    transform: "translate(-908.225 -635.762)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2657",
    "data-name": "Group 2657",
    transform: "translate(156.941 111.191)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2656",
    "data-name": "Group 2656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2655",
    "data-name": "Group 2655",
    clipPath: "url(#clip-path-139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3257",
    "data-name": "Path 3257",
    d: "M902.952,645.693c.5-3.261,3.078-6.58,6.8-5.929s5.44,4.868,5.657,7.281c-1.027,2.455-3.93,3.753-8.125,3.02a6.5,6.5,0,0,1-3.908-2.517c-.542-.477-.571-.889-.422-1.854",
    transform: "translate(-902.875 -639.681)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2660",
    "data-name": "Group 2660",
    transform: "translate(157.751 116.55)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2659",
    "data-name": "Group 2659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2658",
    "data-name": "Group 2658",
    clipPath: "url(#clip-path-140)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3258",
    "data-name": "Path 3258",
    d: "M909.307,674.072c-1.744-1.064-2.562-2.445-.742-3.248s6.513.056,8.427,1.369-3.721,4.29-7.685,1.88",
    transform: "translate(-907.538 -670.508)",
    fill: "#fff"
  }))))))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2667",
    "data-name": "Group 2667",
    transform: "translate(156.941 111.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2666",
    "data-name": "Group 2666",
    clipPath: "url(#clip-path-141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3259",
    "data-name": "Path 3259",
    d: "M922.533,655.327a2.911,2.911,0,1,1-2.119-3.54,2.911,2.911,0,0,1,2.119,3.54",
    transform: "translate(-914.378 -649.612)",
    fill: "#a9583d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3260",
    "data-name": "Path 3260",
    d: "M927.59,661.347a1.58,1.58,0,1,1-1.151-1.918,1.579,1.579,0,0,1,1.151,1.918",
    transform: "translate(-920.722 -655.958)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2665",
    "data-name": "Group 2665",
    transform: "translate(5.43 3.883)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2664",
    "data-name": "Group 2664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2663",
    "data-name": "Group 2663",
    clipPath: "url(#clip-path-142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3261",
    "data-name": "Path 3261",
    d: "M935.734,663.045a.824.824,0,0,1-1,.6.834.834,0,0,1-.6-1.006.825.825,0,0,1,1.6.4",
    transform: "translate(-934.112 -662.02)",
    fill: "#fff"
  }))))))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2681",
    "data-name": "Group 2681",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2680",
    "data-name": "Group 2680",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3263",
    "data-name": "Path 3263",
    d: "M903.591,645.4c.614-3.161,3.146-6.266,6.752-5.635,3.73.652,5.44,4.868,5.657,7.281-6.432-4.512-11.241-3.319-12.409-1.645",
    transform: "translate(-746.526 -528.49)",
    fill: "#ffc193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3264",
    "data-name": "Path 3264",
    d: "M903.591,662.527c.166-.6,1-2.743,5.371-1.933,4.936.906,7.037,3.579,7.037,3.579-6.432-4.512-11.241-3.319-12.409-1.645",
    transform: "translate(-746.526 -545.618)",
    fill: "#4a4347"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2670",
    "data-name": "Group 2670",
    transform: "translate(156.907 118.406)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2669",
    "data-name": "Group 2669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2668",
    "data-name": "Group 2668",
    clipPath: "url(#clip-path-144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3265",
    "data-name": "Path 3265",
    d: "M910.578,684.961c-.643.049-1.219.075-1.7.092-1.931-.017-4.331-.38-5.384-2a5.461,5.461,0,0,1-.814-1.863,8.482,8.482,0,0,0,6.031,3.159c4.19.426,5.951-2,6.535-3.012-.358,2.069-2.28,3.438-4.672,3.621",
    transform: "translate(-902.684 -681.192)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2673",
    "data-name": "Group 2673",
    transform: "translate(139.507 109.046)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2672",
    "data-name": "Group 2672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2671",
    "data-name": "Group 2671",
    clipPath: "url(#clip-path-145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3266",
    "data-name": "Path 3266",
    d: "M810.854,634.128c0-2.8-1.492-6.445-6.027-6.788.644.337.494.49.494.49a3.5,3.5,0,0,0-2.741,1.793,4.31,4.31,0,0,1,5.2-.16c1.961,1.388,3.069,4.665,3.069,4.665",
    transform: "translate(-802.581 -627.34)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2676",
    "data-name": "Group 2676",
    transform: "translate(138.27 109.887)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2675",
    "data-name": "Group 2675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2674",
    "data-name": "Group 2674",
    clipPath: "url(#clip-path-146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3267",
    "data-name": "Path 3267",
    d: "M804.935,638.581c.379-2.176-1.718-5.793-4.783-6.328-4.186-.731-4.752,4.242-4.684,5.194s.878,2.848,3.67,3.234a9.524,9.524,0,0,0,5.9-1.288c.358-.326-.187-.324-.106-.812",
    transform: "translate(-795.463 -632.18)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2679",
    "data-name": "Group 2679",
    transform: "translate(138.745 113.652)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2678",
    "data-name": "Group 2678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2677",
    "data-name": "Group 2677",
    clipPath: "url(#clip-path-147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3268",
    "data-name": "Path 3268",
    d: "M800.743,653.876c-1.769-.23-2.639.552-2.541,1.289s.507,2.266,3.5,2.732,4.178-1.3,3.875-1.846-1.871-1.784-4.829-2.176",
    transform: "translate(-798.195 -653.836)",
    fill: "#fff"
  }))))))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2686",
    "data-name": "Group 2686",
    transform: "translate(138.27 109.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2685",
    "data-name": "Group 2685",
    clipPath: "url(#clip-path-148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3269",
    "data-name": "Path 3269",
    d: "M806.114,641.591a2.6,2.6,0,1,1-1.893-3.155,2.606,2.606,0,0,1,1.893,3.155",
    transform: "translate(-800.031 -637.285)",
    fill: "#a9583d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3270",
    "data-name": "Path 3270",
    d: "M810.612,646.948a1.408,1.408,0,0,1-2.732-.682,1.414,1.414,0,0,1,1.71-1.027,1.4,1.4,0,0,1,1.023,1.709",
    transform: "translate(-805.688 -642.934)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2684",
    "data-name": "Group 2684",
    transform: "translate(3.805 2.839)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2683",
    "data-name": "Group 2683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2682",
    "data-name": "Group 2682",
    clipPath: "url(#clip-path-149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3271",
    "data-name": "Path 3271",
    d: "M818.805,649.43a.743.743,0,0,1-.9.535.737.737,0,0,1,.358-1.43.744.744,0,0,1,.537.9",
    transform: "translate(-817.354 -648.512)",
    fill: "#fff"
  }))))))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2757",
    "data-name": "Group 2757",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2756",
    "data-name": "Group 2756",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3273",
    "data-name": "Path 3273",
    d: "M796.078,636.206c.316-1.767,1.394-4.514,4.583-3.956a6.406,6.406,0,0,1,4.821,5.874c-3.312-3.3-7.694-3.879-9.4-1.918",
    transform: "translate(-657.701 -522.29)",
    fill: "#ffc193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3274",
    "data-name": "Path 3274",
    d: "M805.482,649.4a7.456,7.456,0,0,0-1.828-2.012,7.533,7.533,0,0,0-2.455-1.274,5.958,5.958,0,0,0-2.831-.2,3.159,3.159,0,0,0-2.289,1.569,3.592,3.592,0,0,1,2.345-1.091,7,7,0,0,1,2.609.286,10.766,10.766,0,0,1,4.45,2.724",
    transform: "translate(-657.701 -533.566)",
    fill: "#4a4347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3275",
    "data-name": "Path 3275",
    d: "M915.034,678.919c-2.758,2.5-6.42,2.044-9.651,1.136-2.72-.767-2.886-1.792-2.886-1.792s-.243.224.145,1.142,2.566,2.9,5.606,3.007,4.851-.8,5.695-1.528a3.874,3.874,0,0,0,1.091-1.965",
    transform: "translate(-745.56 -560.366)",
    fill: "#ffc193"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2689",
    "data-name": "Group 2689",
    transform: "translate(156.915 117.897)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2688",
    "data-name": "Group 2688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2687",
    "data-name": "Group 2687",
    clipPath: "url(#clip-path-151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3276",
    "data-name": "Path 3276",
    d: "M905.635,680.054c3.031.857,6.445,1.307,9.127-.706a6.134,6.134,0,0,1-3.619,1.81,16.18,16.18,0,0,1-6.467-1.074c-2.3-1-1.926-1.823-1.926-1.823s.166,1.025,2.885,1.792",
    transform: "translate(-902.727 -678.262)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3277",
    "data-name": "Path 3277",
    d: "M804.52,663.207a10.374,10.374,0,0,1-5.7.388c-2.583-.454-3.53-1.17-3.76-1.786,0,0-.107.091-.09.473a3.5,3.5,0,0,0,1.931,2.406,7.585,7.585,0,0,0,5.03.4,7.755,7.755,0,0,0,2.89-1.283c.346-.369-.3-.6-.3-.6",
    transform: "translate(-656.782 -546.772)",
    fill: "#ffc193"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2692",
    "data-name": "Group 2692",
    transform: "translate(138.185 115.276)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2691",
    "data-name": "Group 2691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2690",
    "data-name": "Group 2690",
    clipPath: "url(#clip-path-152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3278",
    "data-name": "Path 3278",
    d: "M798.824,664.727a10.374,10.374,0,0,0,5.7-.388,10.143,10.143,0,0,1-6.271.633c-1.969-.341-3.014-1.147-3.282-1.793.32.377,1.266,1.093,3.849,1.547",
    transform: "translate(-794.975 -663.18)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3279",
    "data-name": "Path 3279",
    d: "M810.088,437.861c4.131-3.941,21.535-11.757,39.029-6.192s22.26,22,22.217,28.71-3.947,15.857-5.371,17.13c.554,3.547-.244,7.771-1.527,9.832-3.086,4.071-8.457,3.766-8.875,2.253,3.2-6.709-.452-10.729-.8-8.734a21.482,21.482,0,0,0-.179,5.88,18.959,18.959,0,0,1-6.078.865c.511-6.418,2.127-10.429,2.455-12.277.4-2.315-.264-3.21-.89-1.535a5.169,5.169,0,0,1-1.054,2.027,17.991,17.991,0,0,0,.132-4.218,23.874,23.874,0,0,0,2.609-7.88,14.211,14.211,0,0,1,2.3,4.32,12.991,12.991,0,0,0-2.187-6.3,11.832,11.832,0,0,0-.2-2.016,12.293,12.293,0,0,1,3.449,4.819,14.045,14.045,0,0,0-4.655-8.114l-.26-1.211c.217-2.423,2.715-9.054-1.441-11.818-6.637-4.42-26.664.484-27.605-3.945-10.184-2.323-13.376,10.644-14.621,11.761-.124-1.975-.588-9.421,3.547-13.355",
    transform: "translate(-666.28 -355.037)",
    fill: "#4a352f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2695",
    "data-name": "Group 2695",
    transform: "translate(140.189 74.698)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2694",
    "data-name": "Group 2694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2693",
    "data-name": "Group 2693",
    clipPath: "url(#clip-path-153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3280",
    "data-name": "Path 3280",
    d: "M849.153,431.67c-17.494-5.565-34.9,2.251-39.029,6.192-3.372,3.212-3.679,8.771-3.611,11.772.2-3.9,2.059-9.28,3.086-10.569s5.171-4.248,11.2-5.966,17.639-3.312,26.8-.473,16.493,9.962,18.709,15.216,4.787,15.727.571,25.542c-3.712,8.636-6.262,11.411-6.828,16.961a8.327,8.327,0,0,0,4.416-3c1.283-2.061,2.08-6.285,1.526-9.832,1.424-1.272,5.328-10.412,5.371-17.13s-4.727-23.144-22.217-28.71",
    transform: "translate(-806.505 -429.736)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3281",
    "data-name": "Path 3281",
    d: "M791.14,559.657s-1.163,3.86-.362,6.157c-.652.237-1.356-.637-2.877-.8s-6.88-.028-8.159,2.057-1.347,6.153-1.347,6.153-.068-4.815-.486-5.337a4.266,4.266,0,0,1-.49-1.743,4.035,4.035,0,0,0,1.82-2.492c.366-1.694,2.856-2.114,5.537-2.536,2.306-.36,4.531-.422,4.885-.712s.448.577.392.872.447-1.4,1.087-1.618",
    transform: "translate(-642.285 -462.376)",
    fill: "#4a352f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3282",
    "data-name": "Path 3282",
    d: "M921.911,565.652c-1.36,1.822-1.913,5.365-1.036,7.159.405.936.721-1.954,10.12,2.415,3.657,2.223,5.947,7.7,5.947,7.7a14.826,14.826,0,0,0-2.972-7.415c-.085-.522,1.339.512,1.881,1.458a43.679,43.679,0,0,0-2-4.423,59.185,59.185,0,0,0-5.563-2.393,17.16,17.16,0,0,1-4.118-1.963c-.452-.462-2.255-2.543-2.255-2.543",
    transform: "translate(-760.456 -467.329)",
    fill: "#4a352f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3283",
    "data-name": "Path 3283",
    d: "M1078,679.738c3.364-4.15,8.18-6.04,9.779-5.859s4.174,2.76,4.6,4.331c.4,1.571-1.449,9.687-2.567,11.073-1.134,1.394-6.535,6.654-8.7,5.865s-3.21-1.671-3.393-2.7-.725-11.46.29-12.707",
    transform: "translate(-890.128 -556.733)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2698",
    "data-name": "Group 2698",
    transform: "translate(189.241 121.392)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2697",
    "data-name": "Group 2697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2696",
    "data-name": "Group 2696",
    clipPath: "url(#clip-path-154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3284",
    "data-name": "Path 3284",
    d: "M1096.88,698.547c-2.669-.976-6.581,2.406-7.473,3.619s.252,1.931.844,2.888-2.574,2.707-1.2,2.8c1.151.07,1.74-.863,1.957-1.827.3-1.277-.985-1.793-.665-2.66a7.1,7.1,0,0,1,2.289-2.466c2.1.454,1.692,2.155,1.5,4.052,1.42-3.37.256-4.256-.933-4.441a4.555,4.555,0,0,1,1.824-.782c1.3-.073,2.809,1.62,2.038,4.553s-1.841,4.165-3.913,6.106a11.241,11.241,0,0,0,4.079-3.649c1.309-2.118,2.332-7.215-.341-8.189",
    transform: "translate(-1088.702 -698.372)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2701",
    "data-name": "Group 2701",
    transform: "translate(187.3 117.134)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2700",
    "data-name": "Group 2700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2699",
    "data-name": "Group 2699",
    clipPath: "url(#clip-path-155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3285",
    "data-name": "Path 3285",
    d: "M1092.482,678.208c-.422-1.57-3-4.145-4.6-4.331s-6.415,1.71-9.779,5.859c-.362.445-.528,2.072-.575,4.016a5.256,5.256,0,0,1,1.816-3.617c1.142-1.19,6.458-4.96,8.206-4.922s3.324,1.183,4.927,2.994",
    transform: "translate(-1077.533 -673.866)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3286",
    "data-name": "Path 3286",
    d: "M1182.949,956c6.066,0,12.937,8.14,14.451,10.269,2.839,4,5.362,10.84,8.155,18.92,3.776,10.908,11.693,28.151,16.77,35.406s13.154,13.8,12,26.9-8.078,18.726-10.388,19.31c-2.3.567-30.133-36.775-36.753-49.247s-10.1-7.532-13.483-9.045-14.919-13.722-9.229-31.966C1167.957,965.4,1172.5,956,1182.949,956",
    transform: "translate(-960.78 -789.826)",
    fill: "#e38b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3287",
    "data-name": "Path 3287",
    d: "M1339.318,1217.319c-7.1-6.01-27.094,6.795-22.478,20.073,2.792,4.442,6.607,10.034,10.678,15.742-2.886-10.644,14.719-23.914,19.6-20.7a160.813,160.813,0,0,1-7.8-15.111",
    transform: "translate(-1087.377 -1004.461)",
    fill: "#934200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3288",
    "data-name": "Path 3288",
    d: "M1201.1,973.273a38.916,38.916,0,0,0-3.7-7c-1.514-2.129-8.385-10.269-14.451-10.269-10.452,0-14.992,9.4-18.475,20.545-5.69,18.244,5.853,30.448,9.229,31.966-3.15-26.889,22.043-40.911,27.392-35.238",
    transform: "translate(-960.78 -789.826)",
    fill: "#934200"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2704",
    "data-name": "Group 2704",
    transform: "translate(202.143 178.547)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2703",
    "data-name": "Group 2703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2702",
    "data-name": "Group 2702",
    clipPath: "url(#clip-path-156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3289",
    "data-name": "Path 3289",
    d: "M1234.336,1106.074c-.788-12.375-6.867-22.392-11.155-22.46-7.037-.12-11.322,12.89-12.341,19.033-.123.725-.213,1.577-.276,2.485-.764-1.914-.814-5.128-.725-7.481-10.32-14.484-23.56-36.318-26.313-40.333-5.763-8.427-3.807-16.39-5.418-15.082-5.606,4.536-6.641,4.421-8.713,4.186-3.892-6.718-1.948-19.086-1.914-19.242a75.492,75.492,0,0,0-3.005,8.172c-5.69,18.244,5.853,30.448,9.229,31.966s6.867-3.432,13.483,9.046c3.76,7.076,14.348,22.17,23.227,33.8,1.271,1.649,2.383,3.095,3.457,4.45.081.115.175.23.265.35.281.354.562.7.836,1.049.14.17.272.337.4.511.26.315.507.622.759.929.141.179.281.354.426.524.226.281.46.571.687.84.157.192.311.375.46.554.2.243.409.49.6.725.166.2.324.379.482.563.175.209.362.426.533.623.307.354.6.691.887,1.006.119.141.23.256.345.383.175.192.354.4.52.567.11.115.208.226.32.336.153.166.3.32.447.46.1.107.2.2.286.29.145.128.26.243.379.362.089.081.17.145.247.222.115.1.222.183.32.264a3.336,3.336,0,0,0,.469.311,1.513,1.513,0,0,0,1.023-.115c.392-.2.6-.328.84-.469a11.868,11.868,0,0,0,1.074-.8c.392-.341.7-.635,1.014-.955a19.211,19.211,0,0,0,2.306-2.865c.439-.678.776-1.241,1.1-1.842a22.165,22.165,0,0,0,1.062-2.212,32.9,32.9,0,0,0,2.366-9.923,2.078,2.078,0,0,1,.008-.226",
    transform: "translate(-1162.922 -1027.18)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2707",
    "data-name": "Group 2707",
    transform: "translate(202.177 192.589)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2706",
    "data-name": "Group 2706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2705",
    "data-name": "Group 2705",
    clipPath: "url(#clip-path-157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3290",
    "data-name": "Path 3290",
    d: "M1176.035,1120.351c.345-2.766-2.085,4.037-1.731,6.863s-.635,3.751-3.057,1.965-5.652-6.752-6.693-11.65a62.04,62.04,0,0,1-1.181-9.57c-1.918,14.958,7.49,24.745,10.491,26.1,3.15,1.4,6.368-2.72,12.1,6.616,0-.013-5.661-9.357-7.388-12.012s-2.89-5.537-2.54-8.308",
    transform: "translate(-1163.119 -1107.959)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2710",
    "data-name": "Group 2710",
    transform: "translate(215.635 218.535)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2709",
    "data-name": "Group 2709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2708",
    "data-name": "Group 2708",
    clipPath: "url(#clip-path-158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3291",
    "data-name": "Path 3291",
    d: "M1287.228,1315.248c-4.945-5.486-15.431-20.269-19.48-26.348-4.731-7.093-14.421-22.435-17.95-27.111-3.508-4.664-5.865-5.132-9.259-4.118,2.69-.175,5.874-.495,10.772,8.751,6.16,11.608,30.7,44.767,35.917,48.825",
    transform: "translate(-1240.539 -1257.228)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3292",
    "data-name": "Path 3292",
    d: "M1470.326,1126.12c4.715,2.443,16.889-16.33,22.366-31.484,2.52-7,4.642-19.391,6.59-31.889,2.276-14.583,2.281-21.058,4.463-27.432,4.05-11.836-12.136-9.263-13.078-2.326-.963,6.936-.6,9.655-8.687,23.53s-17.6,29.464-20.141,36.139-.669,28.722,8.487,33.462",
    transform: "translate(-1206.881 -848.575)",
    fill: "#e38b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3293",
    "data-name": "Path 3293",
    d: "M1470.32,1420.36c3.146,1.624,9.57-6.121,15.129-15.947-1.74,1.765-5.883,3.606-11.719-.614s-12.063-14.365-10.269-20.542c-.673,1.389-1.24,2.634-1.624,3.64-2.54,6.684-.669,28.722,8.483,33.462",
    transform: "translate(-1206.879 -1142.816)",
    fill: "#934200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3294",
    "data-name": "Path 3294",
    d: "M1514.208,1266.526c-2.012,3.419-3.956,6.753-5.729,9.851,2.639,13.019,22.273,17.549,24.924,11.757.967-3.525,1.863-7.78,2.728-12.409-3.918,3.956-23.611-3.252-21.923-9.2",
    transform: "translate(-1246.27 -1046.375)",
    fill: "#934200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3295",
    "data-name": "Path 3295",
    d: "M1595.784,1032.988c-.921,6.65-.64,9.446-7.749,21.9.089,4.774,13.87,10.657,16.586,6.377,2.055-13.543,2.14-19.8,4.241-25.953,4.049-11.836-12.136-9.263-13.078-2.326",
    transform: "translate(-1311.997 -848.575)",
    fill: "#934200"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2713",
    "data-name": "Group 2713",
    transform: "translate(253.935 182.846)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2712",
    "data-name": "Group 2712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2711",
    "data-name": "Group 2711",
    clipPath: "url(#clip-path-159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3296",
    "data-name": "Path 3296",
    d: "M1475.878,1094.754c6.535-12.439,14.365-29.1,15.354-42.843a4.691,4.691,0,0,0-.5,1.566c-.963,6.936-.6,9.655-8.687,23.53s-17.6,29.464-20.141,36.139c-1.053,2.771-1.326,8.155-.665,13.854,1.59-11.808,7.319-18.309,14.638-32.247",
    transform: "translate(-1460.882 -1051.911)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3297",
    "data-name": "Path 3297",
    d: "M322.622,1247.289a58.99,58.99,0,0,1,7.409,8.823c3.188,1.207,8.432-5.559,7.2-9.48s-5.465-5.315-5.7-9.7-12.784,6.078-8.914,10.359",
    transform: "translate(-265.931 -1021.055)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3298",
    "data-name": "Path 3298",
    d: "M289.629,1123.231c1.1-3.406,1.164-5.367,3.167-6.463s2.651-10.989.068-14.672-7.34-5.038-8.743-6.658-.5-4.791-3.086-5.729a4.641,4.641,0,0,0-5.124,1.049c-1.163.929-2.958,2.421.661,10.435,1.756,3.888,4.335,13.121,6.1,19.067,1.709,5.729,6.194,5.333,6.957,2.971",
    transform: "translate(-226.723 -899.993)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3299",
    "data-name": "Path 3299",
    d: "M340.709,1104.906c3.163-2.37,3.363-7.042,4.237-9.369s.379-6.6.776-9.506,4.6-7.038,5.226-8.436a1.737,1.737,0,0,0-1.253-2.426c-1.355-.432-3.469-.128-5.942,1.326s-1.564,3.772-2,4.493a15.833,15.833,0,0,1-2.894,3.99c-1.36,1.168-4.582.256-5.431-.316s-1.637,6.083-.281,11.42,5.239,10.571,7.562,8.824",
    transform: "translate(-274.636 -888.131)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2716",
    "data-name": "Group 2716",
    transform: "translate(47.703 186.858)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2715",
    "data-name": "Group 2715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2714",
    "data-name": "Group 2714",
    clipPath: "url(#clip-path-160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3300",
    "data-name": "Path 3300",
    d: "M301.791,1075.17c-1.355-.433-3.469-.128-5.942,1.326s-1.564,3.772-2,4.493a15.828,15.828,0,0,1-2.894,3.99c-1.326,1.142-4.446.285-5.358-.286a6.341,6.341,0,0,1-1.466-1.116c-1.407-1.616-.5-4.792-3.086-5.729a4.642,4.642,0,0,0-5.124,1.049c-1.164.929-2.954,2.422.661,10.435,1.756,3.887,4.335,13.121,6.1,19.067,1.709,5.729,6.194,5.333,6.957,2.971,1.1-3.406,1.164-5.367,3.167-6.463a1.508,1.508,0,0,0,.418-.388c2.741-2.459,2.988-6.778,3.82-8.981.869-2.332.379-6.6.776-9.506s4.6-7.038,5.226-8.436a1.737,1.737,0,0,0-1.253-2.425",
    transform: "translate(-274.435 -1074.989)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2719",
    "data-name": "Group 2719",
    transform: "translate(57.399 186.858)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2718",
    "data-name": "Group 2718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2717",
    "data-name": "Group 2717",
    clipPath: "url(#clip-path-161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3301",
    "data-name": "Path 3301",
    d: "M336.8,1087.778a11.743,11.743,0,0,0-1.245-1.406s2.063-.533,2.715-1.479,2.2-2.664,2.69-3.56a6.578,6.578,0,0,1,1.547-3.738,10.842,10.842,0,0,1,4.83-2.155,1.915,1.915,0,0,1,1.432,1.394c.021.62-2.208,3.336-3.273,4.862a17.372,17.372,0,0,0-2.4,4.6c-.243,1.044.1,6.207-.022,7.366s-.976,3.031-1.049,4.2a20.51,20.51,0,0,1-1.261,4.8c1.4-2.4,1.713-5.4,2.361-7.127.869-2.332.379-6.6.776-9.506s4.6-7.038,5.226-8.436a1.737,1.737,0,0,0-1.253-2.425c-1.355-.433-3.469-.128-5.942,1.325s-1.564,3.772-2,4.493a15.838,15.838,0,0,1-2.894,3.99c-1.326,1.142-4.446.286-5.358-.286a6.341,6.341,0,0,1-1.466-1.116c1.053,1.679,4.851,3.717,6.586,4.2",
    transform: "translate(-330.213 -1074.989)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3302",
    "data-name": "Path 3302",
    d: "M282.725,1052.3c-.622-1.65-.1-4.459-.034-6.714s-.614-4.284-.009-5.076a5.319,5.319,0,0,1,3.47.062c2.14.65,3.129,4.026,3.171,5.435s.7,4.456-1.083,5.718-4.834,2.353-5.516.576",
    transform: "translate(-233.332 -859.446)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3303",
    "data-name": "Path 3303",
    d: "M270.52,966.693a4.343,4.343,0,0,1-1.62-3.112,46.379,46.379,0,0,0-1.982-8.225,1.633,1.633,0,0,1,2.042-.816,9.148,9.148,0,0,1,3.312,2.8c1.155,1.528,1.645,2.523,1.3,3.983s.755,3.374-.085,4.365-2.57,1.362-2.967,1.007",
    transform: "translate(-220.521 -788.548)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3304",
    "data-name": "Path 3304",
    d: "M280.359,1008.6c-.788-.874-.618-1.829-.733-2.939s-.2-2.1-.375-4.15a3.107,3.107,0,0,1,3.47-3.212c1.206.328,2.187,1.886,2.6,4.329.354,2.038.243,3.223-.546,4.369s-3.133,3.02-4.42,1.6",
    transform: "translate(-230.701 -824.723)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2722",
    "data-name": "Group 2722",
    transform: "translate(50.438 169.001)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2721",
    "data-name": "Group 2721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2720",
    "data-name": "Group 2720",
    clipPath: "url(#clip-path-162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3305",
    "data-name": "Path 3305",
    d: "M293.933,985.305c.652-1.083.75-2.236.422-4.139a6.845,6.845,0,0,0-1.573-3.677,3.882,3.882,0,0,1,0-1.456,3.7,3.7,0,0,0,.1-1.006c-1.39-3.819-3.206-3.14-2.592-1.215.665,2.074.661,5.77.7,9.12s-.217,2.3.524,5.955a20.293,20.293,0,0,1-.281,8.1,8.436,8.436,0,0,0,3.4-1.449c1.782-1.262,1.125-4.308,1.083-5.718a8.1,8.1,0,0,0-1.79-4.519",
    transform: "translate(-290.169 -972.261)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3306",
    "data-name": "Path 3306",
    d: "M269.323,1047.7c-.473-1.875.307-4.9.593-7.362s-.2-4.753.469-5.563a4.9,4.9,0,0,1,3.453.431c2.063.933,2.732,4.731,2.643,6.283s.277,4.949-1.616,6.147-5.038,2.076-5.541.064",
    transform: "translate(-222.386 -854.797)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3307",
    "data-name": "Path 3307",
    d: "M282.656,955.051a5.06,5.06,0,0,1,1.014-3.7,52.55,52.55,0,0,0,4.327-8c.857-.467,1.743.307,2.025.927a10.715,10.715,0,0,1,.409,4.745c-.231,2.1-.571,3.25-1.842,4.131s-1.82,3.235-3.111,3.374-2.788-.9-2.822-1.479",
    transform: "translate(-233.497 -779.259)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3308",
    "data-name": "Path 3308",
    d: "M273.776,1000.425c-.461-1.194.017-2.121.277-3.321s.5-2.246,1-4.444,2.46-2.53,3.683-1.6c1.031.776,1.807,2.8,1.394,5.49-.341,2.242-.494,3.481-1.616,4.389s-3.994,1.422-4.74-.516",
    transform: "translate(-226.028 -818.389)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2725",
    "data-name": "Group 2725",
    transform: "translate(46.789 163.951)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2724",
    "data-name": "Group 2724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2723",
    "data-name": "Group 2723",
    clipPath: "url(#clip-path-163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3309",
    "data-name": "Path 3309",
    d: "M276.886,943.354a52.572,52.572,0,0,1-4.327,8c-.183.3-.328.56-.46.812a3.011,3.011,0,0,0-.686,1.369c-.5,2.2-.746,3.246-1,4.444a7.377,7.377,0,0,0-.4,2.756c-.043,1.087.073,2.547-.1,4.071-.286,2.46-1.066,5.486-.593,7.362a1.453,1.453,0,0,0,.456.742,59.434,59.434,0,0,0,.908-12.435,23.317,23.317,0,0,1,1.935-7.886,62.693,62.693,0,0,0,4.024-6.044c.908-1.842,1.1-2.424,1.5-2.168.341.221,1.407,3.553.827,6.513a13.037,13.037,0,0,0,.341-1.861,10.724,10.724,0,0,0-.409-4.745c-.281-.62-1.168-1.394-2.025-.927",
    transform: "translate(-269.175 -943.211)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3310",
    "data-name": "Path 3310",
    d: "M271.465,1054.094c-.158-1.761,1.1-4.323,1.786-6.478s.567-4.288,1.369-4.889a5.346,5.346,0,0,1,3.324,1c1.876,1.207,1.914,4.719,1.573,6.094s-.537,4.478-2.588,5.207-5.3.959-5.465-.938",
    transform: "translate(-224.267 -861.467)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3311",
    "data-name": "Path 3311",
    d: "M286.075,1021.989a3.064,3.064,0,0,1,1.24-2.461c.775-.81,1.586-1.081,3.039-2.541a2.432,2.432,0,0,1,3.986.818c.533,1.127.729,2.189-.87,4.086-1.334,1.584-2.344,2.72-3.738,2.86-1.377.141-4.028.019-3.657-2.762",
    transform: "translate(-236.319 -839.597)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3312",
    "data-name": "Path 3312",
    d: "M309.253,1001.226a3.707,3.707,0,0,1,2.537-2.021,39.527,39.527,0,0,0,7.166-3.11,1.733,1.733,0,0,1,1.176,1.859,8.2,8.2,0,0,1-1.9,3.608c-1.163,1.345-1.982,1.959-3.389,1.839-1.424-.124-2.958,1.217-4.05.548s-1.786-2.289-1.539-2.724",
    transform: "translate(-255.456 -822.952)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2728",
    "data-name": "Group 2728",
    transform: "translate(47.184 173.145)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2727",
    "data-name": "Group 2727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2726",
    "data-name": "Group 2726",
    clipPath: "url(#clip-path-164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3313",
    "data-name": "Path 3313",
    d: "M287.039,1001.563a8.2,8.2,0,0,0,1.9-3.608,1.733,1.733,0,0,0-1.176-1.859,39.524,39.524,0,0,1-7.166,3.11,6.647,6.647,0,0,0-1.019.441,2.378,2.378,0,0,0-1.279.695c-1.453,1.46-2.264,1.731-3.035,2.541a3.054,3.054,0,0,0-1.244,2.459c-.235,1.036-.349,2.4-.772,3.76-.682,2.155-1.944,4.717-1.786,6.477a1.346,1.346,0,0,0,.456.878,84.131,84.131,0,0,0,2.635-9.7c.388-2.713-.017-1.841,1.722-3.553s2.929-3.1,4.421-3.137,6.522-2.068,7.136-2.387c.515-.124.741,1.277-.861,3.954.026-.032.047-.049.068-.075",
    transform: "translate(-271.45 -996.096)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3314",
    "data-name": "Path 3314",
    d: "M268.919,1057.1c.09-1.765,1.7-4.131,2.664-6.164s1.168-4.171,2.042-4.655a5.326,5.326,0,0,1,3.146,1.458c1.7,1.45,1.245,4.941.72,6.249s-1.155,4.365-3.282,4.8-5.388.209-5.29-1.688",
    transform: "translate(-222.172 -864.414)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3315",
    "data-name": "Path 3315",
    d: "M293.8,1043.857a4.229,4.229,0,0,1,3.3-.354c1.833.354,5.328,1.26,7.763,1.215.69.571.358,1.965-.026,2.406a6.623,6.623,0,0,1-3.21,1.756,6.015,6.015,0,0,1-4.74-.621c-1.172-.767-2.618-.539-3.214-1.571s-.32-2.609.128-2.833",
    transform: "translate(-242.344 -861.99)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2731",
    "data-name": "Group 2731",
    transform: "translate(46.745 181.358)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2730",
    "data-name": "Group 2730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2729",
    "data-name": "Group 2729",
    clipPath: "url(#clip-path-165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3316",
    "data-name": "Path 3316",
    d: "M276.917,1043.5a4.213,4.213,0,0,0-3.291.354c-.873.484-1.074,2.617-2.042,4.655s-2.575,4.4-2.664,6.164a1.3,1.3,0,0,0,.294.874,9.341,9.341,0,0,1,1.33-3.79c1.735-3.227,2.319-5.84,2.822-6.63a3.416,3.416,0,0,1,2.86-1.11c1,.055,5.29,1.025,6.8,1.074s1.692-.036,1.795.516a2.441,2.441,0,0,1-.269,1.616c.494-.542.827-1.935.137-2.507-2.434.045-5.93-.861-7.771-1.215",
    transform: "translate(-268.919 -1043.347)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3317",
    "data-name": "Path 3317",
    d: "M284.382,1129c1.539-6.262,2.038-11,.2-14.762s-6.407-6.083-7.86-9.962-.477-5.333-3.287-6.5-5.631.584-4.855,2.911,2.038,8.436,3.977,15.316,4.365,14.638,5.525,16.488c1.164,1.833,5.473-.132,6.3-3.5",
    transform: "translate(-221.783 -906.653)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2734",
    "data-name": "Group 2734",
    transform: "translate(46.668 191.664)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2733",
    "data-name": "Group 2733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2732",
    "data-name": "Group 2732",
    clipPath: "url(#clip-path-166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3318",
    "data-name": "Path 3318",
    d: "M269.955,1107.59c-.371-1.407-1.057-2.971-.742-4.954a2.2,2.2,0,0,0-.61,2.375c.776,2.328,2.038,8.436,3.977,15.316s4.365,14.638,5.525,16.488a1.449,1.449,0,0,0,.4.392c-.328-3.6-1.636-12.665-3.572-16.855a122.841,122.841,0,0,1-4.974-12.762",
    transform: "translate(-268.478 -1102.637)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3319",
    "data-name": "Path 3319",
    d: "M1651.114,980.817c-2.336,3.436-3.679,9.956-4.373,10-2.281,2.547-13.172,2.355-12.738-1.731a61.512,61.512,0,0,1,2.315-12.528c1.778-5.559,18.061-.516,14.8,4.261",
    transform: "translate(-1349.964 -804.795)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3320",
    "data-name": "Path 3320",
    d: "M1645.09,931.313c1.083-3,3.649-8.51,7.728-11.469s12.306,8.479,10.269,11.74-5.192,3.254-6.462,5.985-9.617,0-10.542-.688-2.178-2.287-.993-5.567",
    transform: "translate(-1358.737 -759.552)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3321",
    "data-name": "Path 3321",
    d: "M1673.546,892.2c1.036-3.425,2.106-5.07,1.083-7.114s4.079-10.546,8.3-12.1,8.1-1.95,10.175-2.479,3.252-3.235,5.908-2.53,3.887,3.913,4.305,5.341,1.053,3.67-6.484,8.2c-3.662,2.2-11.032,8.323-15.87,12.2-4.663,3.738-8.129.865-7.417-1.516",
    transform: "translate(-1382.568 -717.003)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3322",
    "data-name": "Path 3322",
    d: "M1656.59,831.945c-1.645-3.589.405-7.794.746-10.258s2.8-5.981,3.849-8.724-.695-8.383-.579-9.913a1.737,1.737,0,0,1,2.259-1.528c1.4.264,3.116,1.543,4.591,4s-.418,4.052-.384,4.9a16.228,16.228,0,0,0,.639,4.887c.635,1.662,3.922,2.406,4.928,2.3s-1.457,6.134-5.2,10.18-9.638,6.793-10.853,4.152",
    transform: "translate(-1368.114 -662.156)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2737",
    "data-name": "Group 2737",
    transform: "translate(287.888 139.314)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2736",
    "data-name": "Group 2736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2735",
    "data-name": "Group 2735",
    clipPath: "url(#clip-path-167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3323",
    "data-name": "Path 3323",
    d: "M1666.8,817.88a11.985,11.985,0,0,1,1.765-.641,5.9,5.9,0,0,1-1.679-2.594c-.128-1.145-.665-3.4-.665-4.416a6.451,6.451,0,0,0,.409-4.02,10.642,10.642,0,0,0-3.21-4.192,1.887,1.887,0,0,0-1.922.546c-.311.528.354,3.977.567,5.825a17.732,17.732,0,0,1-.09,5.2c-.281,1.027-3.044,5.412-3.491,6.488s-.589,3.127-1.083,4.184a21.048,21.048,0,0,0-1.185,4.823c-.081-2.784,1.074-5.561,1.33-7.392.341-2.459,2.8-5.981,3.849-8.724s-.695-8.383-.58-9.913a1.737,1.737,0,0,1,2.259-1.528c1.4.264,3.116,1.543,4.591,4s-.417,4.052-.383,4.9a16.228,16.228,0,0,0,.639,4.887c.631,1.632,3.777,2.368,4.851,2.3a6.347,6.347,0,0,0,1.824-.29c-1.726.981-6.04.959-7.8.556",
    transform: "translate(-1656.209 -801.469)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2740",
    "data-name": "Group 2740",
    transform: "translate(287.844 139.314)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2739",
    "data-name": "Group 2739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2738",
    "data-name": "Group 2738",
    clipPath: "url(#clip-path-168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3324",
    "data-name": "Path 3324",
    d: "M1688.863,818.466c-.418-1.428-1.645-4.634-4.3-5.341s-3.829,2-5.909,2.53c-1.679.426-4.548.78-7.826,1.718-1.27-.335-2.711-1.012-3.112-2.061a16.221,16.221,0,0,1-.639-4.887c-.034-.853,1.867-2.451.384-4.9s-3.193-3.734-4.59-4a1.737,1.737,0,0,0-2.26,1.528c-.115,1.53,1.625,7.172.579,9.913s-3.508,6.264-3.849,8.724-2.391,6.669-.746,10.258c.558,1.2,2.085,1.277,3.948.627a40.372,40.372,0,0,1-1.446,4.776c-.712,2.381,2.754,5.254,7.417,1.516,4.838-3.879,12.209-10,15.87-12.2,7.536-4.525,6.91-6.778,6.484-8.2",
    transform: "translate(-1655.958 -801.469)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3325",
    "data-name": "Path 3325",
    d: "M1816.728,852.734c1.453-1,2.626-3.6,3.853-5.5s2.942-3.171,2.891-4.171a5.315,5.315,0,0,0-2.886-1.922c-2.127-.687-4.864,1.524-5.7,2.664s-3.112,3.27-2.361,5.314,2.634,4.687,4.208,3.613",
    transform: "translate(-1497.339 -694.827)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3326",
    "data-name": "Path 3326",
    d: "M1873.9,793.108a4.321,4.321,0,0,0,3.1-1.639,47.073,47.073,0,0,1,6.313-5.635A1.625,1.625,0,0,0,1882.1,784a8.974,8.974,0,0,0-4.318.42c-1.82.592-2.779,1.132-3.329,2.526s-2.536,2.349-2.412,3.64,1.33,2.579,1.863,2.517",
    transform: "translate(-1546.628 -647.637)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3327",
    "data-name": "Path 3327",
    d: "M1852.675,817.936c1.151-.271,1.552-1.149,2.281-1.995s1.36-1.609,2.673-3.2a3.108,3.108,0,0,0-1.027-4.616c-1.177-.418-2.869.3-4.6,2.074-1.449,1.473-2.033,2.511-2.033,3.9s.849,4.271,2.711,3.83",
    transform: "translate(-1528.397 -667.561)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2743",
    "data-name": "Group 2743",
    transform: "translate(315.032 137.224)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2742",
    "data-name": "Group 2742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2741",
    "data-name": "Group 2741",
    clipPath: "url(#clip-path-169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3328",
    "data-name": "Path 3328",
    d: "M1818.923,798.51c.089-1.262.665-2.261,2.016-3.64a6.928,6.928,0,0,1,3.393-2.129,4.041,4.041,0,0,0,.827-1.2,3.4,3.4,0,0,1,.482-.882c3.317-2.347,4.429-.757,2.826.471-1.731,1.332-3.832,4.371-5.776,7.1s-1.13,2.014-3.824,4.593a20.42,20.42,0,0,0-4.378,6.831,8.572,8.572,0,0,1-1.969-3.133c-.75-2.044,1.526-4.184,2.361-5.314a8.1,8.1,0,0,1,4.041-2.7",
    transform: "translate(-1812.37 -789.453)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3329",
    "data-name": "Path 3329",
    d: "M1826.466,855.5c1.445-1.27,2.528-4.2,3.7-6.386s2.869-3.792,2.775-4.843a4.917,4.917,0,0,0-3.082-1.607c-2.229-.411-4.945,2.33-5.751,3.658s-3.047,3.917-2.17,5.972,2.959,4.574,4.527,3.206",
    transform: "translate(-1505.078 -696.156)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3330",
    "data-name": "Path 3330",
    d: "M1875.213,765.215a5.106,5.106,0,0,0,1.275-3.619,52.466,52.466,0,0,1,.993-9.035,1.572,1.572,0,0,0-2.19-.394,10.654,10.654,0,0,0-3.04,3.672c-1,1.852-1.381,3-.836,4.444.529,1.443-.345,3.7.63,4.542s2.805.846,3.167.39",
    transform: "translate(-1545.913 -621.202)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3331",
    "data-name": "Path 3331",
    d: "M1860.121,812.62c1.045-.722,1.194-1.752,1.663-2.888s.865-2.131,1.7-4.225-.584-3.474-2.122-3.412c-1.292.056-3.077,1.281-4.267,3.725-1,2.038-1.573,3.144-1.172,4.532s2.476,3.435,4.194,2.267",
    transform: "translate(-1533.218 -662.672)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2746",
    "data-name": "Group 2746",
    transform: "translate(320.582 130.697)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2745",
    "data-name": "Group 2745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2744",
    "data-name": "Group 2744",
    clipPath: "url(#clip-path-170)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3332",
    "data-name": "Path 3332",
    d: "M1855.287,752.561a52.462,52.462,0,0,0-.993,9.035c-.021.349-.051.65-.09.927a3.02,3.02,0,0,1-.213,1.515c-.839,2.093-1.231,3.095-1.7,4.224a7.147,7.147,0,0,1-1.253,2.5c-.567.917-1.505,2.048-2.225,3.4-1.172,2.187-2.255,5.115-3.7,6.386a1.437,1.437,0,0,1-.805.349,58.951,58.951,0,0,1,6.338-10.736,23.292,23.292,0,0,0,2.891-7.588,60.446,60.446,0,0,1,.132-7.259c.307-2.031.473-2.619,0-2.637-.413-.01-3.176,2.119-4.394,4.881a13.541,13.541,0,0,1,.788-1.718,10.653,10.653,0,0,1,3.04-3.672,1.572,1.572,0,0,1,2.191.394",
    transform: "translate(-1844.302 -751.899)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3333",
    "data-name": "Path 3333",
    d: "M1822.4,856.545c1.138-1.357,1.556-4.186,2.225-6.341s1.974-3.856,1.663-4.8a5.334,5.334,0,0,0-3.3-1.064c-2.238-.081-4.276,2.786-4.774,4.109s-2.111,3.99-.835,5.757,3.815,3.8,5.021,2.342",
    transform: "translate(-1501.075 -697.571)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3334",
    "data-name": "Path 3334",
    d: "M1841.172,817.293a3.069,3.069,0,0,0,.384-2.728c-.179-1.108-.695-1.792-1.057-3.823a2.426,2.426,0,0,0-3.739-1.59c-1.082.627-1.846,1.381-1.611,3.852.187,2.061.375,3.57,1.437,4.478s3.307,2.308,4.586-.187",
    transform: "translate(-1516.122 -668.192)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3335",
    "data-name": "Path 3335",
    d: "M1828.121,778.274a3.714,3.714,0,0,0-.934-3.1,39.828,39.828,0,0,1-4.122-6.641,1.737,1.737,0,0,0-2.029.859,8.215,8.215,0,0,0-.49,4.045c.2,1.773.507,2.743,1.739,3.442s1.744,2.69,3.022,2.76,2.757-.863,2.814-1.366",
    transform: "translate(-1504.047 -634.86)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2749",
    "data-name": "Group 2749",
    transform: "translate(316.443 133.57)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2748",
    "data-name": "Group 2748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2747",
    "data-name": "Group 2747",
    clipPath: "url(#clip-path-171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3336",
    "data-name": "Path 3336",
    d: "M1820.546,773.437a8.214,8.214,0,0,1,.49-4.045,1.736,1.736,0,0,1,2.029-.859,39.833,39.833,0,0,0,4.122,6.641,6.829,6.829,0,0,1,.584.942,2.341,2.341,0,0,1,.653,1.292c.362,2.031.877,2.716,1.057,3.824a3.067,3.067,0,0,1-.384,2.728c-.4.987-1.078,2.166-1.5,3.534-.669,2.155-1.087,4.983-2.225,6.341a1.287,1.287,0,0,1-.869.454,85.866,85.866,0,0,1,3.35-9.466c1.227-2.455,1.07-1.5.609-3.9s-.639-4.22-1.841-5.094-4.194-5.418-4.514-6.031c-.354-.384-1.339.633-1.543,3.749a.464.464,0,0,0-.013-.1",
    transform: "translate(-1820.49 -768.43)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3337",
    "data-name": "Path 3337",
    d: "M1821.8,858.285c.934-1.5.955-4.356,1.326-6.582.354-2.227,1.415-4.09.972-4.987a5.3,5.3,0,0,0-3.414-.595c-2.221.226-3.845,3.35-4.152,4.725s-1.535,4.248-.034,5.821,4.3,3.233,5.3,1.618",
    transform: "translate(-1500.139 -699.012)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3338",
    "data-name": "Path 3338",
    d: "M1811.7,823.179a4.257,4.257,0,0,0-2.515-2.165c-1.705-.757-5.1-2-7.072-3.423-.891.077-1.419,1.411-1.347,1.993a6.568,6.568,0,0,0,1.637,3.265,6.04,6.04,0,0,0,4.254,2.2c1.394.03,2.46,1.042,3.534.533s1.748-1.963,1.509-2.4",
    transform: "translate(-1487.745 -675.475)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2752",
    "data-name": "Group 2752",
    transform: "translate(313.035 142.116)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2751",
    "data-name": "Group 2751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2750",
    "data-name": "Group 2750",
    clipPath: "url(#clip-path-172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3339",
    "data-name": "Path 3339",
    d: "M1809.283,821.015a4.255,4.255,0,0,1,2.515,2.165c.443.9-.618,2.76-.972,4.987-.371,2.225-.393,5.083-1.326,6.582a1.247,1.247,0,0,1-.724.548,9.182,9.182,0,0,0,1.044-3.873c.418-3.634,1.424-6.12,1.471-7.046a3.437,3.437,0,0,0-1.723-2.543c-.861-.526-4.932-2.172-6.2-2.988s-1.381-1-1.773-.595a2.409,2.409,0,0,0-.708,1.473c-.1-.724.43-2.057,1.321-2.133,1.97,1.422,5.367,2.666,7.072,3.423",
    transform: "translate(-1800.878 -817.592)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3340",
    "data-name": "Path 3340",
    d: "M1676.8,911.689c2.3-6.025,4.59-10.2,8.244-12.242s8.726-1.362,12.123-3.723,3.44-4.109,6.411-3.463,4.284,3.683,2.332,5.151-6.475,5.774-11.987,10.331-11.918,9.555-13.926,10.4-4.433-3.218-3.2-6.456",
    transform: "translate(-1385.058 -737.053)",
    fill: "#fcba8e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2755",
    "data-name": "Group 2755",
    transform: "translate(294.389 158.062)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2754",
    "data-name": "Group 2754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2753",
    "data-name": "Group 2753",
    clipPath: "url(#clip-path-173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3341",
    "data-name": "Path 3341",
    d: "M1717.489,912.982c1.108-.948,2.567-1.848,3.432-3.649a2.181,2.181,0,0,1-.848,2.3c-1.961,1.471-6.475,5.774-11.987,10.331s-11.919,9.555-13.927,10.4a1.382,1.382,0,0,1-.554.1c2.319-2.767,8.56-9.476,12.541-11.82a122.275,122.275,0,0,0,11.342-7.662",
    transform: "translate(-1693.606 -909.333)",
    fill: "#fff"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuggler);
export default __webpack_public_path__ + "static/media/juggler.e48d4121c2f240d1f5c9a93c35214ea9.svg";
export { ForwardRef as ReactComponent };